export default {
  en: {
    mainCurrency: 'Main Currency',
    mainLanguage: 'Main Language',
    market: 'Market',
    setMainCountry: 'Set Main Country',
    setMainCurrency: 'Set Main Currency',
    setMainLanguage: 'Set Main Language',
    redirectedTo: 'Redirected To',
    onlyVerifiedDomainInfo: 'Only verified domains can be connected',
    disconnectDomain: 'Disconnect Domain',
    connectDomain: 'Connect Domain',
    deleteDomain: 'Delete Domain',
    setMainDomain: 'Set Main Domain',
    disconnected: 'Disconnected',
    deleteScript: 'Delete Script',
    deactivateScript: 'Deactivate Script',
    activateScript: 'Activate Script',
    supportedCurrencies: 'Supported Currencies',
    supportedCountries: 'Supported Countries',
    supportedLanguages: 'Supported Languages',
    providerDisableInfo: 'Provider may have been disabled for the whole system',
    activity: 'Activity',
    verificationAnd: 'Verification (and)',
    verificationOr: 'Verification (or)',
    andDelimiter: 'and',
    currencyFrom: 'Currency From',
    currencyTo: 'Currency To',
    reverseRate: 'Reverse Rate',
    feature: 'Feature',
    otherTransactions: 'Other Transactions',
    playersNotifiedDate: 'Date Notified',
    depositProcessingType: 'Deposit Processing Type',
    withdrawalProcessingType: 'Withdrawal Processing Type',
    allowedActivities: 'Allowed Activities',
    depositSupportedCurrencies: 'Deposit Supported Currencies',
    withdrawalSupportedCurrencies: 'Withdrawal Supported Currencies',
    newFee: 'New Fee, %',
    feeBefore: 'Fee Before, %',
    newLimit: 'New Limit',
    statusDisabledInfo: 'Website will get unavailable from all domains.',
    statusActivitiesDisabledInfo: 'No new bets will be accepted.',
    statusVersionNamesDisabledInfo: 'Betting will be disabled for selected versions.',
    timezoneInfo: 'Any ongoing calculations related to time zone will get changed.',
    domainRedirection: 'Domain Redirection',
    uVerify: 'VERIFY',
    redirect: 'Redirect',
    forwardingURL: 'Forwarding URL',
    destinationURL: 'Destination URL',
    domainRedirectInfo: "The domain that is used as either forwarding or destination URL can't be deleted without deleting the existing rule.",
    registerDomainInfo: 'You need to register all your domains in your google account to enable captcha for all of them.',
    ageRestriction: 'Age Restriction',
    passwordPattern: 'Password Pattern',
    failedAttemptsPeriod: 'Failed Attempts Period',
    lockPeriod: 'Lock Period',
    passwordReminder: 'Password Reminder',
    inactivityPeriod: 'Inactivity Period',
    securityPeriod: 'Security Check Period',
    referralActivationPeriod: 'Referral Activation Period',
    passwordPatternNote:
      'It is recommended passwords to have minimum 8 characters including at least 1 number and 1 uppercase letter. However, you can weaken it up to having 6-20 Latin letters, numbers or special characters.',
    referralActivationPeriodNote: "Period for which you want to keep the referrer's ID information for a new registration on the website.",
    correspondingTranslations: 'Make sure all translations are correspondingly updated.',
    verificationCodeLength: 'Verification Code Length',
    dailyMobileVerification: 'Daily Mobile Verification Requests',
    emailRequestsInDaily: 'Daily Email Verification Requests',
    expirationMinutes: 'Token Expiration Period',
    expirationMinutesNote: 'Config defines the period after which the token (code, link) in the notification will become invalid.',
    emailRequestsInDailyNote: 'Config defines how many email requests for verification player can get in a day. Min value is {{value}}.',
    dailyMobileVerificationNote: 'Config defines how many SMS requests for verification player can get in a day. Min value is  {{value}}.',
    identityDocument: 'Identity Document',
    addressDocument: 'Address Document',
    additionalDocument: 'Additional Document',
    disableSportBook: 'Disable {{name}}',
    gameDisableTooltip: 'Game may have been disabled for the whole system',
    playerLimitInfo: {
      text1: 'You can set limit severity decrease period for each limit type.',
      text2:
        'Player-imposed limit changes, that make the current limits weaker, will get apply in accordance with this configuration. Exception: in case of access limit type any changes done by player and operator will work in the configured period.',
    },
    depositDecreaseLimit: 'Deposit Limit',
    betDecreaseLimit: 'Bet Limit',
    withdrawalDecreaseLimit: 'Withdrawal Limit',
    activateSportsbook: 'Activate Sportsbook',
    customScriptInfo: 'You can integrate new applications or add different functionalities to your website by adding custom scripts.',
    scriptName: 'Script Name',
    insideHead: 'Inside closing </head> tag',
    insideBody: 'Inside closing </body> tag',
    headTag: 'head tag script',
    bodyTag: 'body tag script',
    service: 'service',
    integrate: 'Integrate',
    showOnLive: 'Show on Live Website',
    showOnLiveTitle: "When you turn off this switcher the 3-rd party service's icon will be hidden from the home page of your website.",
    apiSecret: 'API Secret',
    apiSecretOrPass: 'API Secret or password',
    apiKeyOrUsername: 'API Key or username',
    sendEmailVia: 'Send Email Via',
    smtpUser: 'SMTP User',
    smtpPass: 'SMTP Password',
    useSSL: 'Use SSL',
    smtpHost: 'SMTP Host',
    smtpPort: 'SMTP Port',
    emailsInfo: {
      text1: 'For some SMTP providers it is required the same email to be registered on their end.',
      text2: 'Please, make sure the requirement is met.',
    },
    emailsInfo1: 'All scheduled messages with this email will be moved to draft',
    blockCountries: 'Block Countries',
    blockCountriesMainText: 'Website will get unavalilable from selected countries',
    versionControl: 'Version Control',
    policies: 'Policies',
    policy: 'Policy',
    dateToNotify: 'Date to Notify',
    featureName: 'Feature Name',
    createBrand: 'Create Brand',
    builder: 'Builder',
    platformState: 'Platform State',
    minMaxWithdrawalAmount: 'Min-Max System Withdrawal Amount',
    minWithdrawalAmount: 'Min. Withdrawal Amount',
    maxWithdrawalAmount: 'Max. Withdrawal Amount',
    minMaxDepositAmount: 'Min-Max System Deposit Amount',
    minDepositAmount: 'Min. Deposit Amount',
    maxDepositAmount: 'Max. Deposit Amount',
    operationFeePercent: 'Operation Fee, %',
    withdrawalFeePercent: 'Withdrawal Fee, %',
    withdrawalFee: 'Withdrawal Fee',
    withdrawalFeeForUsedBalancePercent: 'Withdrawal Fee For Used Balance, %',
    withdrawalFeeForUsedBalance: 'Withdrawal Fee For Used Balance',
    allowedConversion: 'Allowed Conversion',
    paymentMethodName: 'Payment Method Name',
    minAmount: 'Min {{title}} Amount',
    maxAmount: 'Max {{title}} Amount',
    minMaxSystemAmount: 'Min-Max System {{title}}  Amount',
    depositFeePercent: 'Deposit Fee, %',
    depositFee: 'Deposit Fee',
    allowConversion: 'Allow Conversion',
    previewLive: 'Preview Live',
    feeFromDeposit: 'Fee From Deposit',
    allowWithdrawalFromUnusedBalance: 'Allow Withdrawal From Unused Balance',
    allowWithdrawalFeeUsedBalance: 'Fee for Withdrawal will be held from the remaining balance.',
    feeCalculationForWithdrawals: 'Fee Calculation for Withdrawals',
    feeFromWithdrawals: 'Fee From Withdrawals',
    feeFromWithdrawalsUsedBalance: 'Fee From Withdrawals (Used Balance)',
    feeFromWithdrawalsBalance: 'Fee From Withdrawals ({{type}} Balance)',
    unusedBalanceInfo: "When activated, 'Unused' balance option will appear in 'Fee From Withdrawals' setting",
    paymentTransactionType: 'Payment Transaction Type',
    paymentMethodType: 'Payment Method Type',
    playerPaymentRelation: 'Player-Payment Relation',
    failedPaymentAttempts: 'Failed Payment Attempts',
    failedPaymentAttemptsPeriod: 'Failed Payment Attempts Period',
    temporaryBlockPeriod: 'Temporary Block Period',
    reverseConversion: '{{title}} Reverse Conversion',
    lCustomScript: 'custom script',
    largeTransactions: 'Large transactions',
    lBrand: 'brand',
    playerSettings: 'Player settings',
    verificationConfigurations: 'Verification configurations',
    theCurrency: 'The currency',
    mainCountry: 'Main Country',
    theLanguage: 'The language',
    smsSettings: 'SMS settings',
    verificationSettings: 'Verification settings',
    smtpSettings: 'SMTP settings',
    captchaSettings: 'Captcha settings',
    theEmail: 'The email',
    conversions: 'Conversions',
    theConversion: 'The conversion',
    theCountry: 'The country',
    playerVerificationSettings: 'Player verification settings',
    domainRedirectionRule: 'Domain redirection rule',
    wageringActivities: 'Wagering activities',
    theSportsBook: 'The Sportsbook',
    sportsBook: 'Sportsbook',
    theSportsBookView: 'The SportsBook view',
    setMainView: 'Set Main View',
    feeForWithdrawalsWillBeHeld: 'Fee for Withdrawal will be held from the remaining balance.',
    brandName: 'Brand Name',
    defaultCountry: 'Default Country',
    defaultLanguage: 'Default Language',
    defaultCurrency: 'Default Currency',
    products: 'Products',
    websiteTemplate: 'Website Template',
    failedPaymentInfo: 'Configurations are not available due to inactivity of "Failed Payments Procedure" standard. Please, activate it from the "Standards" section.',
    depositWithdrawalPaymentMethodInfo:
      "Payment methods using conversion will be affected in case of changes and custom min/max limits may be reset by the system if contradicting to new changes . Make sure to review the limits and the availability of currencies in the payment methods' settings.",
    otherPaymentMethodInfo: 'Internal functionalities using conversion will use these conversion rates. Make sure to have all conversions in place (e.g. Referral Bonus).',
    conversionSettingsInfo: 'The current limit contradicts system/system-converted limit.',
    card: 'Card',
    imageAlt: 'Image Alt',
    recommendedSize: 'Recommended size',
    stateOrRegion: 'State/Region',
    socialLinks: 'Social Links',
    socialLinkInfo: "Company's profile pages on different resources, such as Facebook, Twitter, Google+, Instagram, Youtube, LinkedIn, Wikipedia, etc. You can add as many URLs, as you wish.",
    image: 'Image',
    depositPaymentCategory: 'Deposit Payment Category',
    withdrawalPaymentCategory: 'Withdrawal Payment Category',
    createNewBrand: 'Create New Brand',
    lConversion: 'conversion',
    logInAllowed: 'Allow Login During Self-Exclusion',
    logInAllowedNote: 'When enabled, players can log in during Self-Exclusion, and make withdrawal only',
    schemaMarkupSettings: 'Schema Markup settings',
    accountId: 'Account ID',
    accountIdInfo: 'Any identification name or code associated with Service Account ID that provides a specific level of access',
    ranges: 'Ranges',
    depositAmountRanges: 'Deposit Amount Range (From - To)',
    taxPercentage: 'Tax Percentage %',
    lTaxes: 'taxes',
    withdrawalAmountRanges: 'Withdrawal Amount Range (From - To)',
    fixedAmountOrPercent: 'Fixed Amount or Tax Percentage',
    allowWithdrawalViaTheDepositedMethods: 'Allow withdrawal only via the deposited methods',
    allowWithdrawalViaTheDepositedMethodsInfo: 'Activating the setting restricts the player from withdrawing money via the brand methods he never deposited before',
    spotsBookJackpotDescription: 'When enabled Sports Jackpot Widget gets available on the Landing Page',
    multiBetOfTheDayDescription: 'When enabled Multi Bet of the Day Widget gets available on the Landing Page',
    sportSuperPromotionDescription: 'When enabled Super Promotions Widget gets available on the Landing Page',
    spotsBookPrematchTopMatchesDescription: 'When enabled Top Matches Widget gets available in the Iframe of Sportsbook and on the Landing Page',
    spotsBookScrollingTypeDescription: 'The setting is only applicable for Standard View and when enabled Sports page is wholly scrollable with one scroll',
    spotsBookTournamentBalanceDescription: 'When enabled the tournament balance gets available on the Website Homepage',
    sportJackpot: 'Sport Jackpot',
    multiBetOfTheDay: 'Multi Bet of the Day',
    sportSuperPromotion: 'Super Promotions',
    sectionsScrolling: 'Sections Scrolling',
    sportTournamentBalance: 'Sport Tournament Balance',
    iframe: 'Iframe',
    native: 'Native',
    sportsBookIframeIntegrationDescription: 'The sportsbook will be available in an inline frame',
    sportsBookNativeIntegrationDescription: 'The sportsbook will be available directly in a build in-app',
    sportsBookMobileIntegrationType: 'Integration Type on Mobile',
    setAsDefault: 'Set as default',
    configs: 'Configs',
    availableLayouts: 'Available Layouts',
    setAmountRangesInfo:
      "If for a range both 'Fixed Amount' and 'Tax Percentage' be set, the system should calculate the tax in the following way: withhold a fixed tax amount + the x percentage of the amount which exceeds the amount set in the 'From' field of the range.",
    depositAmountRangesHint: "The amount in the 'From' field of the 'Deposit Amount Range' is included in that range, whereas the amount in the 'To' field is not included in the range.",
    withdrawalAmountRangesHint: "The amount in the 'From' field of the 'Withdrawal Amount Range' is included in that range, whereas the amount in the 'To' field is not included in the range.",
    fixedAmountHint:
      "The amount in the 'Fixed Amount' field should be lower or equal to the amount entered in the 'From' field of the 'Deposit Amount Range'. If the amount 'From' is 0, the amount in the 'Fixed Amount' field also must be 0.",
    fixedAmount: 'Fixed Amount',
    brandSportsBookActivation:
      'By Sportsbook product activation you will get access to a customizable interface with live and pre-match events for 65+ sports. When activated the product can only be deactivated from Sportsbook admin panel.',
    amountFrom: 'Amount From',
    allowPlayerCompose: 'Allow Players to "Compose" Messages',
    sportsBookInheritWebsiteColor: 'Inherit Website Color',
    sportsBookInheritWebsiteColorDescription: 'The setting applies to all sports pages.',
    theBrand: 'The brand',
    taxSettings: 'Tax settings',
    infoUrlHint: 'This URL will be used on the website for displaying taxation details.',
    everyMatrixDescription: 'Modular and API driven iGaming solutions designed to unleash bold ideas',
    smarticoAffiliateDescription: 'There is no better way to connect with your customers',
    hotjarDescription: 'Understand how users are really experiencing your site without drowning in numbers',
    hotjarId: 'HotJar ID',
    googleAnalyticsId: 'Google Analytics ID',
    googleAnalyticsDescription: 'Analyze usage across your websites',
    googleSiteVerificationCode: 'Google site verification code',
    googleSearchConsoleDescription: "Get help to monitor, maintain, and troubleshoot your website's presence in search results on Google.",
    copyPasteFieldName: 'Copy your {{fieldName}} and paste it to the field below.',
    learnMore: 'Learn more…',
    affiliateInfo: '{{count}} integrations can not be active simultaneously',
    liveChatDescription: 'Online communication app that enables you and your website visitors to chat in real-time',
    liveAgentDescription: 'Provide excellent customer service',
    intercomDescription: 'Start great customer relationship here',
    zendeskDescription: 'Communicate with customers more efficiently',
    intercomId: 'Intercom ID',
    zendeskId: 'Zendesk ID',
    liveChatLicenseNumber: 'LiveChat LICENSE_NUMBER',
    liveAgentYourLa: 'LiveAgent YOUR-LA',
    liveAgentButtonID: 'LiveAgent button ID',
    digitainAgIdInfo: 'This is the ID of the Brand in the "Digitain Agent" admin panel',
    depositCurrencyInfo:
      'In case of players are allowed to make deposits with all the currencies supported with the payment methods, "Allow Conversion" with the supported currency configs should be active for the payment method.',
    pageGroups: 'Page Groups',
    digitainRetailInfo: "This is the ID of the Brand in the 'Digitain Retail' admin panel",
    smarticoDescription: 'The gamification solution that utilizes challenges and gaming techniques to motivate players',
    smarticoLabelKey: 'Label Key',
    brandKey: 'Brand Key',
    smarticoBrandKeyInfo: 'A public key for the brand',
    smarticoLabelKeyInfo: 'A public key for the label',
    smarticoNote: 'Smartico CRM and Gamification are interconnected, each action in this section has effect on Gamification as well',
    realityCheckPeriod: 'Reality Check Period',
    prematchTopMatches: 'Prematch Top Matches',
    prematchTotalTopMatches: 'Prematch Top Matches (Total Market Included)',
    spotsBookPrematchTotalTopMatchesDescription: 'When enabled Prematch Top Matches Widget with Total Market Data gets available',
    livePrematchTopMatches: 'Live & Prematch Top Matches',
    spotsBookLivePrematchTopMatchesDescription: 'When enabled Live & Prematch Top Matches Widget gets available',
    liveTopMatches: 'Live Top Matches',
    spotsBookLiveTopMatchesDescription: 'When enabled Live Top Matches Widget gets available',
    periodCalculationSource: 'Period Calculation Source',
    periodCalculationSourceInfo: 'Select the date source on which the calculation of the verification period will start',
    verificationPeriod: 'Verification period',
    verificationPeriodInfo: ' The number of days a player account can be active before verification',
    unverifiedPlayersExclusionsInfo:
      "In cases when a payment method is selected in 'Payments Ignoring Deposit Verification' menu and limits are set in 'Max Deposit Amounts' part, the limits will not affect on that payment method.",
    responsibleGamingPeriodLimitsInfo: 'In this section you  can set a specific time period that a player can choose for time out and self-exclusion.',
    preferencesDescription: 'Activating/ deactivating SMS, Email and Push Notifications for players.',
    preferencesSMSDescription: 'SMS sending for all the players of the brand and on the website Via SMS part should become invisible',
    preferencesEmailDescription: 'E-mail sending for all the players of the brand and on the website Via E-mail part should become invisible',
    walletsSettings: 'Wallets Settings',
    wallets: 'Wallets',
    features: 'Features',
    dda: 'DDA',
    ddaInfo: 'Activating this option the taxes on the withdrawal will be withheld in the DDA logic',
    whatsAppDescription: 'Let your customers contact you using the most popular messenger in the world.',
    phoneNumber: 'Phone Number',
    whatsAppPhoneNumberInfo: 'Enter the phone number with which your WhatsApp account is registered',
    multiGameLaunch: 'Multi-Game launch',
    multiGameLaunchDescription: 'Depending on the configuration, the multi-game option is available on the website and players are able to play multiple games simultaneously.',
    jackpotWidget: 'Jackpot Widget',
    jackpotWidgetDescription: 'Refers to Casino Jackpot Widget activation for Landing Page. Available for Amusnet Provider Jackpot Widget.',
    gameIframe: 'Game Iframe',
    manuBarFixation: 'Menu Bar Fixation',
    manuBarFixationDescription: 'Only for mobile view, depending on the configuration Main Bar is fixed for the lobbies.',
    paymentVisibilityInfo: 'In this section, you can hide and not allow payment method usage for players who have one of the selected tags',
    centrivoConnectAgDescription: "Transform Your iGaming Business with Centrivo's Connect Agent Solution",
    retailCentrivoDescription: "Transform Your iGaming Business with Centrivo's Retail Solution",
    currencySymbol: 'Currency Symbol',
    preferencesPushNotificationsDescription: 'Push Notifications channel will become available for sending notifications for the Brand',
    currencyFormat: 'Currency Format',
    currencyFormatInfo: 'Which Currency format to show on the website for the players.',
    isoCode: 'ISO Code',
    symbols: 'Symbols',
    digitainCrmDescription: 'CRM solution designed to maintain the engagement of existing players and enhance their overall satisfaction',
    accessDecreaseLimit: 'Access Limit',
    depositOnNegativeBalance: 'Deposit on Negative Balance',
    depositOnNegativeBalanceInfo: "After the deposit approval the adjustment will be done to the player's negative wallet for closing the debt.",
    digitainAffiliateDescription: 'Activate your affiliate program and experience a significant boost in your website traffic.',
    projectId: 'Project ID',
    projectIdInfo: 'This is the ID of the Project in the "Digitain Affiliate" admin panel',
    brandIdInfo: 'This is the ID of the Brand in the "Digitain Affiliate" admin panel',
    maintenanceSetup: 'Maintenance setup',
    maintenancePeriod: 'Maintenance Period',
    sportsBookViews: 'Sportsbook Views',
    mandatoryNotification: 'Mandatory Notification',
    mandatoryNotificationInfo: 'A mandatory pop-up for logged in players on the website',
    lossDecreaseLimit: 'Loss Limit',
    inactivityIndicators: 'Inactivity Indicators',
    inactivityIndicatorsInfo:
      "This configuration will consider as an inactive player based on one of several indicators, the player's last login date or last transactions(bet, deposit, withdrawal) date",
    recoverByPlayer: 'Recover By Player',
    recoverByPlayerInfo: 'When enabled, players can recover themself through the verification code',
    singleBetDecreaseLimit: 'Single Bet Limit',
    cashierType: 'Cashier Type',
    lIcon: 'icon',
    gameLaunchType: 'Game Launch Type (Mobile view)',
    gameFullScreenLaunchDescription: 'Game open with iframe in full screen',
    gameHeaderFooterLaunchDescription: 'Games open with iframe and header and footer',
    gameQuickActionBarLaunchDescription: 'Games open with quick actions bar',
    limitEffectConfigs: 'Limit Effect Configs',
    ignoreFirstDeposit: 'Ignore First Deposit',
    ignoreFirstDepositHint: "If this option is selected the player's first lifetime successful deposit will not be calculated in the responsible gaming deposit limit",
    periodLimit: 'Period Limit',
    playerLimitsConfiguration: 'Player Limits configuration',
    alanbaseDescription: 'A platform brought to you by experts in iGaming and affiliate marketing helping other experts to optimize their costs and boost their profits.',
    routForEvents: 'Rout for Events',
    routForGoals: 'Rout for Goals',
    fastDepositPaymentMethod: 'Fast Deposit Payment Method',
    fastDepositPaymentMethodInfo:
      "Fast Deposit is a functionality on the website through which the players are able to make a deposit without leaving the game page by the payment method predefined from 'Centrivo'.",
    sportStatusIconsInfo: "Uploaded icons will be visible in the player's profile on the website. Each uploaded icon will be reflected on the website after no more than one hour.",
    rolloverBetsReturn: 'Rollover Bets Return to Same Wallet',
    rolloverBetsReturnInfo: 'In cases when the bet made from the rollover balance is returned/cancelled the amount will be transferred to rollover balance',
    maxDepositAmounts: 'Max Deposit Amounts',
    paymentsIgnoringDepositVerification: 'Payments Ignoring Deposit Verification',
    selfExclusion: 'Self-Exclusion',
    timeOut: 'Time-Out',
    configureLimits: 'Configure Limits',
    metaMapDesc: 'Everything you need to verify your customers in a single platform',
    clientId: 'Client ID',
    clientIdInfo: 'Used to identify you as a merchant.',
    clientSecret: 'Client Secret',
    clientSecretInfo: 'Use client_secret taken from the Dashboard as your password.',
    pushGameState: 'Push Game State',
    pushGameStateDescription: 'This setup defines the state of the games ("Game State") sent by the aggregator to the Back Office.',
    thunderBiteDescription: 'Gamify the customer experience and turn engagement into loyalty.',
    campaignURL: 'Campaign URL',
    captchaCaseInsensitiveInfo: 'By enabling the option for the captcha, the system does not distinguish between uppercase and lowercase letters, which are considered identical.',
    caseInsensitive: 'Case Insensitive',
    verificationRequestPeriod: 'SMS/Email Verification Request Period',
    verificationRequestPeriodInfo: 'Config defines when the next SMS/Email verification request will be sent to the player',
    sec: 'sec',
    integratedDate: 'Integrated Date',
    integratedBy: 'Integrated By',
    isInvisible: 'Is Invisible',
    captchaInvisibleInfo: 'If checked, the captcha will not be visible to players',
    captchaLogonAttemptsInfo: 'Define the number of failed login attempts, the period for counting these attempts, and the duration for which CAPTCHA will appear.',
    jackpot: 'Jackpot',
    globalState: 'Global State',
    jackpotGames: 'Jackpot Games',
    myAffiliatesDescription: 'The most flexible affiliate tracking software on the market',
    sportDomainsTabInfo: 'Max sport domain count is {{count}}. Only active domains can be set as Main. Only verified domains can be connected.',
    firebaseAuthenticationDescription: 'Configure social media platforms for user sign-up and sign-in authentication with Firebase.',
    frontend: 'Frontend',
    backend: 'Backend',
    google: 'Google',
    facebook: 'Facebook',
    socialMediaPlatforms: 'Social Media Platforms',
    optimoveDescription: 'CRM solution designed to maintain the engagement of existing players and enhance their overall satisfaction.',
    baseUrl: 'Base URL',
    forcePasswordChangeNote:
      'By enabling the option, players must change passwords if the set period is passed.\nWhen the Password Reminder period is passed, players cannot log in to the website without changing their password if the option is enabled.',
    forcePasswordChange: 'Force Password Change',
    playerTags: 'Player Tags',
    additional: 'Additional',
    gameTimeLimit: 'Game Time Limit',
    verificationOptions: 'Verification Options',
    blockActions: 'Block Actions',
    userNotification: 'User Notification',
    winAmounts: 'Win Amounts',
    largeWinTransactionNotification:
      'The Large Win transaction notification will be sent only to selected users. Ensure that the Win amount is configured for all currencies in case of any users are selected.',
    promptOnLogin: 'Prompt on Login',
    promptOnLoginInfo: 'By selecting this option, players will be required to set their limits during their first login',
    productCategory: 'Product Category',
    betProfitRange: 'Bet Profit Range (From - To)',
    betProfitRangeHint: "The amount in the 'From' field of the 'Bet Profit Range' is included in that range, whereas the amount in the 'To' field is not included in the range.",
    betTaxInfo: "A single 'Product Category' can be assigned to either the 'Cumulative' or 'Per Transaction' taxation type, based on the preferred tax calculation method.",
    betTaxStandardDisabledInfo: "Activate 'Taxation' and 'Tax on Bets Profit' to enable the tax engine for your brand.",
    depositTaxStandardDisabledInfo: "Activate 'Taxation' and 'Tax on Deposit' to enable the tax engine for your brand.",
    withdrawalTaxStandardDisabledInfo: "Activate 'Taxation' and 'Tax on Withdrawal' to enable the tax engine for your brand.",
    registrationUniqueness: 'Registration Uniqueness',
    registrationUniquenessNote: 'The uniqueness of the selected combination should be validated during player registration.',
    responsibleGamingLimitsInfo:
      'In this section you can set predefined values which will auto-fill as default limits during setup but can be manually adjusted.Prompt on login can be enabled/disabled which will require players to set the limit.',
    hours: '{{number}} hours',
    days: '{{number}} days',
    month: '{{number}} month',
    year: '{{number}} year',
    viewDefaultAmount: 'View Default Amount',
    viewDefaultLimit: 'View Default Limit',
    realTimeUniquenessCheck: 'Real-Time Uniqueness Check',
    realTimeUniquenessCheckNote: 'By enabling this, the system will instantly check the Mobile Number, ID, and Email for uniqueness, during the registration process.',
    appToken: 'App Token',
    accountVerificationOptions: 'Account Verification Options',
    accountVerificationOptionsInfo: 'Select the options based on which the player’s account will be considered as verified',
    markAsUnverified: 'Mark As Unverified',
    markAsUnverifiedInfo: 'When enabled, players will be marked as unverified based on the set rules',
    verificationPeriodTabInfo: {
      text1: 'In this section, you can set rules to automatically block unverified players after a specific period.',
      text2:
        "Players are considered unverified if they haven't completed the required verification steps, which are defined in the Verification Configuration section. Players who pass the selected verification will be considered as verified. By not verifying, the players will be marked as blocked for unverified.",
    },
    notificationReminder: 'Notification Reminder',
    notificationReminderInfo: 'The number of days after which the player will be reminded to verify the account',
    blockForUnVerify: 'Block For Unverify',
    blockForUnVerifyOptions: 'Block For Unverify Options',
    betOddsLimit: 'Bet Odds Limit',
    betOddsLimitInfo:
      'In cases when the bet is made with the odds lower than the specified one, the won amount will be distributed proportionally between the wallets (used and unused), where the bet was made',
    selfExclusionReason: 'Self-Exclusion Reason',
    selfExclusionReasonInfo: "If the reason is selected the player's cannot set a self exclusion on the account by selecting the specified reasons",
    balanceVisibility: 'Balance Visibility',
    balanceVisibilityNote: 'Selected balances will be visible to the brand players.',
    configured: 'Configured',
    limitEffectPeriodInfo:
      'Changes take effect either after a set time (immediately, 24 hours, 48 hours, or 7 days), or at the start of the next calendar period — midnight for daily limits, Monday for weekly limits, or the 1st of the month for monthly limits.',
    documentsConfig: 'Documents Config',
    documentsConfigInfo: 'The following types of documents required page count is always 1',
    pageCount: 'Page Count',
    realityCheckSettings: 'Reality Check Settings',
    calculationType: 'Calculation Type',
    realityCheckInterval: 'Reality Check Interval',
    showLogOutButton: 'Show Log Out Button',
    realityCheckSettingsInfo: 'The configurations will only apply if Reality Check is enabled in the Standards section',
    realityCheckStatus: 'Reality Check Status',
    realityCheckPeriodInfo: "These periods will appear in the player's account on the website",
    realityCheckIntervalInfo: 'Defines the time interval between Reality Check popup shown to the players',
    capitalizePlayerData: 'Capitalize Player Data',
    capitalizePlayerDataInfo: 'By enabling this, the system will capitalize First/Last Names, Address, and City fields during the registration process and save it in backoffice',
    blockedCountriesInfo:
      'The action (unblock, full block, block for login, block for registration, block for login and registration) can be applied individually per country or by bulk, updating their state at once.',
    bulkAction: 'Bulk Action',
    multiPeriodLimitType: 'Multi Period Limit Type',
    singlePeriodLimitType: 'Single Period Limit Type',
    changeEffectPeriods: 'Change Effect Periods',
    lastMonthPeriod: 'Last Month Period',
    eddVerificationNotification: 'EDD configurations will trigger Source of Funds verification for Qualified Players',
    totalDepositAmount: 'Total Deposit Amount',
    schemaMarkupImage: 'Schema Markup Image',
    dataSendPeriod: 'Data Send Period',
    demoLaunchDesktop: 'Demo Launch (Desktop)',
    demoLaunchMobile: 'Demo Launch (Mobile)',
    demoLaunchDesktopDescription: 'Depending on the configuration, the demo button is available on games and players are able to launch game demo version on Desktop view.',
    demoLaunchMobileDescription: 'Depending on the configuration, the demo button is available on games and players are able to launch game demo version on Mobile view.',
    androidSettings: 'Android Settings',
    iosSettings: 'iOS Settings',
    googleCloudProjectId: 'Google Cloud Project ID',
    mobileReCaptcha: 'Mobile reCAPTCHA',
    androidReCaptchaKey: 'Android reCAPTCHA Key',
    androidKeyId: 'Android Key ID',
    iosReCaptchaKey: 'iOS reCAPTCHA Key',
    iosKeyId: 'iOS Key ID',
    playerApproval: 'Player Approval',
    playerApprovalInfo: 'Requires player confirmation before applying the new, weaker limit after the change effect period',
    transactionTypeNote: 'Selected types will be visible to the brand’s players in their Cashier on the website.',
    domainDeletion: 'Domain Deletion',
    incomeAccessDescription: 'Join the longest serving iGaming affiliate marketing network',
    firstSuccessfulDeposit: 'First Successful Deposit',
    firstSuccessfulDepositDesc: 'Players should have at least one successful deposit to be eligible to activate the bonuses',
    sportStatusDesc: 'Players with the selected statuses are eligible to activate the received bonuses',
    brandBonusesInfo: 'This section lets users set up the bonus activation logic for the brand based on specific conditions. If any condition is not met, the bonus will not be activated.',
    failedLogonPasswordAttempts: 'Failed Logon/Password Recovery Attempts',
    itsMeAuthenticationDescription: 'Itsme® is a secure digital ID app for logging in, paying, and signing.',
    projectName: 'Project Name',
    nationalities: 'Nationalities',
    mainNationality: 'Main Nationality',
    setMainNationality: 'Set Main Nationality',
    playerLimitConfigModalInfo:
      'In this section, you can set the default values and predefined values for the limit. By providing and/or updating the Default Amounts for the limit, it will be set for all players for registration. The suggested values should be available during player login, but can be manually adjusted.',
    playerLimitRequiredOnLogin: 'Required on Login',
    playerLimitRequiredOnLoginHint: 'Enabling the option will require players to set a limit on login',
    suggestedAmounts: 'Suggested Amounts',
    defaultAmount: 'Default Amount',
    viewLimits: 'View limits',
    configureAmounts: 'Configure Amounts',
    suggested: 'Suggested',
    otherTypeDocumentConfigInfo:
      'For all types except <0>Other</0>, the selected number of files is required. For <0>Other</0>, the selected number is the maximum allowed, fewer files are permitted.',
    uploadReCaptchaInfo: 'You can upload a valid JSON file for ReCaptcha configuration',
    androidPrivateKey: 'Android Private Key',
    iosPrivateKey: 'iOS Private Key',
    indefiniteTimePeriod: 'Indefinite Time Period',
    sportMinBetAge: 'Sport Min. Betting Age',
    casinoMinBetAge: 'Casino Min. Betting Age',
    zingBrainDesc: 'ZingBrain is an easy to integrate performance improvement platform for the iGaming industry.',
    awsCloudDescription: 'Configure AWS to enable data uploads.',
    zingBrandDescription: 'Integrate ZingBrain to enable AI-powered lobby content recommendations configuration.',
    regionName: 'Region Name',
    endpointUrl: 'Endpoint URL',
    accessKeyId: 'Access Key ID',
    secretAccessKey: 'Secret Access Key',
    bucketName: 'Bucket Name',
    apiUserName: 'API Username',
    apiPassword: 'API Password',
    zingBrandId: 'ZingBrand ID',
    configuredDate: 'Configured Date',
    configuredBy: 'Configured By',
    standardTaxModel: 'Standard Tax Model',
    standardTaxModelInfo: 'Calculates the tax on the deposit made, by applying the mentioned Tax % on the total amount.',
    vatTaxModel: 'VAT Tax Model',
    vatTaxModelInfo: 'Calculates the tax on the deposit made, by applying the mentioned VAT % on the total amount by VAT formula.',
    setVatAmountRangesInfo: 'Total deposit amount includes VAT. The system automatically separates the VAT portion from the total to calculate the actual deposit value.',
    realityCheckConfiguration: 'Reality Check Configuration',
    typeOfTaxation: 'Type of Taxation',
    ghanaRegulationDesc: 'Player verification through Gaming Commission of Ghana',
    merchantKey: 'Merchant Key',
    onlyOneKycInfo: 'Only one KYC can run at a time.',
    crmFeatures: 'CRM Features',
    loyaltyProgram: 'Loyalty Program',
    activationMinimumAmount: 'Activation Minimum Amount',
    activationMinimumAmountDesc: 'Players should have at least the mentioned amount in their wallets to be able to activate the bonus',
    authentigateDescription:
      'Authentigate is your all-in-one solution for most popular Baltic eID authentication. Connect Smart-ID, Mobile-ID, eParaksts mobile, and Estonian ID card through one secure gateway.',
    betStatusCorrectionsNotification: 'Defining limits and confirmation requirements for operators, allowing them to approve or cancel the limit exceeding action',
    trustlyDescription: 'Trustly Pay and Play gives players a quick, seamless onboarding flow that combines deposits, user verification and account creation.',
    trustlyNote: 'Pay and Play must be configured first in the Paydrom Page before enabling this option.',
    relumActivation: 'By activating the Relum product, you gain access to multiple games various premium game providers, allowing you to create a personalized gaming experience for your players.',
    sportsBookActivation:
      'By Sportsbook product activation you will get access to a comprehensive multi-lingual, multi-currency, customizable interface with live and pre-match events for different sports, with the leagues worldwide and huge number of betting markets.',
    domain: 'Domain',
    whiteIps: 'White IPs',
    hasOptionalComment: 'Optional Comment',
    hasOptionalCommentInfo: 'Make the Comment field optional when selecting a reason during self-exclusion setup.',
    becomeDigitalDesc: 'Identity verification, fraud prevention, and digital conversion all on one platform',
    clientKey: 'Client Key',
    contractId: 'Contract ID',
    addCountry: 'Add Country',
    trustedCountry: 'Trusted Country',
    changeStatus: 'Change Status',
    defaultLimitAutoApply: 'Default Limit Auto-Apply',
    defaultLimitAutoApplyHint: 'Limits that are below or equal to the default are applied immediately and ignore other settings',
    realTimeEvents: 'Real Time Events',
    kycAidDesc: 'KYCAID is an all-in-one solution for automated identity and document verification.',
    apiToken: 'API Token',
    formId: 'Form ID',
    overridePlayerData: 'Override Player Data',
    overrideAddress: 'Override Address',
    overridePlayerDataInfo:
      'This setting determines whether the data received from KYCAID after a successful verification will overwrite the player’s existing information, including First Name, Last Name, Document Number, and Date of Birth',
    overrideAddressInfo: 'This setting determines whether the address data received from KYCAID after a successful verification will overwrite the player’s existing address information.',
    googleAdsDescription: 'This integration allows you to automatically send offline conversion data.',
    developerToken: 'Developer Token',
    developerTokenInfo: 'Google Ads Manager Account Developer Token',
    googleCloudConsoleClientIdInfo: 'Google Cloud Console - OAuth 2.0 Client Id',
    secretKeyInfo: 'Google Cloud Console - OAuth 2.0 Secret Key',
    attributionPeriod: 'Attribution Period',
    attributionPeriodInfo: 'Determines how long FTD/Deposit events are sent for a GCLID after registration. Min: 1 day, Max: 60 days.',
    conversion: 'Conversion',
    customerId: 'Customer ID',
    theMobileCode: 'The Mobile Code',
    mobileCodes: 'Mobile Codes',
    code: 'Code',
    mobileCode: 'Mobile Code',
    configureTrustlyInfo: 'You can add up to 4 amounts',
    combinedWidget: 'Combined Widget',
    validationContractId: 'Validation Contract ID',
    unicoDesc: 'Identity verification, fraud prevention, and digital conversion all on one platform.',
    balanceAdjustmentsNotification: 'Defining limits and confirmation requirements for operators, allowing them to approve or cancel the limit exceeding action',
    betStatusCorrections: 'Bet Status Corrections',
    bonusGrantingNotification: 'Defining limits and confirmation requirements for operators, allowing them to approve or cancel the limit exceeding action.',
    grantBonuses: 'Grant Bonuses',
    operationalLimits: 'Operational Limits',
    allowManualKycVerification: 'Allow Manual Identity KYC Verification',
    allowManualKycVerificationInfo: 'Allow Players/Operator to upload Identity documents manually when a 3rd-party provider is enabled',
    isRefundable: 'Is Refundable',
    reopenApplicationForReview: 'Reopen application for review',
    verifyOnLogin: 'Verify on Login',
    verifyOnLoginInfo: 'When enabled, players will be prompted to verify their email and/or mobile immediately after logging in.',
    enableEmailVerifyViaLinkOnLogin: 'Email Verification via Link',
    allowWithdrawalCancel: 'Allow Withdrawal Cancel',
    allowWithdrawalCancelInfo: 'When disabled, players cannot cancel pending withdrawals.',
    verificationMethodExclusion: 'Verification Method Exclusion',
    verificationMethodExclusionDesc:
      'Select verification methods to exclude from EDD triggering. Players verified using the selected methods will bypass this EDD rule, while players verified through non-selected methods will remain subject thresholds',
    blockActionsDesc: 'Select which actions will be blocked once the EDD amount threshold is reached within the configured time period',
    telegramSettings: 'Telegram settings',
    activateTelegram: 'Activate Telegram',
    otpMethod: 'OTP Method',
    amlContractId: 'AML Contract ID',
    callType: 'Call Type',
    gamStopLogs: 'Gamstop Logs',
    gamStopDesc: 'UKGC self-exclusion checks via Gamstop single and batch APIs.',
    enablePreferencesPerProduct: 'Preferences per-product',
    enablePreferencesPerProductInfo: 'When enabled, players can set separate notification preferences per product for Newsletters, Promotions and Bonuses. Deposits and Withdrawals are not affected.',
    autoDeposit: 'Auto Deposit',
    autoDepositInfo: 'Auto Deposit amount must be within the configured deposit amount range.',
    frequency: 'Frequency',
    frequencyInfo: 'Define the allowed frequency range for Auto Deposit activation. Players can select Auto Deposit frequency only within the configured minimum and maximum number of days.',
    retryCount: 'Retry Count',
    retryCountInfo: 'If the payment fails, the system will try again every 24 hours until the configured retry limit is reached.',
    disableAutoDeposit: 'Turn Off Auto Deposit',
    enabledDate: 'Enabled Date',
    linkedCard: 'Linked Card',
    nextExecutionDate: 'Next Execution Date',
    lastAutoDepositDate: 'Last Auto Deposit Date',
    successfulAutoDepositCount: 'Successful Auto Deposit Count',
    retryCountCurrentCycle: 'Retry Count (current cycle)',
    failedAutoDeposits: 'Failed Auto Deposits',
    ageBasedLimitsInfo:
      'Configure Maximum Deposit Limits by operator-defined Age Groups and per-currency amounts. If an age-based maximum limit is equal to or lower than the configured Default Limit, it is applied as the default limit. Players cannot increase the limit beyond the configured maximum, but they can choose to set a lower limit.',
    setAgeBasedLimits: 'Set Age Based Limits',
    ageRange: 'Age Range',
    netDepositLimit: 'Net Deposit Limit',
    ageFrom: 'Age From',
    ageTo: 'Age To',
    magicLinkSettings: 'Magic Link Settings',
    magicLinkChannels: 'Magic Link Channels',
    whatsAppSettings: 'WhatsApp Settings',
    phoneNumberId: 'Phone Number ID',
    accessToken: 'Access Token',
    wabaId: 'WABA ID',
    magicLinkForLogin: 'Magic Link for Login',
    magicLinkTabInfo:
      'Enable passwordless login via Magic Link. Select the channels through which Magic Links can be delivered. A channel will work only if it is already configured for the brand in Notification Settings.',
    showReferralLink: 'Show Referral Link',
    inviteChannels: 'Invite Channels',
    inviteLimit: 'Invite Limit',
    inviteLimitInfo: 'Max SMS/email invites a player can send per day.',
    selectedTemplateWasDeletedOrDisabled: 'Selected template was deleted or disabled',
    coolingOff: 'Cooling Off',
    coolingOffInfo: 'When enabled, expired Self-Exclusions remain active until removed by an operator. Selecting Period = None schedules the Self-Exclusion for automatic removal after 24 hours.',
    wageringContributionPercent: 'Wagering Contribution, %',
    brandBonusSettingsInfo: 'Default wagering contribution % per category will be used during Bonus Wagering configuration as default values.',
    relative: 'Relative',
    entireAmount: 'Entire Amount',
    gbgDesc: 'GBG identity verification, document checks, AML screening, and financial vulnerability checks.',
    registration: 'Registration',
    journeyId: 'Journey ID',
    monitoringDuration: 'Monitoring Duration',
    lastCallPeriod: 'Last Call Period',
    serverSideDelivery: 'Server-Side Delivery',
    serverSideDeliveryInfo: "When on, backend-finalized events such as deposits are sent to GA4 directly from the server, so they count even if the player's app or browser is closed",
    measurementId: 'Measurement ID',
    exportCenterSettings: 'Export Center Settings',
    exportCenterSettingsInfo:
      'Export Center lets players generate and download their account data for a selected period; configure whether it is enabled, the available period, and the report types players can export.',
    reportTypes: 'Report Types',
    interval: 'Interval',
    intervalInfo: 'The look-back window, in calendar days, players can select an export period from.',
    durationInfo: 'The maximum length, in calendar days, of a custom date range a player can select.',
    exportCenterInfo: 'Enables the player Export Center so players can generate and download their account data.',
    setCategoryAgeBasedLimitsTitle: 'Age-Based Maximum Limits by Game Categories',
    setCategoryAgeBasedLimitsInfo:
      'Configure Maximum Single Bet Limits by operator-defined Game Category Groups, Age Groups, and currencies. Each limit applies to the selected game categories and player age range in the specified currency. These limits are enforced as maximum limits and are not directly visible or configurable by players.',
    addAgeRange: 'Add Age Range',
    setCategoryAgeBasedLimits: 'Set Category and Age Based Limits',
    categoryBasedLimitsInfo: 'Selected game categories will be excluded from the category list when creating the next group',
    documentUploadNotifications: 'Document Upload Notifications',
    pendingDocumentVerificationInfo:
      'Configure notifications to inform operators when a player uploads a document for verification. Notifications are sent only for documents in Pending status and include all document types.',
    calculationTypeInfo: 'Sets how casino win tax is applied across the existing tax ranges. Relative taxes each portion of the win at the rate of the range it falls into; Entire amount taxes the full win at the rate of the range it falls into.',
    documentVerification: 'Document Verification',
    flowId: 'Flow ID',
  },
  es: {
    mainCurrency: 'Moneda principal',
    mainLanguage: 'Idioma principal',
    market: 'Mercado',
    setMainCountry: 'Establecer país principal',
    setMainCurrency: 'Establecer moneda principal',
    setMainLanguage: 'Establecer idioma principal',
    redirectedTo: 'Redirigido a',
    onlyVerifiedDomainInfo: 'Solo se puede conectar servidores verificados',
    disconnectDomain: 'Desconectar dominio',
    connectDomain: 'Conectar dominio',
    deleteDomain: 'Eliminar dominio',
    deleteScript: 'Eliminar script',
    deactivateScript: 'Desactivar script',
    activateScript: 'Activar script',
    supportedCurrencies: 'Monedas admitidas',
    supportedCountries: 'Países admitidos',
    supportedLanguages: 'Idiomas admitidos',
    providerDisableInfo: 'Puede que el proveedor haya sido desactivado en todo el sistema',
    activity: 'Actividad',
    verificationAnd: 'Verificación (y)',
    verificationOr: 'Verificación (o)',
    andDelimiter: 'y',
    currencyFrom: 'Moneda desde',
    currencyTo: 'Moneda hacia',
    reverseRate: 'Tarifa inversa',
    feature: 'Función',
    otherTransactions: 'Otras transacciones',
    playersNotifiedDate: 'Fecha de notificación',
    depositProcessingType: 'Tipo de procesamiento de depósitos',
    withdrawalProcessingType: 'Tipo de procesamiento de retiros',
    allowedActivities: 'Actividades permitidas',
    depositSupportedCurrencies: 'Monedas admitidas para el depósito',
    withdrawalSupportedCurrencies: 'Monedas admitidas para la retirada',
    newFee: 'Nueva tarifa, %',
    feeBefore: 'Tarifa antes, %',
    newLimit: 'Nuevo límite',
    statusDisabledInfo: 'El sitio web dejará de estar disponible desde todos los dominios.',
    statusActivitiesDisabledInfo: 'No se aceptarán nuevas apuestas.',
    statusVersionNamesDisabledInfo: 'Las apuestas se desactivarán para las versiones seleccionadas.',
    timezoneInfo: 'Los cálculos en curso relacionados con la zona horaria se modificarán.',
    domainRedirection: 'Redirección de dominio',
    uVerify: 'VERIFICAR',
    redirect: 'Redirigir',
    forwardingURL: 'URL de reenvío',
    destinationURL: 'URL de destino',
    domainRedirectInfo: 'El domain que se utiliza como URL de reenvío o de destino no puede ser eliminado sin borrar la regla existente.',
    registerDomainInfo: 'Debe registrar todos sus domains en su cuenta de google para habilitar el captcha en todos ellos.',
    ageRestriction: 'Restricción de edad',
    passwordPattern: 'Patrón de contraseña',
    failedAttemptsPeriod: 'Periodo de intentos fallidos',
    lockPeriod: 'Periodo de bloqueo',
    passwordReminder: 'Recordatorio de contraseña',
    inactivityPeriod: 'Periodo de inactividad',
    securityPeriod: 'Periodo de comprobación de seguridad',
    referralActivationPeriod: 'Periodo de activación de la recomendación',
    passwordPatternNote:
      'Se recomienda que las contraseñas tengan un mínimo de 8 caracteres, incluyendo al menos 1 número y 1 letra mayúscula. Sin embargo, puede debilitarla hasta tener entre 6 y 20 letras, números o caracteres especiales.',
    referralActivationPeriodNote: 'Periodo durante el cual desea conservar la información de identificación del recomendador para un nuevo registro en el sitio web.',
    correspondingTranslations: 'Asegúrese de que todas las traducciones se han actualizado correspondientemente.',
    verificationCodeLength: 'Longitud del código de verificación',
    dailyMobileVerification: 'Solicitudes diarias de verificación por móvil',
    emailRequestsInDaily: 'Solicitudes diarias de verificación por correo electrónico',
    expirationMinutes: 'Periodo de caducidad del token',
    expirationMinutesNote: 'La configuración define el periodo tras el cual el token (código, enlace) de la notificación dejará de ser válido.',
    emailRequestsInDailyNote: 'Esta configuración define cuántas solicitudes de verificación por correo electrónico puede recibir el jugador en un día. El valor mín. es {{value}}.',
    dailyMobileVerificationNote: 'Esta configuración define cuántas solicitudes de verificación por SMS puede recibir el jugador en un día. El valor mín. es {{value}}.',
    identityDocument: 'Documento de identidad',
    addressDocument: 'Documento de dirección',
    additionalDocument: 'Documento adicional',
    disableSportBook: 'Inhabilitar {{name}}',
    gameDisableTooltip: 'Puede que el juego haya sido desactivado en todo el sistema',
    playerLimitInfo: {
      text1: 'Puede configurar el periodo de disminución de la gravedad de los límites para cada tipo de límite.',
    },
    depositDecreaseLimit: 'Límite de depósito',
    betDecreaseLimit: 'Límite de apuesta',
    withdrawalDecreaseLimit: 'Límite de retirada',
    activateSportsbook: 'Activar Sportsbook',
    customScriptinfo: 'Puede integrar nuevas aplicaciones o añadir funcionalidades diferentes a su sitio web mediante la adición de scripts personalizados.',
    scriptName: 'Nombre de script',
    insideHead: 'Dentro de la etiqueta de cierre </head>',
    insideBody: 'Dentro de la etiqueta de cierre </body>',
    headTag: 'Script de etiqueta de encabezado',
    bodyTag: 'Script de etiqueta de cuerpo',
    service: 'servicio',
    integrate: 'Integrar',
    showOnLive: 'Mostrar en sitio web activo',
    showOnLiveTitle: 'Si desactiva este interruptor, el icono del servicio de terceros quedará oculto en la página de inicio de su sitio web.',
    apiSecret: 'Secreto de API',
    apiSecretOrPass: 'Secreto de API o contraseña',
    apiKeyOrUsername: 'Clave de API o nombre de usuario',
    sendEmailVia: 'Enviar correo electrónico mediante',
    smtpUser: 'Usuario SMTP',
    smtpPass: 'Contraseña SMTP',
    useSSL: 'Usar SSL',
    smtpHost: 'Host SMTP',
    smtpPort: 'Puerto SMTP',
    emailsInfo: {
      text1: 'Algunos proveedores de SMTP requieren que el mismo correo electrónico esté registrado en su extremo.',
      text2: 'Por favor, asegúrese de que se cumple este requisito.',
    },
    emailsInfo1: 'Todos los mensajes programados con este correo electrónico se moverán a borradores',
    blockCountries: 'Bloquear países',
    blockCountriesMainText: 'El sitio web dejará de estar disponible desde los países seleccionados',
    versionControl: 'Control de versiones',
    policies: 'Políticas',
    policy: 'Política',
    dateToNotify: 'Fecha de notificación',
    featureName: 'Nombre de función',
    createBrand: 'Crear marca',
    builder: 'Constructor',
    platformState: 'Estado de la plataforma',
    minMaxWithdrawalAmount: 'Importe mín-máx de retirada del sistema',
    minWithdrawalAmount: 'Importe min. de retirada',
    maxWithdrawalAmount: 'Importe máx. de retirada',
    minMaxDepositAmount: 'Importe mín-máx de depósito del sistema',
    minDepositAmount: 'Importe min. de depósito',
    maxDepositAmount: 'Importe máx. de depósito',
    operationFeePercent: 'Tasa de operación, %',
    withdrawalFeePercent: 'Tasa de retirada, %',
    withdrawalFee: 'Tasa de retirada',
    withdrawalFeeForUsedBalancePercent: 'Tasa de retirada para saldo utilizado, %',
    withdrawalFeeForUsedBalance: 'Tasa de retirada para saldo utilizado',
    allowedConversion: 'Conversión permitida',
    paymentMethodName: 'Nombre del método de pago',
    minAmount: 'Importe mín. de {{title}}',
    maxAmount: 'Importe máx. de {{title}}',
    minMaxSystemAmount: 'Importe mín-máx de {{title}}',
    depositFeePercent: 'Tasa de depósito, %',
    depositFee: 'Tasa de depósito',
    allowConversion: 'Permitir conversión',
    previewLive: 'Previsualización en vivo',
    feeFromDeposit: 'Tasa del depósito',
    allowWithdrawalFromUnusedBalance: 'Permitir la retirada del saldo no utilizado',
    allowWithdrawalFeeUsedBalance: 'La tasa de retirada se retendrá del saldo restante.',
    feeCalculationForWithdrawals: 'Cálculo de la tasa de retirada',
    feeFromWithdrawals: 'Tasa de las retiradas',
    feeFromWithdrawalsUsedBalance: 'Tasa de las retiradas (saldo utilizado)',
    feeFromWithdrawalsBalance: 'Tasa de las retiradas (saldo {{type}})',
    unusedBalanceInfo: 'Si se activa, la opción de saldo no utilizado aparecerá en la configuración de la "Tasa de retirada".',
    paymentTransactionType: 'Tipo de transacción de pago',
    paymentMethodType: 'Tipo de método de pago',
    playerPaymentRelation: 'Relación jugador-pago',
    failedPaymentAttempts: 'Intentos de pago fallidos',
    failedPaymentAttemptsPeriod: 'Periodo de intentos de pago fallidos',
    temporaryBlockPeriod: 'Periodo de bloqueo temporal',
    reverseConversion: 'Conversión inversa de {{title}}',
    lCustomScript: 'script personalizado',
    largeTransactions: 'Transacciones grandes',
    lBrand: 'marca',
    playerSettings: 'Opciones del jugador',
    verificationConfigurations: 'Configuraciones de verificación',
    theCurrency: 'La moneda',
    mainCountry: 'País principal',
    theLanguage: 'El idioma',
    smsSettings: 'Opciones de SMS',
    verificationSettings: 'Opciones de verificación',
    smtpSettings: 'Opciones de SMTP',
    captchaSettings: 'Opciones de captcha',
    theEmail: 'El correo electrónico',
    conversions: 'Conversiones',
    theConversion: 'La conversión',
    theCountry: 'El país',
    playerVerificationSettings: 'Configuración de verificación de jugadores',
    domainRedirectionRule: 'Regla de redirección de dominio',
    wageringActivities: 'Actividades de apuesta',
    theSportsBook: 'El sportsbook',
    sportsBook: 'Sportsbook',
    theSportsBookView: 'La vista de sportsbook',
    setMainView: 'Establecer vista principal',
    feeForWithdrawalsWillBeHeld: 'La tasa de retirada se retendrá del saldo restante.',
    brandName: 'Nombre de marca',
    defaultCountry: 'País predeterminado',
    defaultLanguage: 'Idioma predeterminado',
    defaultCurrency: 'Moneda predeterminada',
    products: 'Productos',
    websiteTemplate: 'Plantilla de sitio web',
    failedPaymentInfo: 'Las configuraciones no están disponibles debido a la inactividad de la norma "Procedimiento de pago fallido". Por favor, actívela desde la sección "Estándares".',
    depositWithdrawalPaymentMethodInfo:
      'Los métodos de pago que utilicen la conversión se verán afectados en caso de cambios y el sistema puede restablecer los límites mínimos/máximos personalizados si se contradicen con los nuevos cambios. '
      + 'Asegúrese de revisar los límites y la disponibilidad de divisas en la configuración de los métodos de pago.',
    otherPaymentMethodInfo:
      'Las funcionalidades internas que usan la conversión utilizarán estos tipos de conversión. Asegúrese de tener todas las conversiones en vigor (por ejemplo, el bono por recomendación).',
    conversionSettingsInfo: 'El límite actual contradice el límite del sistema/conversión.',
    card: 'Tarjeta',
    imageAlt: 'Imagen Alt.',
    recommendedSize: 'Tamaño recomendado',
    stateOrRegion: 'Estado/Región',
    socialLinks: 'Enlaces a redes sociales',
    socialLinkInfo: 'Páginas de perfil de la empresa en diferentes recursos, como Facebook, Twitter, Google+, Instagram, Youtube, LinkedIn, Wikipedia, etc. Puede añadir tantas URLs como desee.',
    image: 'Imagen',
    depositPaymentCategory: 'Categoría de pago de depósitos',
    withdrawalPaymentCategory: 'Categoría de pago de retiradas',
    createNewBrand: 'Crear nueva marca',
    accountId: 'ID de Cuenta',
    allowWithdrawalViaTheDepositedMethods: 'Permitir la retirada sólo a través de los métodos depositados',
    allowWithdrawalViaTheDepositedMethodsInfo: 'La activación de la configuración restringe al jugador la posibilidad de retirar dinero a través de los métodos que nunca antes había depositado',
    lConversion: 'conversión',
    schemaMarkupSettings: 'Configuración de Schema Markup',
    accountIdInfo: 'Cualquier nombre o código de identificación asociado al ID de cuenta de servicio que proporcione un nivel específico de acceso.',
    ranges: 'Rangos',
    depositAmountRanges: 'Importe del depósito (Desde - Hasta)',
    taxPercentage: 'Impuesto Porcentaje %',
    lTaxes: 'impuestos',
    withdrawalAmountRanges: 'Intervalo de retirada ( Desde - Hasta )',
    fixedAmountOrPercent: 'Importe fijo o porcentaje fiscal',
    spotsBookJackpotDescription: 'Importe fijo o tipo impositivo',
    spotsBookPrematchTopMatchesDescription: 'Cuando se activa, el widget Top Matches está disponible en el Iframe de Sportsbook y en la Landing Page.',
    spotsBookScrollingTypeDescription: 'La configuración sólo es aplicable a la vista estándar y, cuando está activada, la página de deportes es totalmente desplazable con un solo desplazamiento.',
    spotsBookTournamentBalanceDescription: 'Cuando se activa, el saldo del torneo está disponible en la página de inicio del sitio web.',
    sportJackpot: 'Jackpot deportivo',
    sectionsScrolling: 'Desplazamiento de secciones',
    sportTournamentBalance: 'Torneo deportivo Balance',
    iframe: 'Iframe',
    native: 'Nativo',
    sportsBookIframeIntegrationDescription: 'El sportsbook estará disponible en un marco en línea',
    sportsBookNativeIntegrationDescription: 'El sportsbook estará disponible directamente en un build in-app',
    sportsBookMobileIntegrationType: 'Tipo de integración en el móvil',
    setAsDefault: 'Fijar por defecto',
    configs: 'Configs',
    availableLayouts: 'Diseños Disponibles',
    setAmountRangesInfo:
      "Si para un rango se establece tanto 'Importe Fijo' como 'Porcentaje de Impuesto', el sistema deberá calcular el impuesto de la siguiente manera: retener un importe de impuesto fijo + el porcentaje x del importe que exceda del importe establecido en el campo 'Desde' del rango.",
    depositAmountRangesHint:
      'El importe del campo " Desde " del " Intervalo de Importes de Depósito " se incluye en dicho intervalo, mientras que el importe del campo " Hasta " no se incluye en el intervalo.',
    withdrawalAmountRangesHint:
      'El importe del campo " Desde " del " Intervalo de Importes de Retirada " se incluye en dicho intervalo, mientras que el importe del campo " Hasta " no se incluye en el intervalo.',
    fixedAmountHint:
      'El importe del campo "Importe Fijo" debe ser inferior o igual al importe introducido en el campo "Desde" del "Rango de Importe del Depósito". Si el importe \'Desde\' es 0, el importe del campo \'Importe Fijo\' también debe ser 0.',
    fixedAmount: 'Importe Fijo',
    brandSportsBookActivation:
      'Mediante la activación del producto Sportsbook obtendrá acceso a una interfaz personalizable con eventos en directo y pre-partido para más de 65 deportes. Una vez activado, el producto solo se puede desactivar desde el panel de administración de Sportsbook.',
    amountFrom: 'Importe Desde',
    allowPlayerCompose: 'Permitir a los Jugadores "Redactar" Mensajes',
    sportsBookInheritWebsiteColor: 'Heredar Color del Sitio Web',
    sportsBookInheritWebsiteColorDescription: 'El ajuste se aplica a todas las páginas de deportes.',
    theBrand: 'Marca',
    taxSettings: 'Configuración Fiscal',
    infoUrlHint: 'Esta URL se utilizará en el sitio web para mostrar los datos fiscales.',
    everyMatrixDescription: 'Soluciones de iGaming modulares y basadas en API diseñadas para liberar ideas audaces',
    smarticoAffiliateDescription: 'No hay mejor manera de conectar con sus clientes',
    hotjarDescription: 'Entender cómo los usuarios están experimentando realmente su sitio web sin ahogarse en los números.',
    hotjarId: 'HotJar ID',
    googleAnalyticsId: 'ID de Google Analytics',
    googleAnalyticsDescription: 'Analice el uso de sus sitios web',
    googleSiteVerificationCode: 'Código de verificación del sitio de Google',
    googleSearchConsoleDescription: 'Obtenga ayuda para supervisar, mantener y solucionar los problemas de presencia de su sitio web en los resultados de búsqueda de Google.',
    copyPasteFieldName: 'Copia tu {{fieldName}} y pégalo en el campo de abajo.',
    learnMore: 'Saber más...',
    affiliateInfo: '{{count}} las integraciones no pueden estar activas simultáneamente',
    liveChatDescription: 'Aplicación de comunicación en línea que le permite chatear en tiempo real con los visitantes de su sitio web.',
    liveAgentDescription: 'Ofrecer un excelente servicio al cliente',
    intercomDescription: 'Inicie aquí una excelente relación con el cliente',
    zendeskDescription: 'Comunicación más eficaz con los clientes',
    intercomId: 'Intercom ID',
    zendeskId: 'Zendesk ID',
    liveChatLicenseNumber: 'LiveChat LICENSE_NUMBER',
    liveAgentYourLa: 'LiveAgent YOUR-LA',
    liveAgentButtonID: 'ID del botón de LiveAgent',
    digitainAgIdInfo: 'Este es el ID de la marca en el panel de administración "Digitain Agent".',
    depositCurrencyInfo:
      'En caso de que a los jugadores se les permita hacer depósitos con todas las divisas soportadas con los métodos de pago, "Permitir Conversión" con las configuraciones de divisas soportadas debe estar activo para el método de pago.',
    pageGroups: 'Grupos de Páginas',
    digitainRetailInfo: 'Este es el ID del método de pago en el panel de administración de "Digitain Retail".',
    smarticoDescription: 'La solución de gamificación que utiliza retos y técnicas de juego para motivar a los jugadores.',
    smarticoLabelKey: 'Clave de Etiqueta',
    brandKey: 'Clave de la Marca',
    smarticoBrandKeyInfo: 'Clave pública para la marca',
    smarticoLabelKeyInfo: 'Clave pública para la etiqueta',
    smarticoNote: 'Smartico CRM y Gamification están interconectados, cada acción en esta sección tiene efecto en Gamification también',
    realityCheckPeriod: 'Reality Check Period',
    timeOut: 'Tiempo muerto',
    prematchTotalTopMatches: 'Primeros partidos (mercado total incluido)',
    spotsBookPrematchTotalTopMatchesDescription: 'Si se activa, el widget de los mejores partidos de Prematch con datos totales del mercado estará disponible.',
    livePrematchTopMatches: 'En Vivo y PrePartido Top Partidos',
    spotsBookLiveTopMatchesDescription: 'Cuando está activado, el Widget de Top Partidos en Directo está disponible',
    periodCalculationSource: 'Período Fuente de cálculo',
    periodCalculationSourceInfo: 'Seleccione la fuente de fecha en la que se iniciará el cálculo del período de verificación',
    verificationPeriod: 'Período de Verificación',
    verificationPeriodInfo: ' El número de días que una cuenta de jugador puede estar activa antes de la verificación.',
    unverifiedPlayersExclusionsInfo:
      'En los casos en que se seleccione un método de pago en el menú "Pagos que Ignoran la Verificación de Depósito" y se establezcan límites en la parte "Importes Máximos de Depósito", los límites no afectarán a ese método de pago.',
    responsibleGamingPeriodLimitsInfo: 'En esta sección puede establecer un periodo de tiempo específico que un jugador puede elegir para el tiempo muerto y la autoexclusión.',
    preferencesSMSDescription: 'Envío de SMS para todos los jugadores de la marca y sección de SMS invisible en el sitio web',
    preferencesEmailDescription: 'Envío de correo electrónico para todos los jugadores de la marca y el sitio web a través de correo electrónico debe ser invisible',
    walletsSettings: 'Ajustes de la Cartera',
    wallets: 'Carteras',
    features: 'Funciones',
    dda: 'DDA',
    ddaInfo: 'Activando esta opción los impuestos sobre el retiro serán retenidos en la lógica del APD',
    whatsAppDescription: 'Permita que sus clientes se pongan en contacto con usted a través del servicio de mensajería más popular del mundo.',
    phoneNumber: 'Número de Teléfono',
    whatsAppPhoneNumberInfo: 'Introduce el número de teléfono con el que está registrada tu cuenta de WhatsApp',
    multiGameLaunch: 'Lanzamiento Multijuegos',
    multiGameLaunchDescription: 'Dependiendo de la configuración, la opción multijuego está disponible en el sitio web y los jugadores pueden jugar varias partidas simultáneamente.',
    jackpotWidget: 'Jackpot Widget',
    jackpotWidgetDescription: 'Se refiere a la activación del Widget Jackpot de Casino para la Página de Destino. Disponible para el Widget Jackpot del Proveedor Amusnet.',
    gameIframe: 'Juego Iframe',
    manuBarFixation: 'Fijación de la Barra de Menús',
    manuBarFixationDescription: 'Sólo para la vista móvil, dependiendo de la configuración Barra Principal es fijo para los vestíbulos.',
    paymentVisibilityInfo: 'En esta sección, puede ocultar y no permitir el uso de métodos de pago a los jugadores que tengan una de las etiquetas seleccionadas',
    centrivoConnectAgDescription: 'Transforme su negocio de iGaming con la solución Connect Agent de Centrivo',
    retailCentrivoDescription: 'Transforme su negocio de iGaming con la solución para retail de Centrivo',
    currencySymbol: 'Símbolo de Moneda',
    preferencesPushNotificationsDescription: 'El canal de Notificaciones Push estará disponible para enviar notificaciones para la Marca',
    currencyFormat: 'Formato de moneda',
    currencyFormatInfo: 'Qué formato de moneda mostrar en el sitio web para los jugadores.',
    isoCode: 'Código ISO',
    symbols: 'Símbolos',
    digitainCrmDescription: 'Solución CRM diseñada para mantener el compromiso de los jugadores existentes y mejorar su satisfacción general.',
    accessDecreaseLimit: 'Límite de acceso',
    depositOnNegativeBalance: 'Depósito sobre saldo negativo',
    depositOnNegativeBalanceInfo: 'Después de la aprobación del depósito, el ajuste se realizará en el monedero negativo del jugador para cerrar la deuda.',
    digitainAffiliateDescription: 'Active su programa de afiliación y experimente un aumento significativo del tráfico de su sitio web.',
    projectId: 'ID del Proyecto',
    projectIdInfo: 'Este es el ID del proyecto en el panel de administración de "Digitain Affiliate".',
    brandIdInfo: 'Este es el ID de la marca en el panel de administración de "Digitain Affiliate".',
    maintenanceSetup: 'Configuración de mantenimiento',
    maintenancePeriod: 'Período de Mantenimiento',
    sportsBookViews: 'Vistas de Sportsbook',
    mandatoryNotification: 'Notificación obligatoria',
    mandatoryNotificationInfo: 'Una ventana emergente obligatoria para los jugadores registrados en el sitio web',
    lossDecreaseLimit: 'Límite de Pérdidas',
    inactivityIndicators: 'Indicadores de inactividad',
    inactivityIndicatorsInfo:
      'Esta configuración considerará como jugador inactivo en base a uno de varios indicadores, la última fecha de inicio de sesión del jugador o la última fecha de transacciones (apuesta, depósito, retirada).',
    recoverByPlayer: 'Recuperación por jugador',
    recoverByPlayerInfo: 'Cuando está activado, los jugadores pueden recuperarse a través del código de verificación',
    singleBetDecreaseLimit: 'Límite de Apuesta Única',
    cashierType: 'Tipo de Caja',
    gameLaunchType: 'Tipo de Lanzamiento del Juego (vista móvil)',
    gameFullScreenLaunchDescription: 'Juego abierto con iframe en pantalla completa',
    gameHeaderFooterLaunchDescription: 'Juegos abiertos con iframe y encabezado y pie de página',
    gameQuickActionBarLaunchDescription: 'Los juegos se abren con la barra de acciones rápidas',
    limitEffectConfigs: 'Configuración del efecto límite',
    ignoreFirstDeposit: 'Ignorar el primer depósito',
    ignoreFirstDepositHint: 'Si se selecciona esta opción, el primer depósito realizado con éxito por el jugador no se calculará en el límite de depósito de juego responsable.',
    periodLimit: 'Límite de período',
    playerLimitsConfiguration: 'Configuración de los límites de los jugadores',
    alanbaseDescription: 'Una plataforma creada por expertos en iGaming y marketing de afiliación para ayudar a otros expertos a optimizar sus costes y aumentar sus beneficios.',
    routForEvents: 'Rutas para eventos',
    routForGoals: 'Rutas por objetivos',
    fastDepositPaymentMethod: 'Método de pago de depósito rápido',
    fastDepositPaymentMethodInfo:
      "Depósito Rápido es una funcionalidad del sitio web a través de la cual los jugadores pueden realizar un depósito sin salir de la página de juego mediante el método de pago predefinido de 'Centrivo'.",
    sportStatusIconsInfo: 'Los iconos cargados serán visibles en el perfil del jugador en el sitio web. Cada icono cargado se reflejará en el sitio web al cabo de una hora como máximo.',
    rolloverBetsReturn: 'Las apuestas prorrogadas vuelven a la misma cartera',
    rolloverBetsReturnInfo: 'En caso de devolución/cancelación de la apuesta realizada con el saldo de reinversión, el importe se transferirá al saldo de reinversión.',
    maxDepositAmounts: 'Importes máximos de depósito',
    paymentsIgnoringDepositVerification: 'Pagos que ignoran la verificación de depósitos',
    selfExclusion: 'Autoexclusión',
    setMainDomain: 'Configurar Dominio Principal',
    disconnected: 'Desconectado',
    configureLimits: 'Configurar Límites',
    metaMapDesc: 'Todo lo que necesitas para verificar a tus clientes en una sola plataforma.',
    clientId: 'ID de Cliente',
    clientIdInfo: 'Se utiliza para identificarte como comerciante.',
    clientSecret: 'Secreto de Cliente',
    clientSecretInfo: 'Usa el client_secret tomado del Panel de Control como tu contraseña.',
    pushGameState: 'Enviar Estado del Juego',
    pushGameStateDescription: 'Esta configuración define el estado de los juegos ("Estado del Juego") enviado por el agregador al Back Office.',
    thunderBiteDescription: 'Gamifica la experiencia del cliente y convierte el engagement en lealtad.',
    campaignURL: 'URL de la Campaña',
    captchaCaseInsensitiveInfo: 'Al habilitar la opción para el captcha, el sistema no distingue entre mayúsculas y minúsculas, considerándolas idénticas.',
    caseInsensitive: 'No distingue mayúsculas/minúsculas',
    verificationRequestPeriod: 'Periodo de Solicitud de Verificación SMS/Email',
    verificationRequestPeriodInfo: 'Configura cuándo se enviará la próxima solicitud de verificación por SMS/Email al jugador.',
    sec: 'seg',
    integratedDate: 'Fecha de Integración',
    integratedBy: 'Integrado por',
    isInvisible: 'Es Invisible',
    captchaInvisibleInfo: 'Si está marcado, el captcha no será visible para los jugadores.',
    captchaLogonAttemptsInfo: 'Define el número de intentos fallidos de inicio de sesión, el periodo para contar estos intentos y la duración durante la cual aparecerá el CAPTCHA.',
    jackpot: 'Jackpot',
    globalState: 'Estado Global',
    jackpotGames: 'Juegos con Jackpot',
    myAffiliatesDescription: 'El software de seguimiento de afiliados más flexible del mercado.',
    sportDomainsTabInfo: 'El número máximo de dominios deportivos es {{count}}. Solo se pueden establecer dominios activos como principales. Solo se pueden conectar dominios verificados.',
    firebaseAuthenticationDescription: 'Configura plataformas sociales para el registro y autenticación de usuarios con Firebase.',
    frontend: 'Frontend',
    backend: 'Backend',
    google: 'Google',
    facebook: 'Facebook',
    socialMediaPlatforms: 'Plataformas de Redes Sociales',
    optimoveDescription: 'Solución CRM diseñada para mantener el engagement de jugadores existentes y mejorar su satisfacción general.',
    baseUrl: 'URL Base',
    forcePasswordChangeNote: 'Al habilitar esta opción, los jugadores deberán cambiar su contraseña si ha pasado el periodo establecido.',
    forcePasswordChange: 'Forzar cambio de contraseña',
    playerTags: 'Etiquetas de jugador',
    additional: 'Adicional',
    gameTimeLimit: 'Límite de tiempo de juego',
    verificationOptions: 'Opciones de verificación',
    blockActions: 'Bloquear acciones',
    userNotification: 'Notificación al usuario',
    winAmounts: 'Montos de ganancia',
    largeWinTransactionNotification:
      'La notificación de "Gran Ganancia" se enviará solo a usuarios seleccionados. Asegúrate de configurar el monto de ganancia para todas las monedas si algún usuario está seleccionado.',
    promptOnLogin: 'Aviso al iniciar sesión',
    promptOnLoginInfo: 'Al seleccionar esta opción, se pedirá a los jugadores que configuren sus límites en el primer inicio de sesión.',
    productCategory: 'Categoría de producto',
    betProfitRange: 'Rango de ganancia de apuesta (Desde - Hasta)',
    betProfitRangeHint: "El monto en el campo 'Desde' está incluido en el rango, mientras que el monto en el campo 'Hasta' no está incluido.",
    betTaxInfo: "A una sola 'Categoría de producto' se le puede asignar el tipo de tributación 'Acumulativo' o 'Por transacción', según el método de cálculo fiscal preferido.",
    betTaxStandardDisabledInfo: "Activa 'Tributación' y 'Impuesto sobre ganancias de apuestas' para habilitar el motor fiscal para tu marca.",
    depositTaxStandardDisabledInfo: "Activa 'Tributación' y 'Impuesto sobre depósitos' para habilitar el motor fiscal para tu marca.",
    withdrawalTaxStandardDisabledInfo: "Activa 'Tributación' y 'Impuesto sobre retiros' para habilitar el motor fiscal para tu marca.",
    registrationUniqueness: 'Unicidad en el registro',
    registrationUniquenessNote: 'La combinación seleccionada debe ser validada como única durante el registro del jugador.',
    responsibleGamingLimitsInfo: 'En esta sección puedes establecer valores predefinidos que se autocompletarán como límites por defecto durante la configuración, pero pueden ajustarse manualmente.',
    hours: '{{number}} horas',
    days: '{{number}} días',
    month: '{{number}} mes',
    year: '{{number}} año',
    viewDefaultAmount: 'Ver monto por defecto',
    viewDefaultLimit: 'Ver límite por defecto',
    realTimeUniquenessCheck: 'Chequeo de unicidad en tiempo real',
    realTimeUniquenessCheckNote: 'Al activarlo, el sistema verificará instantáneamente que el número móvil, ID y correo electrónico sean únicos durante el proceso de registro.',
    appToken: 'Token de app',
    accountVerificationOptions: 'Opciones de verificación de cuenta',
    accountVerificationOptionsInfo: 'Selecciona las opciones según las cuales la cuenta del jugador será considerada verificada.',
    markAsUnverified: 'Marcar como no verificado',
    markAsUnverifiedInfo: 'Al activarlo, los jugadores serán marcados como no verificados según las reglas establecidas.',
    verificationPeriodTabInfo: {
      text1: 'En esta sección, puedes establecer reglas para bloquear automáticamente a jugadores no verificados después de un periodo específico.',
      text2: 'Los jugadores que completen la verificación serán considerados verificados. Los no verificados serán marcados como bloqueados por no verificar.',
    },
    notificationReminder: 'Recordatorio de notificación',
    notificationReminderInfo: 'Número de días después de los cuales se recordará al jugador verificar su cuenta.',
    blockForUnVerify: 'Bloquear por no verificar',
    blockForUnVerifyOptions: 'Opciones de bloqueo por no verificar',
    betOddsLimit: 'Límite de cuotas de apuesta',
    betOddsLimitInfo:
      'Si la apuesta se realiza con cuotas inferiores al límite establecido, la ganancia se distribuirá proporcionalmente entre las carteras (usadas y no usadas) donde se realizó la apuesta.',
    selfExclusionReason: 'Razón de autoexclusión',
    selfExclusionReasonInfo: 'Si se selecciona, el jugador no podrá establecer autoexclusión para la cuenta con las razones especificadas.',
    balanceVisibility: 'Visibilidad del saldo',
    balanceVisibilityNote: 'Los saldos seleccionados serán visibles para los jugadores de la marca.',
    configured: 'Configurado',
    limitEffectPeriodInfo:
      'Los cambios surtirán efecto después de un tiempo establecido (inmediato, 24 horas, 48 horas o 7 días), o al inicio del siguiente periodo calendario — medianoche para límites diarios, lunes para límites semanales o el día 1 para límites mensuales.',
    documentsConfig: 'Configuración de documentos',
    documentsConfigInfo: 'El número de páginas requeridas para los tipos de documentos siguientes es siempre 1.',
    pageCount: 'Número de páginas',
    realityCheckSettings: 'Configuración de Reality Check',
    calculationType: 'Tipo de cálculo',
    realityCheckInterval: 'Intervalo de Reality Check',
    showLogOutButton: 'Mostrar botón de cerrar sesión',
    realityCheckSettingsInfo: 'Las configuraciones solo aplicarán si Reality Check está habilitado en la sección de estándares.',
    realityCheckStatus: 'Estado de Reality Check',
    realityCheckPeriodInfo: 'Estos periodos aparecerán en la cuenta del jugador en el sitio web.',
    realityCheckIntervalInfo: 'Define el intervalo de tiempo entre las ventanas emergentes de Reality Check mostradas a los jugadores.',
    capitalizePlayerData: 'Capitalizar datos del jugador',
    capitalizePlayerDataInfo: 'Al activarlo, el sistema capitalizará Nombres, Apellidos, Dirección y Ciudad durante el registro y lo guardará en backoffice.',
    blockedCountriesInfo:
      'La acción (desbloquear, bloqueo total, bloqueo para inicio de sesión, bloqueo para registro, bloqueo para inicio de sesión y registro) puede aplicarse individualmente por país o en bloque, actualizando su estado de una vez.',
    bulkAction: 'Acción masiva',
    multiPeriodLimitType: 'Tipo de límite multiperiodo',
    singlePeriodLimitType: 'Tipo de límite periodo único',
    changeEffectPeriods: 'Periodos de efecto de cambio',
    lastMonthPeriod: 'Periodo del mes pasado',
    eddVerificationNotification: 'Las configuraciones EDD activarán la verificación de fuente de fondos para jugadores calificados.',
    totalDepositAmount: 'Monto total de depósitos',
    prematchTopMatches: 'Partidos Top antes del Partido',
    spotsBookLivePrematchTopMatchesDescription: 'Cuando está habilitado, el widget de Partidos Destacados en Vivo y Prematch estará disponible.',
    liveTopMatches: 'Partidos Top en Vivo',
    preferencesDescription: 'Activación/desactivación de notificaciones por SMS, correo electrónico y push para los jugadores.',
    lIcon: 'Icono',
    brandBonusesInfo:
      'Esta sección permite a los usuarios configurar la lógica de activación de bonos para la marca según condiciones específicas. Si alguna condición no se cumple, el bono no se activará.',
    firstSuccessfulDeposit: 'Primer depósito exitoso',
    firstSuccessfulDepositDesc: 'Los jugadores deben tener al menos un depósito exitoso para poder activar los bonos.',
    sportStatusDesc: 'Los jugadores con el estado seleccionado no son elegibles para activar los bonos recibidos.',
    standardTaxModelInfo: 'Calcula el impuesto sobre el depósito realizado aplicando el porcentaje de impuesto indicado al monto total.',
    vatTaxModelInfo: 'Calcula el impuesto sobre el depósito realizado aplicando el porcentaje de IVA indicado según la fórmula de IVA. El monto total del depósito incluye el IVA.',
    setVatAmountRangesInfo: 'El sistema separa automáticamente la parte del IVA del total para calcular el valor real del depósito.',
    multiBetOfTheDay: 'Multi Apuesta del Día',
    sportSuperPromotion: 'Súper Promociones',
    schemaMarkupImage: 'Imagen de Schema Markup',
    dataSendPeriod: 'Periodo de envío de datos',
    demoLaunchDesktop: 'Lanzamiento demo (Desktop)',
    demoLaunchMobile: 'Lanzamiento demo (Mobile)',
    demoLaunchDesktopDescription: 'Según la configuración, el botón de demo está disponible en los juegos y los jugadores pueden lanzar la versión demo en la vista Desktop.',
    demoLaunchMobileDescription: 'Según la configuración, el botón de demo está disponible en los juegos y los jugadores pueden lanzar la versión demo en la vista Mobile.',
    androidSettings: 'Configuración de Android',
    iosSettings: 'Configuración de iOS',
    googleCloudProjectId: 'ID del proyecto de Google Cloud',
    mobileReCaptcha: 'Αναγνωριστικό έργου Google Cloud',
    androidReCaptchaKey: 'Clave reCAPTCHA de Android',
    androidKeyId: 'ID de clave de Android',
    iosReCaptchaKey: 'Clave reCAPTCHA de iOS',
    iosKeyId: 'ID de clave de iOS',
    playerApproval: 'Aprobación del jugador',
    playerApprovalInfo: 'Requiere confirmación del jugador antes de aplicar el nuevo límite más bajo tras el período de cambio',
    transactionTypeNote: 'Los tipos seleccionados serán visibles para los jugadores de la marca en el Cashier del sitio web',
    domainDeletion: 'Eliminación de dominio',
    incomeAccessDescription: 'Únete a la red de afiliación iGaming con mayor trayectoria',
    suggestedAmounts: 'Importes sugeridos',
    defaultAmount: 'Importe predeterminado',
    viewLimits: 'Ver límites',
    configureAmounts: 'Configurar importes',
    suggested: 'Sugerido',
    otherTypeDocumentConfigInfo:
      'Para todos los tipos excepto <0>Other</0>, se requiere el número seleccionado de archivos. Para <0>Other</0>, el número seleccionado es el máximo permitido; se permiten menos archivos',
    uploadReCaptchaInfo: 'Puedes subir un archivo JSON válido para la configuración de reCAPTCHA',
    androidPrivateKey: 'Clave privada de Android',
    iosPrivateKey: 'Clave privada de iOS',
    indefiniteTimePeriod: 'Periodo de tiempo indefinido',
    sportMinBetAge: 'Edad mínima de apuesta en deportes',
    casinoMinBetAge: 'Edad mínima de apuesta en casino',
    zingBrainDesc: 'ZingBrain es una plataforma de mejora de rendimiento fácil de integrar para la industria del iGaming',
    awsCloudDescription: 'Configura AWS para habilitar la carga de datos',
    zingBrandDescription: 'Integra ZingBrain para habilitar la configuración de recomendaciones de contenido del lobby impulsadas por IA',
    regionName: 'Nombre de la región',
    endpointUrl: 'URL del endpoint',
    accessKeyId: 'ID de clave de acceso',
    secretAccessKey: 'Clave de acceso secreta',
    bucketName: 'Nombre del bucket',
    apiUserName: 'Nombre de usuario de la API',
    apiPassword: 'Contraseña de la API',
    zingBrandId: 'ID de ZingBrand',
    configuredDate: 'Fecha de configuración',
    configuredBy: 'Configurado por',
    standardTaxModel: 'Modelo fiscal estándar',
    loyaltyProgram: 'Programa de fidelidad',
    activationMinimumAmount: 'Importe mínimo de activación',
    activationMinimumAmountDesc: 'Los jugadores deben tener al menos el importe indicado en sus wallets para poder activar el bono',
    authentigateDescription:
      'Authentigate es tu solución todo en uno para la autenticación eID más popular en los países bálticos. Conecta Smart-ID, Mobile-ID, eParaksts mobile y la tarjeta de identidad estonia a través de una única pasarela segura',
    betStatusCorrectionsNotification: 'Definición de límites y requisitos de confirmación para operadores, permitiéndoles aprobar o cancelar acciones que excedan los límites',
    trustlyDescription: 'Trustly Pay and Play ofrece a los jugadores un proceso de onboarding rápido y sin fricciones que combina depósitos, verificación de usuario y creación de cuenta',
    trustlyNote: 'Pay and Play debe configurarse primero en la página de Paydrom antes de habilitar esta opción',
    relumActivation:
      'Al activar el producto Relum, obtendrás acceso a múltiples juegos de distintos proveedores premium, permitiéndote crear una experiencia de juego personalizada para tus jugadores',
    sportsBookActivation:
      'Al activar el producto Sportsbook, obtendrás acceso a una interfaz completa, multilingüe, multidivisa y personalizable, con eventos en vivo y pre-partido para distintos deportes, ligas de todo el mundo y una amplia variedad de mercados de apuestas',
    domain: 'Dominio',
    whiteIps: 'IPs permitidas',
    betStatusCorrections: 'Correcciones del estado de apuestas',
    autoDeposit: 'Depósito automático',
  },
  tr: {
    mainCurrency: 'Ana Para Birimi',
    mainLanguage: 'Ana Dil',
    market: 'Pazar',
    setMainCountry: 'Ana Ülkeyi Ayarla',
    setMainCurrency: 'Ana Para Birimi Ayarla',
    setMainLanguage: 'Ana Dili Ayarla',
    redirectedTo: 'Yönlendirildi:',
    onlyVerifiedDomainInfo: 'Yalnızca doğrulanmış domain bağlanabilir',
    disconnectDomain: 'Domain Bağlantısını Kes',
    connectDomain: 'Domain Bağla',
    deleteDomain: 'Domain Sil',
    deleteScript: 'Komut Dosyasını Sil',
    deactivateScript: 'Komut Dosyasını Devre Dışı Bırak',
    activateScript: 'Komut Dosyasını Etkinleştir',
    supportedCurrencies: 'Desteklenen Para Birimleri',
    supportedCountries: 'Desteklenen Ülkeler',
    supportedLanguages: 'Desteklenen Diller',
    providerDisableInfo: 'Sağlayıcı tüm sistem için devre dışı bırakılmış olabilir',
    activity: 'Faaliyet',
    verificationAnd: 'Doğrulama (ve)',
    verificationOr: 'Doğrulama (veya)',
    andDelimiter: 've',
    currencyFrom: 'Para Birimi:',
    currencyTo: 'Para Birimi:',
    reverseRate: 'Ters Oran',
    feature: 'Özellik',
    otherTransactions: 'Diğer İşlemler',
    playersNotifiedDate: 'Bildirim Tarihi',
    depositProcessingType: 'Para Yatırma İşlemi Türü',
    withdrawalProcessingType: 'Para Çekme İşlemi Türü',
    allowedActivities: 'İzin Verilen Faaliyetler',
    depositSupportedCurrencies: 'Para Yatırmak için Desteklenen Para Birimleri',
    withdrawalSupportedCurrencies: 'Para Çekmek için Desteklenen Para Birimleri',
    newFee: 'Yeni Ücret, %',
    feeBefore: 'Öncesinde Ücret, %',
    newLimit: 'Yeni Limit',
    statusDisabledInfo: 'Web sitesi tüm domain alanlarından kullanılamayacak.',
    statusActivitiesDisabledInfo: 'Yeni bahisler kabul edilmeyecektir.',
    statusVersionNamesDisabledInfo: 'Seçilen sürümler için bahisler devre dışı bırakılacaktır.',
    timezoneInfo: 'Saat dilimiyle ilgili devam eden tüm hesaplamalar değişecektir.',
    domainRedirection: 'Domain Yönlendirme',
    uVerify: 'DOĞRULA',
    redirect: 'Yönlendirme',
    forwardingURL: 'Yönlendirme URL',
    destinationURL: 'Hedef URL',
    domainRedirectInfo: 'Yönlendirme veya hedef URL olarak kullanılan domain, mevcut kural silinmeden silinemez.',
    registerDomainInfo: "Hepsi için captcha'yı etkinleştirmek için tüm domain adlarınızı google hesabınıza kaydetmeniz gerekir.",
    ageRestriction: 'Yaş Kısıtlaması',
    passwordPattern: 'Şifre Kalıbı',
    failedAttemptsPeriod: 'Başarısız Denemeler Dönemi',
    lockPeriod: 'Kilit Süresi',
    passwordReminder: 'Şifre Hatırlatıcı',
    inactivityPeriod: 'Hareketsizlik Dönemi',
    securityPeriod: 'Güvenlik Kontrolü Dönemi',
    referralActivationPeriod: 'Yönlendirme Aktivasyon Süresi',
    passwordPatternNote:
      'Şifrelerin en az 1 rakam ve 1 büyük harf olmak üzere en az 8 karakterden oluşması önerilir. Ancak 6-20 Latin harf, sayı veya özel karakter olacak kadar güçlendirebilirsiniz.',
    referralActivationPeriodNote: 'Web sitesinde yeni bir kayıt için referans olan kişinin kimlik bilgilerini saklamak istediğiniz süre.',
    correspondingTranslations: 'Tüm çevirilerin uygun şekilde güncellendiğinden emin olun.',
    verificationCodeLength: 'Doğrulama Kodu Uzunluğu',
    dailyMobileVerification: 'Günlük Mobil Doğrulama İstekleri',
    emailRequestsInDaily: 'Günlük E-mail Doğrulama İstekleri',
    expirationMinutes: 'Jeton Son Kullanma Süresi',
    expirationMinutesNote: 'Config, bildirimdeki belirtecin (kod, bağlantı) geçersiz hale geleceği süreyi tanımlar.',
    emailRequestsInDailyNote: 'Config, doğrulama oyuncusunun bir günde kaç e-posta talebi alabileceğini tanımlar. Minimum değer: {{value}}.',
    dailyMobileVerificationNote: 'Yapılandırma, oyuncunun bir günde kaç SMS talebi alabileceğini tanımlar. Minimum değer: {{value}}.',
    identityDocument: 'Kimlik Belgesi',
    addressDocument: 'Adres Belgesi',
    additionalDocument: 'Ek Belge',
    disableSportBook: '‎{{name}} Devre Dışı Bırak',
    gameDisableTooltip: 'Oyun tüm sistem için devre dışı bırakılmış olabilir',
    playerLimitInfo: {
      text1: 'Her bir limit türü için limit seviyesini düşürme süresini ayarlayabilirsiniz.',
    },
    depositDecreaseLimit: 'Para Yatırma Limiti',
    betDecreaseLimit: 'Bahis Limiti',
    withdrawalDecreaseLimit: 'Para Çekme Limiti',
    activateSportsbook: 'Spor Bahis Platformunu Etkinleştir',
    customScriptInfo: 'Yeni uygulamalar entegre edebilir veya farklı uygulamalar ekleyebilirsiniz. özel komut dosyaları ekleyerek web sitenize işlevselleştirir.',
    scriptName: 'Komut Dosyası Adı',
    insideHead: 'Kapanış </head> etiketinin içinde',
    insideBody: 'Kapanış </body> etiketinin içinde',
    headTag: 'baş etiketi komut dosyası',
    bodyTag: 'gövde etiketi komut dosyası',
    service: 'hizmet',
    integrate: 'Birleştir',
    showOnLive: 'Canlı Web Sitesinde Göster',
    showOnLiveTitle: 'Bu değiştiriciyi kapattığınızda, 3. taraf hizmetinin simgesi web sitenizin ana sayfasından gizlenecektir.',
    apiSecret: 'API Gizli Anahtarı',
    apiSecretOrPass: 'API Gizli Anahtarı veya Şifresi',
    apiKeyOrUsername: 'API Anahtarı veya kullanıcı adı',
    sendEmailVia: 'E-mail Gönder',
    smtpUser: 'SMTP Kullanıcısı',
    smtpPass: 'SMTP Şifresi',
    useSSL: 'SSL Kullan',
    smtpHost: 'SMTP Ana Bilgisayarı',
    smtpPort: 'SMTP Bağlantı Noktası',
    emailsInfo: {
      text1: 'Bazı SMTP sağlayıcıları için aynı e-mailin kendi taraflarında kayıtlı olması gerekir.',
      text2: 'Lütfen gereksinimin karşılandığından emin olun.',
    },
    emailsInfo1: 'Bu e-maili içeren tüm planlanmış iletiler taslağa taşınacak',
    blockCountries: 'Ülke Yasakla',
    blockCountriesMainText: 'Web sitesi seçilen ülkelerden kullanılamaz hale gelecek',
    versionControl: 'Sürüm Kontrolü',
    policies: 'Politikalar',
    policy: 'Politika',
    dateToNotify: 'Bildirim Tarihi',
    featureName: 'Özellik Adı',
    createBrand: 'Marka Yarat',
    builder: 'Geliştirici',
    platformState: 'Platform Durumu',
    minMaxWithdrawalAmount: 'Min-Max Sistem Para Çekme Tutarı',
    minWithdrawalAmount: 'Min. Para Çekme Tutarı',
    maxWithdrawalAmount: 'Maks. Para Çekme Tutarı',
    minMaxDepositAmount: 'Min-Max Sistem Para Yatırma Tutarı',
    minDepositAmount: 'Min. Para Yatırma Tutarı',
    maxDepositAmount: 'Maks. Para Yatırma Tutarı',
    operationFeePercent: 'Operasyon Ücreti, %',
    withdrawalFeePercent: 'Para Çekme Ücreti, %',
    withdrawalFee: 'Para Çekme Ücreti',
    withdrawalFeeForUsedBalancePercent: 'Kullanılan bakiye için Para Çekme Ücreti, %',
    withdrawalFeeForUsedBalance: 'Kullanılan bakiye için Para Çekme Ücreti',
    allowedConversion: 'İzin Verilen Dönüşüm',
    paymentMethodName: 'Ödeme yöntemi adı',
    minAmount: 'Min {{title}} Tutar',
    maxAmount: 'Maks. {{title}} Tutar',
    minMaxSystemAmount: 'Min-Maks Sistem {{title}} Tutarı',
    depositFeePercent: 'Para Yatırma Ücreti, %',
    depositFee: 'Para Yatırma Ücreti',
    allowConversion: 'Dönüşüme İzin Ver',
    previewLive: 'Önizleme Canlı',
    feeFromDeposit: 'Para Yatırma Ücreti',
    allowWithdrawalFromUnusedBalance: 'Kullanılmayan Bakiyeden Para Çekilmesine İzin Ver',
    allowWithdrawalFeeUsedBalance: 'Para Çekme Ücreti kalan bakiyeden yapılacaktır.',
    feeCalculationForWithdrawals: 'Para Çekme Ücreti Hesaplama',
    feeFromWithdrawals: 'Para Çekme Ücreti',
    feeFromWithdrawalsUsedBalance: 'Para Çekme Ücreti (Kullanılmış Bakiye)',
    feeFromWithdrawalsBalance: 'Para Çekme Ücreti ({{type}} Bakiyesi)',
    unusedBalanceInfo: "Etkinleştirildiğinde, 'Para Çekme Ücreti' ayarında 'Kullanılmayan' bakiye seçeneği görünecektir.",
    paymentTransactionType: 'Ödeme İşlem Türü',
    paymentMethodType: 'Ödeme Yöntemi Türü',
    playerPaymentRelation: 'Oyuncu-Ödeme İlişkisi',
    failedPaymentAttempts: 'Başarısız Ödeme Girişimleri',
    failedPaymentAttemptsPeriod: 'Başarısız Ödeme Girişimleri Dönemi',
    temporaryBlockPeriod: 'Geçici Blok Dönemi',
    reverseConversion: '‎{{title}} Ters Dönüşüm',
    lCustomScript: 'özel komut dosyası',
    largeTransactions: 'Büyük işlemler',
    lBrand: 'marka',
    playerSettings: 'Oyuncu ayarları',
    verificationConfigurations: 'Doğrulama yapılandırmaları',
    theCurrency: 'Para Birimi',
    mainCountry: 'Ana Ülke',
    theLanguage: 'Dil',
    smsSettings: 'SMS ayarları',
    verificationSettings: 'Doğrulama ayarları',
    smtpSettings: 'SMTP ayarları',
    captchaSettings: 'Captcha ayarları',
    theEmail: 'E-mail',
    conversions: 'Dönüşümler',
    theConversion: 'Dönüşüm',
    theCountry: 'Ülke',
    playerVerificationSettings: 'Oyuncu doğrulama ayarları',
    domainRedirectionRule: 'Domain yeniden yönlendirme kuralı',
    wageringActivities: 'Çevrim Aktiviteleri',
    theSportsBook: 'Spor Bahis Platformu',
    sportsBook: 'Spor Bahis Platformu',
    theSportsBookView: 'Spor Bahis Platformu Görünümü',
    setMainView: 'Ana Görünümü Ayarla',
    feeForWithdrawalsWillBeHeld: 'Para Çekme Ücreti kalan bakiyeden yapılacaktır.',
    brandName: 'Marka Adı',
    defaultCountry: 'Varsayılan Ülke',
    defaultLanguage: 'Varsayılan Dil',
    defaultCurrency: 'Varsayılan Para Birimi',
    products: 'Ürünler',
    websiteTemplate: 'Web Sitesi Şablonu',
    failedPaymentInfo: '‎"Başarısız Ödeme Prosedürü" standardının etkin olmaması nedeniyle yapılandırmalar kullanılamıyor. Lütfen "Standartlar" bölümünden etkinleştirin.',
    depositWithdrawalPaymentMethodInfo:
      'Dönüşüm kullanan ödeme yöntemleri, değişiklik durumunda etkilenecektir ve yeni değişikliklerle çakışması durumunda sistem tarafından özel min/maks limitleri sıfırlanabilir. Ödeme yöntemleri ayarlarında para birimlerinin limitlerini ve kullanılabilirliğini gözden geçirdiğinizden emin olun.',
    otherPaymentMethodInfo: 'Dönüştürmeyi kullanan dâhili işlevler bu dönüştürme oranlarını kullanır. Tüm dönüşümlerin yerinde olduğundan emin olun (ör. Referans Bonusu).',
    conversionSettingsInfo: 'Geçerli limit, sistem/sistem tarafından dönüştürülmüş limitle çakışıyor.',
    card: 'Kart',
    imageAlt: 'Resim Alt',
    recommendedSize: 'Önerilen boyut',
    stateOrRegion: 'Şehir/Bölge',
    socialLinks: 'Sosyal Bağlantılar',
    socialLinkInfo: 'Şirketin Facebook, Twitter, Google+, Instagram, Youtube, LinkedIn, Wikipedia gibi farklı kaynaklardaki profil sayfaları. Dilediğiniz kadar URL ekleyebilirsiniz.',
    content: 'İçerik',
    image: 'Resim',
    depositPaymentCategory: 'Para Yatırma Ödeme Kategorisi',
    withdrawalPaymentCategory: 'Para Çekme Ödeme Kategorisi',
    createNewBrand: 'Yeni Marka Yarat',
    accountId: 'Hesap ID',
    allowWithdrawalViaTheDepositedMethods: 'Yalnızca para yatırmak için kullanılan yöntemlerle para çekme işlemlerine izin ver',
    allowWithdrawalViaTheDepositedMethodsInfo: 'Bu ayarı etkinleştirmek, oyuncunun daha önce hiç para yatırmadığı marka yöntemleriyle para çekmesini kısıtlar',
    lConversion: 'dönüşüm',
    schemaMarkupSettings: 'Schema Markup ayarları',
    accountIdInfo: "Hizmet Hesabı ID'si ile ilişkili olan herhangi bir kimlik adı veya kodu, belirli bir erişim düzeyi sağlar",
    ranges: 'Aralıklar',
    depositAmountRanges: 'Para Yatırma Tutar Aralığı (Tutardan - Tutara)',
    taxPercentage: 'Vergi Yüzdesi %',
    lTaxes: 'vergiler',
    withdrawalAmountRanges: 'Para Çekme Tutar Aralığı (Tutardan - Tutara)',
    fixedAmountOrPercent: 'Sabit Tutar veya Vergi Yüzdesi',
    spotsBookJackpotDescription: "Etkinleştirildiğinde Spor Jackpot Widget'ı Açılış Sayfasında görünür",
    spotsBookScrollingTypeDescription: 'Ayar sadece Standart Görünüm için uygulanır ve etkinleştirildiğinde Spor sayfası tek kaydırma ile bütünüyle kaydırılabilir',
    spotsBookTournamentBalanceDescription: 'Etkinleştirildiğinde, turnuva bakiyesi Web Sitesi Ana Sayfasında görünür ',
    sportJackpot: 'Spor Jackpot',
    sectionsScrolling: 'Bölüm Kaydırma',
    sportTournamentBalance: 'Spor Turnuvası Bakiyesi',
    iframe: 'Iframe',
    native: 'Yerel',
    sportsBookIframeIntegrationDescription: 'Spor bahisleri inline frame olarak sunulacak',
    sportsBookNativeIntegrationDescription: 'Spor bahisleri doğrudan uygulama içi bir yapıda sunulacak',
    sportsBookMobileIntegrationType: 'Mobil Entegrasyon Türü',
    setAsDefault: 'Varsayılan olarak ayarla',
    configs: 'Konfigürasyonlar',
    availableLayouts: 'Mevcut Düzenler',
    setAmountRangesInfo:
      "Bir aralık için hem 'Sabit Tutar' hem de 'Vergi Yüzdesi' ayarlanırsa, sistem vergiyi şu şekilde hesaplar: sabit bir vergi tutarı + aralığın 'Tutardan' kısmında belirtilen miktarı geçen tutarın x yüzdesi.",
    depositAmountRangesHint: "Para Yatırma Tutarı Aralığı'nın' 'Tutardan' alanındaki tutar bu aralığa dahil edilirken, 'Tutara' alanındaki tutar aralığa dahil edilmez.",
    withdrawalAmountRangesHint: "Para Çekme Tutarı Aralığı'nın' 'Tutardan' alanındaki tutar bu aralığa dahil edilirken, 'Tutara' alanındaki tutar aralığa dahil edilmez.",
    fixedAmountHint:
      "Sabit Tutar' alanındaki tutar, 'Para Yatırma Tutar Aralığı'nın 'Tutardan' alanına girilen tutardan düşük veya eşit olmalıdır. 'Tutardan' alanındaki tutar 0 ise, 'Sabit Tutar' alanındaki tutar da 0 olmalıdır.",
    fixedAmount: 'Sabit Tutar',
    brandSportsBookActivation:
      'Spor Bahisleri etkinleştirildiğinde, 65+ spor için canlı ve maç öncesi etkinlikleri içeren özelleştirilebilir arayüze erişebileceksiniz. Ürün etkinleştirildiğinde yalnızca Spor bahisleri yönetici panelinden devre dışı bırakılabilir.',
    amountFrom: 'Tutardan',
    allowPlayerCompose: 'Oyuncuların Mesaj "Oluşturmasına" İzin Ver',
    sportsBookInheritWebsiteColor: 'Web Sitesi Rengini Devam Ettir',
    sportsBookInheritWebsiteColorDescription: 'Bu ayar tüm spor sayfaları için geçerlidir.',
    theBrand: 'Marka',
    taxSettings: 'Vergi ayarları',
    infoUrlHint: 'Bu URL, vergi detaylarını görüntülemek için web sitesinde kullanılacaktır.',
    everyMatrixDescription: 'Cesur fikirleri hayata geçirmek için tasarlanmış modüler ve API odaklı iGaming çözümleri',
    smarticoAffiliateDescription: 'There is no better way to connect with your customers',
    hotjarDescription: 'Kullanıcıların sayılara takılmak zorunda kalmadan sitenizi gerçekten nasıl kullandığını anlayın',
    hotjarId: 'HotJar ID',
    googleAnalyticsDescription: 'Web sitelerinizde kullanımı analiz edin',
    googleSiteVerificationCode: 'Google site doğrulama kodu',
    googleSearchConsoleDescription: "Google'daki arama sonuçlarında web sitenizin durumunu izlemek, bakımını yapmak ve sorunlarını gidermek için yardım alın.",
    copyPasteFieldName: '{{fieldName}} kopyalayın ve aşağıdaki alana yapıştırın.',
    learnMore: 'Daha fazlası...',
    affiliateInfo: '{{count}} entegrasyonları aynı anda aktif olamaz',
    liveChatDescription: 'Online iletişim uygulaması, sizin ve web sitenizin ziyaretçilerinin gerçek zamanlı olarak sohbet etmesini sağlar',
    liveAgentDescription: 'Mükemmel müşteri hizmeti sağlar',
    intercomDescription: 'Mükemmel müşteri ilişkilerine buradan başlayın',
    zendeskDescription: 'Müşterilerinizle daha verimli iletişim kurun',
    intercomId: 'Intercom ID',
    zendeskId: 'Zendesk ID',
    liveChatLicenseNumber: 'LiveChat LICENSE_NUMBER',
    liveAgentYourLa: 'LiveAgent YOUR-LA',
    liveAgentButtonID: 'LiveAgent button ID',
    digitainAgIdInfo: 'Bu, "Digitain Acentesi" yönetici panelindeki Markanın ID\'sidir',
    depositCurrencyInfo:
      'Oyuncuların ödeme yöntemleriyle desteklenen tüm para birimleriyle para yatırmalarına izin verilmesi için, ödeme yöntemi için desteklenen para birimi yapılandırmaları ile "Dönüştürmeye İzin Ver" etkinleştirilmelidir.',
    pageGroups: 'Sayfa Grupları',
    digitainRetailInfo: "Bu, 'Digitain Perakende' yönetici panelindeki Markanın ID'sidir",
    smarticoDescription: 'Oyuncuları motive etmek için mücadele ve oyun tekniklerini kullanan oyunlaştırma çözümü',
    smarticoLabelKey: 'Etiket Anahtarı',
    brandKey: 'Marka Anahtarı',
    smarticoBrandKeyInfo: 'Marka için genel anahtar',
    smarticoLabelKeyInfo: 'Etiket için genel anahtar',
    smarticoNote: 'Smartico CRM ve Oyunlaştırma birbiriyle bağlantılıdır, bu bölümdeki her eylemin Oyunlaştırma üzerinde de etkisi vardır',
    realityCheckPeriod: 'Gerçeklik Kontrolü Dönemi',
    timeOut: 'Zaman Aşımı',
    spotsBookPrematchTopMatchesDescription: "Etkinleştirildiğinde En İyi Maçlar Widget'ı Spor Bahisleri Iframe'inde ve Açılış Sayfasında kullanılabilir hale gelir",
    googleAnalyticsId: 'Google Analitik ID',
    prematchTopMatches: 'Maç Öncesi En İyi Maçlar',
    prematchTotalTopMatches: 'Maç Öncesi En İyi Maçlar (Toplam Pazar Dahil)',
    spotsBookPrematchTotalTopMatchesDescription: "Etkinleştirildiğinde Toplam Pazar Verilerini ile Maç Öncesi En İyi Maçlar Widget'ı kullanılabilir hale gelir",
    livePrematchTopMatches: 'Canlı & Maç Öncesi En İyi Maçlar',
    spotsBookLivePrematchTopMatchesDescription: 'Canlı ve Maç Öncesi En İyi Maçlar Etkinleştirildiğinde Widget kullanılabilir ',
    liveTopMatches: 'En İyi Canlı Maçlar',
    spotsBookLiveTopMatchesDescription: 'En İyi Canlı Maçlar Etkinleştirildiğinde Widget kullanılabilir',
    periodCalculationSource: 'Dönem Hesaplama Kaynağı',
    periodCalculationSourceInfo: 'Doğrulama dönemi hesaplamasının başlayacağı tarih kaynağını seç',
    verificationPeriod: 'Doğrulama dönemi',
    verificationPeriodInfo: ' Oyuncu hesabının doğrulanmadan önce etkin olabileceği gün sayısı',
    unverifiedPlayersExclusionsInfo:
      "Para Yatırma Doğrulamasını Dikkate Almayan Ödemeler' menüsünde bir ödeme yöntemi seçildiğinde ve 'Maksimum Para Yatırma Tutarları' bölümünde limitler belirlendiğinde, limitler bu ödeme yönteminden etkilenmez.",
    responsibleGamingPeriodLimitsInfo: 'Bu bölümde, oyuncunun zaman aşımı ve kendi hariç tutma için seçebileceği belirli bir süre ayarlayabilirsiniz.',
    preferencesDescription: 'Oyuncular için SMS, E-posta ve Anlık Bildirimlerin etkinleştirilmesi/devre dışı bırakılması.',
    preferencesSMSDescription: 'Markanın tüm oyuncuları için SMS gönderimi ve web sitesinde SMS bölümünün görünmez olması',
    preferencesEmailDescription: 'E-mail sending for all the players of the brand and on the website Via E-mail part should become invisible',
    walletsSettings: 'Cüzdan Ayarları',
    wallets: 'Cüzdanlar',
    features: 'Özellikler',
    dda: 'DDA',
    ddaInfo: 'Bu seçenek etkinleştirildiğinde, para çekme işlemine ilişkin vergiler DDA kapsamında kesilir',
    whatsAppDescription: 'Müşterilerinizin dünyanın en popüler mesajlaşma aracını kullanarak sizinle iletişime geçmesini sağlayın.',
    phoneNumber: 'Telefon Numarası',
    whatsAppPhoneNumberInfo: 'WhatsApp hesabınızın kayıtlı olduğu telefon numarasını girin',
    multiGameLaunch: 'Çoklu Oyun başlatma',
    multiGameLaunchDescription: 'Yapılandırmaya bağlı olarak, çoklu oyun seçeneği web sitesinde mevcuttur ve oyuncular aynı anda birden fazla oyun oynayabilir',
    jackpotWidget: "Jackpot Widget'ı",
    jackpotWidgetDescription: "Açılış Sayfası için Casino Jackpot Widget aktivasyonunu ifade eder. Amusnet Sağlayıcı Jackpot Widget'ı için kullanılabilir.",
    gameIframe: "Oyun Iframe'i",
    manuBarFixation: 'Menü Çubuğu Sabitleme',
    manuBarFixationDescription: 'Yalnızca mobil görünüm için, yapılandırmaya bağlı olarak Ana Çubuk lobiler için sabitlenir.',
    paymentVisibilityInfo: 'Bu bölümde, seçilen etiketlerden birine sahip olan oyuncular için ödeme yöntemi kullanımını gizleyebilir veya izin vermeyebilirsiniz',
    centrivoConnectAgDescription: "Centrivo'nun Connect Acente Çözümü ile iGaming İşinizi Geliştirin",
    retailCentrivoDescription: "Centrivo'nun Perakende Çözümü ile iGaming İşinizi Geliştirin",
    currencySymbol: 'Para Birimi Sembolü',
    preferencesPushNotificationsDescription: 'Anında Bildirimler kanalı Marka için bildirim göndermek için kullanılabilir hale gelir',
    currencyFormat: 'Para Birimi Formatı',
    currencyFormatInfo: 'Oyuncular için web sitesinde hangi Para Birimi formatı gösterilir.',
    isoCode: 'ISO Code',
    symbols: 'Semboller',
    digitainCrmDescription: 'CRM çözümü, mevcut oyuncuların bağlılığını sürdürmek ve genel memnuniyetlerini artırmak için tasarlanmıştır',
    accessDecreaseLimit: 'Erişim Limiti',
    depositOnNegativeBalance: 'Negatif Bakiyeye Para Yatırma',
    depositOnNegativeBalanceInfo: 'Para yatırma onayından sonra, borcun kapatılması için oyuncunun negatif cüzdanında ayarlama yapılır.',
    digitainAffiliateDescription: 'Affiliate programınızı etkinleştirin ve web sitenizin trafiğinde ciddi bir artış sağlayın.',
    projectId: 'Proje ID',
    projectIdInfo: 'Bu, "Digitain Affiliate" yönetici panelindeki Proje ID\'sidir',
    brandIdInfo: 'Bu, "Digitain Affiliate" yönetici panelindeki Markanın ID\'sidir',
    maintenanceSetup: 'Bakım kurulumu',
    maintenancePeriod: 'Bakım Süresi',
    sportsBookViews: 'Spor Bahisleri Görünümleri',
    mandatoryNotification: 'Zorunlu Bildirim',
    mandatoryNotificationInfo: 'Web sitesinde oturum açan oyuncular için zorunlu pop-up',
    lossDecreaseLimit: 'Kayıp Limiti',
    inactivityIndicators: 'Etkin Olmama Göstergeleri',
    inactivityIndicatorsInfo:
      'Bu yapılandırma, oyuncunun son giriş tarihi veya son işlem (bahis, para yatırma, para çekme) tarihi gibi çeşitli göstergelerden birine göre aktif olmayan bir oyuncu olarak değerlendirilir',
    recoverByPlayer: 'Oyuncuya Göre Kurtar',
    recoverByPlayerInfo: 'Etkinleştirildiğinde, oyuncular doğrulama kodu aracılığıyla kendilerini kurtarabilir',
    singleBetDecreaseLimit: 'Tekli Bahis Limiti',
    cashierType: 'Kasiyer Türü',
    lIcon: 'simge',
    gameLaunchType: 'Oyun Başlatma Türü (Mobil görünüm)',
    gameFullScreenLaunchDescription: 'Oyun tam ekranda iframe ile açılır',
    gameHeaderFooterLaunchDescription: 'Oyunlar iframe, üstbilgi ve altbilgi ile açılır',
    gameQuickActionBarLaunchDescription: 'Oyunlar hızlı eylemler çubuğu ile açılır',
    limitEffectConfigs: 'Limit Efekt Yapılandırmaları',
    ignoreFirstDeposit: 'İlk Para Yatırmayı Yoksay',
    ignoreFirstDepositHint: 'Bu seçenek seçilirse, oyuncunun ilk ömür boyu başarılı para yatırma işlemi sorumlu oyun para yatırma limitinde hesaplanmaz',
    periodLimit: 'Dönem Limiti',
    playerLimitsConfiguration: 'Oyuncu Limitleri yapılandırması',
    alanbaseDescription: 'iGaming ve affiliate pazarlama uzmanları tarafından hazırlanmış, maliyetlerinizi optimize etmenize ve kârınızı artırmanıza yardımcı olan bir platform.',
    routForEvents: 'Etkinlikler İçin Rota',
    routForGoals: 'Hedefler için Rota',
    fastDepositPaymentMethod: 'Hızlı Para Yatırma Ödeme Yöntemi',
    fastDepositPaymentMethodInfo: "Hızlı Para Yatırma, web sitesinde oyuncuların oyun sayfasından çıkmadan 'Centrivo'dan önceden tanımlanmış ödeme yöntemiyle para yatırabilecekleri bir işlevdir.",
    sportStatusIconsInfo: 'Yüklenen simgeler oyuncunun web sitesindeki profilinde görülebilir. Yüklenen her simge en fazla bir saat sonra web sitesine yansır.',
    rolloverBetsReturn: 'Rollover Bahisler Aynı Cüzdana Geri Döner',
    rolloverBetsReturnInfo: 'Rollover bakiyesinden yapılan bahsin iade/iptal edilmesi durumunda tutar rollover bakiyesine aktarılır',
    maxDepositAmounts: 'Maksimum Para Yatırma Tutarları',
    paymentsIgnoringDepositVerification: 'Para Yatırma Doğrulamasını Yok Sayan Ödemeler',
    selfExclusion: 'Kendini Hariç Tutma',
    setMainDomain: 'Ana Domain Ayarla    ',
    disconnected: 'Bağlantı Kesildi',
    configureLimits: 'Limitleri Yapılandır',
    metaMapDesc: 'Müşterilerinizi doğrulamak için ihtiyacınız olan her şey tek bir platformda',
    clientId: 'Müşteri Id ',
    clientIdInfo: 'Sizi bir bayi olarak tanımlamak için kullanılır.',
    clientSecret: 'Müşteri Gizli ',
    clientSecretInfo: "Dashboard'dan alınan müşteri gizli anahtarını şifreniz olarak kullanın.",
    pushGameState: 'Oyun Durumunu Gönder',
    pushGameStateDescription: "Bu yapılandırma, agregatör tarafından Back Office'e gönderilen oyunların durumunu (“Oyun Durumu”) tanımlar.",
    thunderBiteDescription: 'Müşteri deneyimini oyunlaştırın ve etkileşimi sadakate dönüştürün.',
    campaignURL: 'Kampanya URL',
    captchaCaseInsensitiveInfo: 'Captcha seçeneğini etkinleştirerek, sistem büyük ve küçük harfleri ayırt etmez ve bunları aynı kabul eder.',
    caseInsensitive: 'Büyük/küçük harf duyarlılığı yok',
    verificationRequestPeriod: 'SMS/E-posta Doğrulama Talep Süresi',
    verificationRequestPeriodInfo: 'Config, oyuncuya bir sonraki SMS/E-posta doğrulama isteğinin ne zaman gönderileceğini tanımlar.',
    sec: 'saniye',
    integratedDate: 'Entegre Tarih',
    integratedBy: 'Entegre Eden',
    isInvisible: 'Görünmez',
    captchaInvisibleInfo: 'İşaretlendiğinde, captcha oyuncular tarafından görünmez olacaktır.',
    captchaLogonAttemptsInfo: "Başarısız oturum açma denemelerinin sayısını, bu denemelerin sayılacağı süreyi ve CAPTCHA'nın görüneceği süreyi tanımlayın.",
    jackpot: 'Jackpot',
    globalState: 'Global Durum',
    jackpotGames: 'Jackpot Oyunları',
    myAffiliatesDescription: 'Piyasadaki en esnek affiliate izleme yazılımı',
    sportDomainsTabInfo: "Maksimum spor domain sayısı {{count}}'dir. Yalnızca aktif domainler Ana olarak ayarlanabilir. Yalnızca doğrulanmış domainler bağlanabilir.",
    firebaseAuthenticationDescription: 'Firebase ile kullanıcı kaydı ve oturum açma kimlik doğrulaması için sosyal medya platformlarını yapılandırın.',
    frontend: 'Ön uç',
    backend: 'Arka uç',
    google: 'Google',
    facebook: 'Facebook',
    socialMediaPlatforms: 'Sosyal Medya Platformları',
    optimoveDescription: 'Mevcut oyuncuların ilgisini sürdürmek ve genel memnuniyetlerini artırmak için tasarlanmış CRM çözümü.',
    baseUrl: 'Temel URL',
    forcePasswordChangeNote:
      'Bu seçeneği etkinleştirdiğinizde, oyuncular belirlenen süre geçtikten sonra şifrelerini değiştirmek zorundadır. Şifre Hatırlatma süresi geçtikten sonra, bu seçenek etkinleştirilmişse oyuncular şifrelerini değiştirmeden web sitesine giriş yapamazlar.',
    forcePasswordChange: 'Şifre Değişikliğini Zorla',
    playerTags: 'Oyuncu Etiketleri',
    additional: 'Ek',
    gameTimeLimit: 'Oyun Süresi Limiti',
    verificationOptions: 'Doğrulama Seçenekleri',
    blockActions: 'Eylemleri Engelle',
    userNotification: 'Kullanıcı Bildirimi',
    winAmounts: 'Kazanç Tutarı',
    largeWinTransactionNotification:
      'Büyük Kazanç işlem bildirimi yalnızca seçilen kullanıcılara gönderilecektir. Herhangi bir kullanıcı seçilmesi durumunda, Kazanç tutarının tüm döviz türleri için yapılandırıldığından emin olun.',
    promptOnLogin: 'Giriş Sorgulaması',
    promptOnLoginInfo: 'Bu seçeneği seçen oyuncuların, ilk girişlerinde limitlerini belirlemeleri gerekecektir.',
    productCategory: 'Ürün Kategorisi',
    betProfitRange: 'Bahis Kar Aralığı (Başlangıç - Bitiş)',
    betProfitRangeHint: '“Bahis Kar Aralığı”nın ‘Başlangıç’ alanındaki tutar bu aralığa dahil edilirken, “Bitiş” alanındaki tutar aralığa dahil edilmez.',
    betTaxInfo: "Tercih edilen vergi hesaplama yöntemine göre, tek bir ‘Ürün Kategorisi’ 'Kümülatif' veya ‘İşlem Başına’ vergi türüne atanabilir.",
    betTaxStandardDisabledInfo: 'Markanızın vergi motorunu etkinleştirmek için ‘Vergilendirme’ ve ‘Bahis Karı Vergisi’ seçeneklerini etkinleştirin.',
    depositTaxStandardDisabledInfo: 'Markanızın vergi motorunu etkinleştirmek için ‘Vergilendirme’ ve ‘Para Yatırma Vergisi’ seçeneklerini etkinleştirin.',
    withdrawalTaxStandardDisabledInfo: 'Markanızın vergi motorunu etkinleştirmek için ‘Vergilendirme’ ve ‘Para Çekme Vergisi’ seçeneklerini etkinleştirin.',
    registrationUniqueness: 'Kayıt Benzersizliği',
    registrationUniquenessNote: 'Seçilen kombinasyonun benzersizliği, oyuncu kaydı sırasında doğrulanmalıdır.',
    responsibleGamingLimitsInfo:
      'Bu bölümde, kurulum sırasında varsayılan limitler olarak otomatik olarak doldurulacak ancak manuel olarak ayarlanabilecek önceden tanımlanmış değerler belirleyebilirsiniz. Oturum açma sırasında uyarı, oyuncuların limiti belirlemelerini gerektirecek şekilde etkinleştirilebilir/devre dışı bırakılabilir.',
    hours: '{{number}} saat',
    days: '{{number}} gün',
    month: '{{number}} ay',
    year: '{{number}} yıl',
    viewDefaultAmount: 'Varsayılan Tutarı Görüntüle',
    viewDefaultLimit: 'Varsayılan Limiti Görüntüle',
    realTimeUniquenessCheck: 'Gerçek Zamanlı Benzersizlik Kontrolü',
    realTimeUniquenessCheckNote:
      'Bu özelliği etkinleştirdiğinizde, sistem kayıt işlemi sırasında cep telefonu numarasını, kimlik numarasını ve e-posta adresini anında benzersizlik açısından kontrol eder.',
    appToken: 'Uygulama Tokeni',
    accountVerificationOptions: 'Hesap Doğrulama Seçenekleri',
    accountVerificationOptionsInfo: 'Oyuncu hesabının doğrulanmış olarak kabul edileceği seçenekleri seçin',
    markAsUnverified: 'Doğrulanmamış Olarak İşaretle',
    markAsUnverifiedInfo: 'Etkinleştirildiğinde, oyuncular belirlenen kurallara göre doğrulanmamış olarak işaretlenecektir.',
    verificationPeriodTabInfo: {
      text1: 'Bu bölümde, belirli bir süre sonra doğrulanmamış oyuncuları otomatik olarak engellemek için kurallar belirleyebilirsiniz.',
      text2:
        'Oyuncular, Doğrulama Yapılandırması bölümünde tanımlanan gerekli doğrulama adımlarını tamamlamamışlarsa doğrulanmamış olarak kabul edilir. Seçilen doğrulamayı geçen oyuncular doğrulanmış olarak kabul edilir. Doğrulama yapılmadığında, oyuncular doğrulanmamış oldukları için engellenmiş olarak işaretlenir.',
    },
    notificationReminder: 'Bildirim Hatırlatıcısı',
    notificationReminderInfo: 'Oyuncunun hesabı doğrulaması için hatırlatma yapılacağı gün sayısı',
    blockForUnVerify: 'Doğrulanmamış İçin Engelle',
    blockForUnVerifyOptions: 'Doğrulanmamış Seçenekler İçin Engelle',
    betOddsLimit: 'Bahis Oranı Limiti',
    betOddsLimitInfo:
      'Bahis, belirtilen orandan daha düşük bir oranla yapıldığında, kazanılan tutar, bahsin yapıldığı cüzdanlar (kullanılan ve kullanılmayan) arasında orantılı olarak dağıtılacaktır.',
    selfExclusionReason: 'Kendini Hariç Tutma Nedeni',
    selfExclusionReasonInfo: 'Sebep seçilirse, oyuncu belirtilen sebepleri seçerek hesabına kendi kendini hariç tutma ayarı yapamaz.',
    balanceVisibility: 'Bakiye Görünürlüğü',
    balanceVisibilityNote: 'Seçilen bakiyeler marka oyuncuları tarafından görülebilir olacaktır.',
    configured: 'Yapılandırıldı',
    limitEffectPeriodInfo:
      "Değişiklikler, belirlenen bir süre sonra (hemen, 24 saat, 48 saat veya 7 gün) veya bir sonraki takvim döneminin başlangıcında (günlük limitler için gece yarısı, haftalık limitler için Pazartesi, aylık limitler için ayın 1'i) geçerli olur.",
    documentsConfig: 'Belgeler Yapılandırması',
    documentsConfigInfo: "Aşağıdaki belge türleri için gerekli sayfa sayısı her zaman 1'dir.",
    pageCount: 'Sayfa Sayısı',
    realityCheckSettings: 'Gerçeklik Kontrolü Ayarları',
    calculationType: 'Hesaplama Türü',
    realityCheckInterval: 'Gerçeklik Kontrol Aralığı',
    showLogOutButton: 'Oturumu Kapat Düğmesini Göster',
    realityCheckSettingsInfo: 'Yapılandırmalar, Standartlar bölümünde Gerçeklik Kontrolü etkinleştirildiğinde geçerli olacaktır.',
    realityCheckStatus: 'Gerçeklik Kontrol Durumu',
    realityCheckPeriodInfo: 'Bu süreler, oyuncunun web sitesindeki hesabında görünecektir.',
    realityCheckIntervalInfo: 'Oyunculara gösterilen Gerçeklik Kontrolü açılır penceresi arasındaki zaman aralığını tanımlar.',
    capitalizePlayerData: 'Oyuncu Verilerini Büyük Harfle Yazar',
    capitalizePlayerDataInfo: 'Bu özelliği etkinleştirdiğinizde, sistem kayıt işlemi sırasında Ad/Soyad, Adres ve Şehir alanlarını büyük harfle yazacak ve bunları arka ofiste kaydedecektir.',
    blockedCountriesInfo:
      'Eylem (engellemeyi kaldırma, tam engelleme, oturum açma için engelleme, kayıt için engelleme, oturum açma ve kayıt için engelleme) ülke bazında tek tek veya toplu olarak uygulanabilir ve durumları aynı anda güncellenebilir.',
    bulkAction: 'Toplu İşlem',
    multiPeriodLimitType: 'Çoklu Dönem Limit Türü',
    singlePeriodLimitType: 'Tek Dönem Limit Türü',
    changeEffectPeriods: 'Etki Sürelerini Değiştirin',
    lastMonthPeriod: 'Geçen Ay Dönemi',
    eddVerificationNotification: 'EDD yapılandırmaları, Nitelikli Oyuncular için Fon Kaynağı doğrulamasını tetikleyecektir.',
    totalDepositAmount: 'Toplam Para Yatırma Tutarı',
  },
  ru: {
    mainCurrency: 'Основная валюта',
    mainLanguage: 'Основной язык',
    market: 'Маркет',
    setMainCountry: 'Задать основную страну',
    setMainCurrency: 'Задать основную валюту',
    setMainLanguage: 'Задать основной язык',
    redirectedTo: 'Перенаправлен на',
    onlyVerifiedDomainInfo: 'Могут быть подключены только подтвержденные домены',
    disconnectDomain: 'Отключить домен',
    connectDomain: 'Подключить домен',
    deleteDomain: 'Удалить домен',
    deleteScript: 'Удалить скрипт',
    deactivateScript: 'Деактивировать скрипт',
    activateScript: 'Активировать скрипт',
    supportedCurrencies: 'Поддерживаемые валюты',
    supportedCountries: 'Поддерживаемые страны',
    supportedLanguages: 'Поддерживаемые языки',
    providerDisableInfo: 'Возможно, провайдер отключен для всей системы',
    activity: 'Действие',
    verificationAnd: 'Верификация (и)',
    verificationOr: 'Верификация (или)',
    andDelimiter: 'и',
    currencyFrom: 'Из валюты',
    currencyTo: 'В валюту',
    reverseRate: 'Обратный курс',
    feature: 'Особенность',
    otherTransactions: 'Другие операции',
    playersNotifiedDate: 'Дата уведомления',
    depositProcessingType: 'Вид обработки депозитов',
    withdrawalProcessingType: 'Вид обработки вывода средств',
    allowedActivities: 'Разрешенные действия',
    depositSupportedCurrencies: 'Поддерживаемые валюты для депозитов',
    withdrawalSupportedCurrencies: 'Поддерживаемые валюты для вывода средств',
    newFee: 'Новая комиссия (%)',
    feeBefore: 'Прежняя комиссия (%)',
    newLimit: 'Новый лимит',
    statusDisabledInfo: 'Сайт станет недоступен со всех доменов.',
    statusActivitiesDisabledInfo: 'Новые ставки приниматься не будут.',
    statusVersionNamesDisabledInfo: 'Ставки будут отключены для выбранных версий.',
    timezoneInfo: 'Все текущие расчеты, связанные с часовым поясом, будут изменены.',
    domainRedirection: 'Перенаправление домена',
    uVerify: 'ВЕРИФИКАЦИЯ',
    redirect: 'Перенаправить',
    forwardingURL: 'Перенаправление URL',
    destinationURL: 'Целевой URL',
    domainRedirectInfo: 'Домен, используемый в качестве перенаправления или целевого URL, не может быть удален без удаления существующего правила.',
    registerDomainInfo: 'Необходимо зарегистрировать все свои домены в учетной записи Google, чтобы включить капчу для всех них.',
    ageRestriction: 'Ограничения по возрасту',
    passwordPattern: 'Шаблон пароля',
    failedAttemptsPeriod: 'Период неудачных попыток',
    lockPeriod: 'Период блокировки',
    passwordReminder: 'Подсказка пароля',
    inactivityPeriod: 'Период бездействия',
    securityPeriod: 'Период проверки безопасности',
    referralActivationPeriod: 'Период активации реферальной программы',
    passwordPatternNote:
      'Рекомендуется, чтобы пароли содержали не менее 8 символов, в том числе как минимум 1 цифру и 1 заглавную букву. Однако вы можете создать менее сложный пароль, используя от 6 до 20 букв латинского алфавита, цифр или специальных символов.',
    referralActivationPeriodNote: 'Период, в течение которого вы хотите хранить информацию об ID реферера при новой регистрации на сайте.',
    correspondingTranslations: 'Убедитесь, что все переводы соответствующим образом обновлены.',
    verificationCodeLength: 'Длина кода подтверждения',
    dailyMobileVerification: 'Ежедневные запросы на верификацию мобильного устройства',
    emailRequestsInDaily: 'Ежедневные запросы на верификацию электронной почты',
    expirationMinutes: 'Срок действия токена',
    expirationMinutesNote: 'Конфигурация определяет период, по истечении которого токен (код, ссылка) в уведомлении станет недействительным.',
    emailRequestsInDailyNote: 'Конфигурация определяет сколько запросов в день игрок может получить по электронной почте для верификации. Минимальное значение: {{value}}.',
    dailyMobileVerificationNote: 'Конфигурация определяет сколько запросов в день игрок может получить по SMS для верификации. Минимальное значение: {{value}}.',
    identityDocument: 'Документ, удостоверяющий личность',
    addressDocument: 'Документ, подтверждающий место жительства',
    additionalDocument: 'Дополнительный документ',
    disableSportBook: 'Отключить {{name}}',
    gameDisableTooltip: 'Возможно, игра отключена для всей системы',
    playerLimitInfo: {
      text1: 'Для каждого типа лимита вы можете установить период снижения строгости лимита.',
    },
    depositDecreaseLimit: 'Лимит на депозиты',
    betDecreaseLimit: 'Лимит на ставки',
    withdrawalDecreaseLimit: 'Лимит на вывод средств',
    activateSportsbook: 'Активировать Спортсбук',
    customScriptInfo: 'Вы можете интегрировать новые приложения или добавить другие функции на свой сайт, внедрив специальные скрипты.',
    scriptName: 'Название скрипта',
    insideHead: 'Внутри закрывающего тега </head>',
    insideBody: 'Внутри закрывающего тега </body>',
    headTag: 'скрипт для заголовка тега',
    bodyTag: 'скрипт для содержания тега',
    service: 'сервис',
    integrate: 'Интегрировать',
    showOnLive: ' Показать на действующем сайте',
    showOnLiveTitle: 'Когда вы отключите этот переключатель, иконка стороннего сервиса будет скрыта с главной страницы вашего сайта.',
    apiSecret: 'Секретный вопрос для API',
    apiSecretOrPass: 'Секретный вопрос для API или пароль',
    apiKeyOrUsername: 'Ключ API или имя пользователя',
    sendEmailVia: 'Отправить письмо через',
    smtpUser: 'Пользователь SMTP',
    smtpPass: 'Пароль SMTP',
    useSSL: 'Использовать SSL',
    smtpHost: 'Хост SMTP',
    smtpPort: 'Порт SMTP',
    emailsInfo: {
      text1: 'Некоторые SMTP-провайдеры требуют, чтобы у них был зарегистрирован тот же адрес электронной почты.',
      text2: 'Убедитесь, что вы выполнили это требование.',
    },
    emailsInfo1: 'Все запланированные сообщения с этим адресом электронной почты будут перемещены в черновики',
    blockCountries: 'Заблокировать страны',
    blockCountriesMainText: 'Сайт станет недоступен во всех выбранных странах',
    versionControl: 'Контроль версии',
    policies: 'Политики',
    policy: 'Политика',
    dateToNotify: 'Дата уведомления',
    featureName: 'Название функции',
    createBrand: 'Создать бренд',
    builder: 'Builder',
    platformState: 'Состояние платформы',
    minMaxWithdrawalAmount: 'Мин. – макс. сумма для вывода из системы',
    minWithdrawalAmount: 'Мин. сумма вывода средств',
    maxWithdrawalAmount: 'Макс. сумма вывода средств',
    minMaxDepositAmount: 'Мин. – макс. сумма депозита',
    minDepositAmount: 'Мин. сумма депозита',
    maxDepositAmount: 'Макс. сумма депозита',
    operationFeePercent: 'Операционная комиссия (%)',
    withdrawalFeePercent: 'Комиссия за вывод средств (%)',
    withdrawalFee: 'Комиссия за вывод средств',
    withdrawalFeeForUsedBalancePercent: 'Комиссия за вывод использованного остатка (%)',
    withdrawalFeeForUsedBalance: 'Комиссия за вывод использованного остатка',
    allowedConversion: 'Допустимая конвертация',
    paymentMethodName: 'Название способа оплаты',
    minAmount: 'Мин. сумма {{title}}',
    maxAmount: 'Макс. сумма {{title}}',
    minMaxSystemAmount: 'Мин. – макс. сумма {{title}} в системе',
    depositFeePercent: 'Комиссия за внесение средств (%)',
    depositFee: 'Комиссия за внесение средств',
    allowConversion: 'Разрешить конвертацию',
    previewLive: 'Предпросмотр в реальном времени',
    feeFromDeposit: 'Комиссия за депозит',
    allowWithdrawalFromUnusedBalance: 'Разрешить вывод средств из неиспользованного остатка',
    allowWithdrawalFeeUsedBalance: 'Комиссия за вывод будет удержана из остатка средств.',
    feeCalculationForWithdrawals: 'Расчет комиссии для вывода средств',
    feeFromWithdrawals: 'Комиссия за вывод средств',
    feeFromWithdrawalsUsedBalance: 'Комиссия за вывод средств (использованный остаток)',
    feeFromWithdrawalsBalance: 'Комиссия за вывод средств (остаток {{type}})',
    unusedBalanceInfo: 'При активации опция  «Неиспользованный» баланс появится в настройке «Комиссия за вывод средств».',
    paymentTransactionType: 'Вид платежной операции',
    paymentMethodType: 'Вид способа оплаты',
    playerPaymentRelation: 'Взаимосвязь между игроком и платежами',
    failedPaymentAttempts: 'Неудачные попытки оплаты',
    failedPaymentAttemptsPeriod: 'Период неудачных попыток оплаты',
    temporaryBlockPeriod: 'Период временной блокировки',
    reverseConversion: 'Обратная конвертация {{title}}',
    lCustomScript: 'специальный скрипт',
    largeTransactions: 'Крупные операции',
    lBrand: 'бренд',
    playerSettings: 'Настройки игрока',
    verificationConfigurations: 'Структуры проверки',
    theCurrency: 'Валюта',
    mainCountry: 'Основная страна',
    theLanguage: 'Язык',
    smsSettings: 'Настройки SMS',
    verificationSettings: 'Настройки верификации',
    smtpSettings: 'Настройки SMTP',
    captchaSettings: 'Настройки капчи',
    theEmail: 'Электронная почта',
    conversions: 'Конвертации',
    theConversion: 'Конвертация',
    theCountry: 'Страна',
    playerVerificationSettings: 'Настройки верификации игрока',
    domainRedirectionRule: 'Правило перенаправления домена',
    wageringActivities: 'Действия вейджеринга',
    theSportsBook: 'Спортсбук',
    sportsBook: 'Спортсбук',
    theSportsBookView: 'Вид Спортсбука',
    setMainView: 'Задать основной вид',
    feeForWithdrawalsWillBeHeld: 'Комиссия за вывод будет удержана из остатка средств.',
    brandName: 'Наименование бренда',
    defaultCountry: 'Страна по умолчанию',
    defaultLanguage: 'Язык по умолчанию',
    defaultCurrency: 'Валюта по умолчанию',
    products: 'Продукты',
    websiteTemplate: 'Шаблон сайта',
    failedPaymentInfo: 'Конфигурации недоступны из-за неактивности стандарта «Процедура обработки неудавшихся платежей». Активируйте его в разделе «Стандарты».',
    depositWithdrawalPaymentMethodInfo:
      'В случае изменений будут затронуты способы оплаты, использующие конвертацию, а также система может сбросить пользовательские минимальные / максимальные лимиты, если они противоречат изменениям. Обязательно проверьте лимиты и доступность валют в настройках способов оплаты.',
    otherPaymentMethodInfo:
      'Внутренние функции, использующие конвертацию, будут использовать эти коэффициенты конвертации. Убедитесь, что у вас указаны все варианты конвертации (например, реферальный бонус).',
    conversionSettingsInfo: 'Текущий лимит противоречит системному / конвертированному системой лимиту.',
    card: 'Карта',
    imageAlt: 'Альт. изображение',
    recommendedSize: 'Рекомендованный размер',
    stateOrRegion: 'Штат / регион',
    socialLinks: 'Социальные сети',
    socialLinkInfo:
      'Страницы компании на различных ресурсах, таких как Facebook, Twitter, Google+, Instagram, Youtube, LinkedIn, Wikipedia и т. д. Вы можете добавить столько URL-адресов, сколько пожелаете.',
    content: 'Контент',
    image: 'Изображение',
    depositPaymentCategory: 'Категория депозита средств',
    withdrawalPaymentCategory: 'Категория вывода средств',
    createNewBrand: 'Создать новый бренд',
    accountId: 'ID учетной записи',
    allowWithdrawalViaTheDepositedMethods: 'Разрешить снятие средств только посредством методов оплаты, которые использовались для депозита средств',
    allowWithdrawalViaTheDepositedMethodsInfo: 'Активация настройки запрещает игроку снимать деньги с помощью методов оплаты, которые он никогда раньше не использовал для депозита',
    lConversion: 'конвертация',
    schemaMarkupSettings: 'Настройки схемы',
    accountIdInfo: 'Любой ID имени или код, связанные с ID учетной записи сервиса, которые обеспечивает определенный уровень доступа',
    ranges: 'Диапазоны',
    depositAmountRanges: 'Диапазон суммы депозита (от - до)',
    taxPercentage: 'Процент налога %',
    lTaxes: 'налоги',
    withdrawalAmountRanges: 'Диапазон суммы вывода (от - до)',
    fixedAmountOrPercent: 'Фиксированная сумма или процент налога',
    spotsBookJackpotDescription: 'При включении виджет спортивного джекпота становится доступным на целевой странице',
    spotsBookPrematchTopMatchesDescription: 'При включении виджет Топ матчей становится доступным в Iframe Спортсбука и на целевой странице',
    spotsBookScrollingTypeDescription: 'Настройка применима только для стандартного вида, и когда она включена, спортивная страница полностью прокручивается одной прокруткой',
    spotsBookTournamentBalanceDescription: 'После включения баланс турнира становится доступным на главной странице сайта',
    sportJackpot: 'Спортивный джекпот',
    sectionsScrolling: 'Прокрутка разделов',
    sportTournamentBalance: 'Баланс спортивного турнира',
    iframe: 'Iframe',
    native: 'Нативный',
    sportsBookIframeIntegrationDescription: 'Спортсбук будет доступен в рамках встроенного фрейма',
    sportsBookNativeIntegrationDescription: 'Спортсбук будет доступен непосредственно во встроенном приложении',
    sportsBookMobileIntegrationType: 'Тип интеграции на мобильных устройствах',
    setAsDefault: 'Установить по умолчанию',
    configs: 'Конфигурации',
    availableLayouts: 'Доступные лэйауты',
    setAmountRangesInfo:
      'Если диапазоны установлены как «Фиксированная сумма» и «Процент налога», система расчитает комиссию следующим образом: удержать фиксированную сумму налога + x процентов от суммы, которая превышает сумму, указанную в поле «От» диапазона',
    depositAmountRangesHint: 'Сумма в поле «От» в «Диапазоне суммы депозита» включена в диапазон, тогда как сумма в поле «До» в диапазон не входит.',
    withdrawalAmountRangesHint: 'Сумма в поле «От» в «Диапазоне суммы снятия» включена в этот диапазон, тогда как сумма в поле «До» в диапазон не входит.',
    fixedAmountHint:
      'Сумма в поле «Фиксированная сумма» должна быть меньше или равна сумме, введенной в поле «От» в «Диапазоне суммы депозита». Если сумма в поле «От» равна 0, сумма в поле «Фиксированная сумма» также должна быть равна 0.',
    fixedAmount: 'Фиксированная сумма',
    brandSportsBookActivation:
      'Активировав продукт Спортсбук, вы получите доступ к настраиваемому интерфейсу с лайв и прематч событиями для более чем 65 видов спорта. После активации продукт можно деактивировать только из панели администратора Спортсбук.',
    amountFrom: 'Сумма от',
    allowPlayerCompose: 'Разрешить игрокам «составлять» сообщения',
    sportsBookInheritWebsiteColor: 'Использовать цвет веб-сайта',
    sportsBookInheritWebsiteColorDescription: 'Настройка применяется ко всем спортивным страницам.',
    theBrand: 'Бренд',
    taxSettings: 'Налоговые настройки',
    infoUrlHint: 'Этот URL-адрес будет использоваться на веб-сайте для отображения сведений о налогообложении.',
    everyMatrixDescription: 'Модульные решения в iGaming на основе API для реализации смелых идей',
    smarticoAffiliateDescription: 'Нет лучшего способа понять клиентов',
    hotjarDescription: 'Поймите, как пользователи на самом деле воспринимают ваш сайт, не утопая в цифрах.',
    hotjarId: 'ID HotJar',
    googleAnalyticsId: 'ID Google Analytics',
    googleAnalyticsDescription: 'Анализируйте пользовательскую активность на своих веб-сайтах',
    googleSiteVerificationCode: 'Код верификации сайта от Google',
    googleSearchConsoleDescription: 'Получите помощь по отслеживанию, обслуживанию и устранению неполадок, связанных с выдачей вашего веб-сайта в результатах поиска Google.',
    copyPasteFieldName: 'Скопируйте {{fieldName}} и вставьте его в поле ниже.',
    learnMore: 'Узнать больше…',
    affiliateInfo: '{{count}} интеграции не могут быть активны одновременно',
    liveChatDescription: 'Приложение для онлайн-общения, с помощью которого вы сможете общаться с пользователями в чате в режиме реального времени.',
    liveAgentDescription: 'Обеспечьте клиентам безупречное обслуживание',
    intercomDescription: 'Начните выстраивать отличные отношения с клиентами здесь',
    zendeskDescription: 'Общайтесь с клиентами эффективно',
    intercomId: 'ID Intercom',
    zendeskId: 'ID Zendesk',
    liveChatLicenseNumber: 'LiveChat LICENSE_NUMBER',
    liveAgentYourLa: 'LiveAgent YOUR-LA',
    liveAgentButtonID: 'Идентификатор кнопки LiveAgent',
    digitainAgIdInfo: 'ID Бренда в панели администратора «Digitain Agent»',
    depositCurrencyInfo:
      'В случае, если игрокам разрешено вносить депозиты поддерживаемыми способами оплаты во всех валютах , поле «Разрешить конвертацию» с конфигурациями поддерживаемых валют должно быть активно для выбранного способа оплаты.',
    pageGroups: 'Группы страниц',
    digitainRetailInfo: 'ID бренда в панели администратора «Digitain Retail»',
    smarticoDescription: 'Здесь используется геймификация с различными испытаниями и игровыми приемами для мотивации игроков',
    smarticoLabelKey: 'Ключ лейбла',
    brandKey: 'Ключ бренда',
    smarticoBrandKeyInfo: 'Открытый ключ для бренда',
    smarticoLabelKeyInfo: 'Открытый ключ для лейбла',
    smarticoNote: 'Smartico CRM и геймификация взаимосвязаны, каждое действие в этом разделе также влияет на геймификацию.',
    realityCheckPeriod: 'Частота напоминаний о времени, проведённом в игре',
    timeOut: 'Перерыв',
    prematchTopMatches: 'Прематч Топ-матчи',
    prematchTotalTopMatches: 'Прематч Топ-матчи (с учетом всего рынка)',
    spotsBookPrematchTotalTopMatchesDescription: 'При включении виджет Прематч Топ-матчи (с учетом всего рынка) становится доступным',
    livePrematchTopMatches: 'Топ-матчи в прямом эфире и прематче',
    spotsBookLivePrematchTopMatchesDescription: 'При включении виджет Топ-матчи в прямом эфире и прематче становится доступным',
    liveTopMatches: 'Топ-матчи в прямом эфире',
    spotsBookLiveTopMatchesDescription: 'При включении виджет Топ-матчи в прямом эфире становится доступным',
    periodCalculationSource: 'Источник расчета периода',
    periodCalculationSourceInfo: 'Выбрать источник даты, с которой начнется расчет периода верификации',
    verificationPeriod: 'Период верификации',
    verificationPeriodInfo: 'Количество дней, в течение которых аккаунт игрока может быть активен до верификации',
    unverifiedPlayersExclusionsInfo:
      'Если в меню «Платежи, которые не требуют верификации депозита» выбран способ оплаты, а в разделе «Максимальные суммы депозита» установлены лимиты, лимиты не будут действовать для этого способа оплаты.',
    responsibleGamingPeriodLimitsInfo: 'В этом разделе вы можете установить определенный период времени, который игрок может выбрать для тайм-аута и самоисключения.',
    preferencesDescription: 'Активация/деактивация SMS, Email и Push-уведомлений для игроков.',
    preferencesSMSDescription: 'SMS-рассылка для всех игроков бренда и на сайте Часть SMS должна стать невидимой',
    preferencesEmailDescription: 'Отправка электронной почты для всех игроков бренда и на сайте Часть электронной почты должна стать невидимой',
    walletsSettings: 'Настройки кошельков',
    wallets: 'Кошельки',
    features: 'Особенности',
    dda: 'DDA',
    ddaInfo: 'При активации этой опции налоги на вывод средств будут удерживаться в логике DDA',
    whatsAppDescription: 'Предоставьте своим клиентам возможность связаться с вами с помощью самого популярного мессенджера в мире.',
    phoneNumber: 'Номер телефона',
    whatsAppPhoneNumberInfo: 'Введите номер телефона, на который зарегистрирован ваш аккаунт WhatsApp',
    multiGameLaunch: 'Запуск нескольких игр',
    multiGameLaunchDescription: 'В зависимости от конфигурации, на сайте доступна опция запуска нескольких игр, и игроки могут играть в несколько игр одновременно.',
    jackpotWidget: 'Виджет джекпота',
    jackpotWidgetDescription: 'Относится к активации виджета Казино джекпот для лендинга. Доступно для виджета Amusnet Provider Jackpot.',
    gameIframe: 'Iframe игры',
    manuBarFixation: 'Исправление панели меню',
    manuBarFixationDescription: 'Только для мобильного просмотра, в зависимости от конфигурации Главная панель фиксирована для лобби.',
    paymentVisibilityInfo: 'В этом разделе вы можете скрыть и не разрешить использование способа оплаты для игроков, имеющих один из выбранных тегов',
    centrivoConnectAgDescription: 'Преобразуйте свой iGaming-бизнес с помощью решения Connect Agent от Centrivo',
    retailCentrivoDescription: 'Преобразуйте свой iGaming-бизнес с помощью Retail Solution от Centrivo',
    currencySymbol: 'Символ валюты',
    preferencesPushNotificationsDescription: 'Канал Push Notifications станет доступен для отправки уведомлений для Бренда',
    currencyFormat: 'Формат валюты',
    currencyFormatInfo: 'Какой формат валюты показывать на сайте для игроков.',
    isoCode: 'Код ISO',
    symbols: 'Символы',
    digitainCrmDescription: 'CRM-решение, предназначенное для поддержания вовлеченности существующих игроков и повышения их общего довольства',
    accessDecreaseLimit: 'Ограничение доступа',
    depositOnNegativeBalance: 'Депозит при отрицательном балансе',
    depositOnNegativeBalanceInfo: 'После одобрения депозита будет произведена корректировка отрицательного кошелька игрока для закрытия долга.',
    digitainAffiliateDescription: 'Активируйте партнерскую программу и ощутите значительный рост посещаемости вашего сайта.',
    projectId: 'ID проекта',
    projectIdInfo: 'Это ID Проекта в панели администратора «Digitain Affiliate»',
    brandIdInfo: 'Это ID Бренда в панели администратора «Digitain Affiliate».',
    maintenanceSetup: 'Настройка технического обслуживания',
    sportsBookViews: 'Просмотры Спортсбука',
    mandatoryNotification: 'Обязательное уведомление',
    mandatoryNotificationInfo: 'Обязательное всплывающее окно для игроков, которые зашли на сайт',
    lossDecreaseLimit: 'Лимит потерь',
    inactivityIndicators: 'Индикаторы неактивности',
    inactivityIndicatorsInfo:
      'Данная конфигурация будет считать игрока неактивным на основании одного из нескольких показателей, даты последнего входа в систему или даты последних транзакций (ставка, депозит, вывод средств)',
    recoverByPlayer: 'Восстановление игроком',
    recoverByPlayerInfo: 'Если эта функция включена, игроки могут самостоятельно восстановить свои данные с помощью верификационного кода',
    singleBetDecreaseLimit: 'Лимит одиночной ставки',
    cashierType: 'Тип кассира',
    lIcon: 'иконка',
    gameLaunchType: 'Тип запуска игры (мобильный вид)',
    gameFullScreenLaunchDescription: 'Игра открывается с помощью iframe в полноэкранном режиме',
    gameHeaderFooterLaunchDescription: 'Игры открываются с iframe, заголовком и нижним колонтитулом',
    gameQuickActionBarLaunchDescription: 'Игры открываются с помощью панели быстрых действий',
    limitEffectConfigs: 'Конфигурации предельных эффектов',
    ignoreFirstDeposit: 'Игнорировать первый депозит',
    ignoreFirstDepositHint: 'Если выбрана эта опция, первый в жизни игрока успешный депозит не будет учитываться в лимите ответственного игрового депозита',
    periodLimit: 'Лимит по периоду',
    playerLimitsConfiguration: 'Настройка лимитов игроков',
    alanbaseDescription: 'Платформа, созданная экспертами в области iGaming и партнерского маркетинга, помогающая другим экспертам оптимизировать свои расходы и увеличить прибыль.',
    routForEvents: 'Маршрут для мероприятий',
    routForGoals: 'Маршрут для целей',
    fastDepositPaymentMethod: 'Быстрый способ оплаты депозита',
    fastDepositPaymentMethodInfo:
      'Быстрый депозит — это функция на сайте, с помощью которой игроки могут сделать депозит, не покидая страницу игры, с помощью платежного метода, предопределенного от Centrivo.',
    sportStatusIconsInfo: 'Загруженные иконки будут видны в профиле игрока на сайте. Каждая загруженная иконка будет отображаться на сайте не более чем в течение часа.',
    rolloverBetsReturn: 'Ставки на ролловер возвращаются в тот же кошелек',
    rolloverBetsReturnInfo: 'В случаях, когда ставка, сделанная с баланса ролловера, возвращается/отменяется, сумма будет переведена на баланс ролловера',
    maxDepositAmounts: 'Максимальные суммы депозитов',
    paymentsIgnoringDepositVerification: 'Платежи, не требующие верификации депозита',
    selfExclusion: 'Самоисключение',
    setMainDomain: 'Установить основной домен',
    disconnected: 'Отключено',
    configureLimits: 'Конфигурация ограничений',
    metaMapDesc: 'Все, что нужно для верификации клиентов, в одной платформе',
    clientId: 'ID клиента',
    clientIdInfo: 'Используется для идентификации вас как продавца.',
    clientSecret: 'Клиентская тайна',
    clientSecretInfo: 'В качестве пароля используйте client_secret, взятый из Дашборда.',
    pushGameState: 'Состояние игры',
    pushGameStateDescription: 'Эта настройка определяет состояние игр («Состояние игры»), отправляемых агрегатором в бэк-офис.',
    thunderBiteDescription: 'Усовершенствуйте работу с клиентами и превратите вовлеченность в лояльность.',
    campaignURL: 'URL кампании',
    captchaCaseInsensitiveInfo: 'При включении опции captcha система не различает прописные и строчные буквы, считая их одинаковыми.',
    caseInsensitive: 'Нечувствительный к регистру',
    verificationRequestPeriod: 'Период запроса верификации через SMS/Эл. почту',
    verificationRequestPeriodInfo: 'Конфигурация определяет, когда игроку будет отправлен следующий запрос на верификацию через SMS/Эл. почту',
    sec: 'сек',
    integratedDate: 'Интегрированная дата',
    integratedBy: 'интегрировано',
    isInvisible: 'является невидимым',
    captchaInvisibleInfo: 'Если установить флажок, captcha не будет видна игрокам',
    captchaLogonAttemptsInfo: 'Определите количество неудачных попыток входа, период подсчета этих попыток и время, в течение которого будет отображаться CAPTCHA.',
    jackpot: 'Джекпот',
    globalState: 'Глобальное состояние',
    jackpotGames: 'Игры с джекпотом',
    myAffiliatesDescription: 'Самое гибкое программное обеспечение для отслеживания аффилиатов на рынке',
    sportDomainsTabInfo: 'Максимальное количество спортивных доменов — {{count}}. Только активные домены могут быть установлены в качестве основных. Только проверенные домены могут быть подключены.',
    firebaseAuthenticationDescription: 'Настройте платформы социальных сетей для регистрации пользователей и аутентификации входа с помощью Firebase.',
    frontend: 'Фронтенд',
    backend: 'Бэкенд',
    google: 'Google',
    facebook: 'Facebook',
    socialMediaPlatforms: 'Платформы для социальных сетей',
    optimoveDescription: 'CRM-решение, разработанное для поддержания вовлеченности существующих игроков и повышения их общего довольства.',
    baseUrl: 'Базовый URL',
    forcePasswordChangeNote:
      'При включении этой опции игроки должны менять пароли, если пройдет установленный период.\nПо истечении периода напоминания пароля игроки не смогут войти на сайт без смены пароля, если опция включена.',
    forcePasswordChange: 'Принудительное изменение пароля',
    playerTags: 'Теги игрока',
    additional: 'Дополнительно',
    gameTimeLimit: 'Ограничение времени игры',
    verificationOptions: 'Варианты верификации',
    blockActions: 'Действия по блокировке',
    userNotification: 'Уведомление пользователяУведомление пользователя',
    winAmounts: 'Выигрышные суммы',
    largeWinTransactionNotification:
      'Уведомление о транзакции с крупным выигрышем будет отправлено только выбранным пользователям. Убедитесь, что сумма выигрыша настроена для всех валют в случае, если выбраны все пользователи.',
    promptOnLogin: 'Подсказка при входе в систему',
    promptOnLoginInfo: 'Выбрав эту опцию, игроки должны будут установить свои лимиты при первом входе в систему.',
    productCategory: 'Категория продукта',
    betProfitRange: 'Диапазон прибыли по ставке (от - до)',
    betProfitRangeHint: 'Сумма в поле «От» диапазона «Прибыль по ставке» включена в этот диапазон, а сумма в поле «До» не включена в этот диапазон.',
    betTaxInfo: 'Одной «Категории товара» может быть присвоен либо «Кумулятивный», либо «За транзакцию» тип налогообложения, в зависимости от предпочтительного метода расчета налога.',
    betTaxStandardDisabledInfo: 'Активируйте «Налогообложение» и «Налог на прибыль по ставкам», чтобы включить налоговый механизм для вашего бренда.',
    depositTaxStandardDisabledInfo: 'Активируйте «Налогообложение» и «Налог на депозит», чтобы включить налоговый механизм для вашего бренда.',
    withdrawalTaxStandardDisabledInfo: 'Активируйте «Налогообложение» и «Налог на вывод средств», чтобы включить налоговый механизм для вашего бренда.',
    registrationUniqueness: 'Уникальность регистрации',
    registrationUniquenessNote: 'Уникальность выбранной комбинации должна быть подтверждена при регистрации игрока.',
    responsibleGamingLimitsInfo:
      'В этом разделе вы можете установить предопределенные значения, которые будут автоматически заполняться как лимиты по умолчанию во время настройки, но могут быть настроены вручную. Можно включить/выключить запрос на вход, который потребует от игроков установить лимит.',
    hours: '{{number}} часов',
    days: '{{number}} дней',
    month: '{{number}} месяцев',
    year: '{{number}} лет',
    viewDefaultAmount: 'Просмотр суммы по умолчанию',
    viewDefaultLimit: 'Просмотр лимита по умолчанию',
    realTimeUniquenessCheck: 'Проверка уникальности в режиме реального времени',
    realTimeUniquenessCheckNote: 'Если включить эту функцию, система будет мгновенно проверять номер мобильного телефона, ID и электронную почту на уникальность во время процесса регистрации.',
    appToken: 'Токен приложения',
    accountVerificationOptions: 'Варианты верификации аккаунта',
    accountVerificationOptionsInfo: 'Выберите опции, на основании которых аккаунт игрока будет считаться подтвержденным',
    markAsUnverified: 'Отметить как неверифицированный',
    markAsUnverifiedInfo: 'Если эта функция включена, игроки будут помечены как неверифицированные в соответствии с установленными правилами',
    verificationPeriodTabInfo: {
      text1: 'В этом разделе вы можете установить правила для автоматической блокировки невертифицированных игроков по истечении определенного периода.',
      text2:
        'Игроки считаются неверифицированными, если они не прошли необходимые этапы верификации, которые определены в разделе Конфигурация верификации. Игроки, прошедшие выбранную верификацию, будут считаться верифицированными. Если верификация не пройдена, игроки будут помечены как заблокированные из-за отсутствия верификации.',
    },
    notificationReminder: 'Напоминание об уведомлении',
    notificationReminderInfo: 'Количество дней, по истечении которых игроку будет предложено верифицировать аккаунт',
    blockForUnVerify: 'Блокировка за отсутствие верификации',
    blockForUnVerifyOptions: 'Блокировка за отсутствие опций верификации',
    betOddsLimit: 'Лимит коэффициентов ставок',
    betOddsLimitInfo:
      'В случаях, когда ставка сделана с коэффициентом ниже указанного, выигранная сумма будет пропорционально распределена между кошельками (использованным и неиспользованным), на которые была сделана ставка',
    selfExclusionReason: 'Причина самоисключения',
    selfExclusionReasonInfo: 'Если причина выбрана, игрок не сможет установить самоисключение на аккаунт, выбрав указанные причины',
    balanceVisibility: 'Видимость баланса',
    balanceVisibilityNote: 'Выбранные балансы будут видны игрокам бренда.',
    configured: 'Конфигурированный',
    limitEffectPeriodInfo:
      'Изменения вступают в силу либо через определенное время (немедленно, через 24 часа, 48 часов или 7 дней), либо в начале следующего календарного периода — в полночь для ежедневных лимитов, в понедельник для еженедельных лимитов или 1 числа месяца для ежемесячных лимитов.',
    documentsConfig: 'Конфигурация документов',
    documentsConfigInfo: 'Для следующих типов документов количество страниц всегда равно 1',
    pageCount: 'Количество страниц',
    realityCheckSettings: 'Настройки проверки реальности',
    calculationType: 'Тип расчетов',
    realityCheckInterval: 'Интервал проверки реальности',
    showLogOutButton: 'Показать кнопку выхода из системы',
    realityCheckSettingsInfo: 'Конфигурации будут применяться только в том случае, если в разделе Стандарты включена проверка реальности',
    realityCheckStatus: 'Статус проверки реальности',
    realityCheckPeriodInfo: 'Эти периоды будут отображаться в аккаунте игрока на сайте',
    realityCheckIntervalInfo: 'Определяет временной интервал между показами всплывающего окна «Проверка реальности» для игроков',
    capitalizePlayerData: 'Капитализация данных игроков',
    capitalizePlayerDataInfo: 'Если включить эту опцию, система будет писать имена и фамилии, адреса и города заглавными буквами во время процесса регистрации и сохранять их в бэк-офисе.',
    blockedCountriesInfo:
      'Действия (разблокировка, полная блокировка, блокировка для входа, блокировка для регистрации, блокировка для входа и регистрации) могут применяться индивидуально для каждой страны или массово, сразу обновляя их статус.',
    bulkAction: 'Массовое действие',
    multiPeriodLimitType: 'Тип многопериодного лимита',
    singlePeriodLimitType: 'Тип лимита на один период',
    changeEffectPeriods: 'Периоды влияния изменений',
    lastMonthPeriod: 'Период за последний месяц',
    eddVerificationNotification: 'Конфигурации EDD будут запускать проверку источника средств для квалифицированных игроков',
    totalDepositAmount: 'Общая сумма депозита',
    maintenancePeriod: 'Период технического обслуживания',
    brandBonusesInfo:
      'Эта секция позволяет пользователям настраивать логику активации бонусов для бренда на основе определённых условий. Если какое-либо условие не выполнено, бонус не будет активирован.',
    firstSuccessfulDeposit: 'Первый успешный депозит',
    firstSuccessfulDepositDesc: 'Игроки должны иметь хотя бы один успешный депозит, чтобы иметь право активировать бонусы.',
    sportStatusDesc: 'Игроки с выбранным статусом не могут активировать полученные бонусы.',
    standardTaxModelInfo: 'Рассчитывает налог на совершённый депозит, применяя указанный процент налога к общей сумме.',
    vatTaxModelInfo: 'Рассчитывает налог на совершённый депозит, применяя указанный процент НДС по формуле НДС. Общая сумма депозита включает НДС.',
    setVatAmountRangesInfo: 'Система автоматически отделяет часть НДС от общей суммы, чтобы вычислить фактическую сумму депозита.',
    multiBetOfTheDay: 'Мульти-ставка дня',
    sportSuperPromotion: 'Супер-акции',
    schemaMarkupImage: 'Изображение разметки схемы',
    dataSendPeriod: 'Период отправки данных',
    demoLaunchDesktop: 'Запуск демоверсии (настольная версия)',
    demoLaunchMobile: 'Запуск демоверсии (мобильная версия)',
    demoLaunchDesktopDescription: 'В зависимости от конфигурации, кнопка демоверсии доступна в играх, и игроки могут запускать демоверсию игры в режиме настольной версии.',
    demoLaunchMobileDescription: 'В зависимости от конфигурации, кнопка демоверсии доступна в играх, и игроки могут запускать демоверсию игры в режиме мобильной версии.',
    androidSettings: 'Настройки Android',
    iosSettings: 'Настройки iOS',
    googleCloudProjectId: 'ID проекта Google Cloud',
    mobileReCaptcha: 'Мобильная reCAPTCHA',
    androidReCaptchaKey: 'Ключ Android reCAPTCHA',
    androidKeyId: 'ID ключа Android',
    iosReCaptchaKey: 'Ключ iOS reCAPTCHA',
    iosKeyId: 'ID ключа iOS',
    playerApproval: 'Подтверждение игрока',
    playerApprovalInfo: 'Требуется подтверждение игрока перед применением нового, более слабого лимита после окончания периода действия изменений',
    transactionTypeNote: 'Выбранные типы будут видны игрокам бренда в их кассе на веб-сайте.',
    domainDeletion: 'Удаление домена',
    incomeAccessDescription: 'Присоединяйтесь к самой давней партнерской маркетинговой сети в сфере iGaming',
    suggestedAmounts: 'Рекомендуемые суммы',
    defaultAmount: 'Сумма по умолчанию',
    viewLimits: 'Просмотр лимитов',
    configureAmounts: 'Настройка сумм',
    suggested: 'Рекомендуемые значения',
    otherTypeDocumentConfigInfo:
      'Для всех типов, кроме <0>Other</0>, требуется указать выбранное количество файлов. Для <0>Other</0> выбранное количество является максимально допустимым, и допускается меньшее количество файлов.',
    uploadReCaptchaInfo: 'Вы можете загрузить действительный JSON-файл для настройки ReCaptcha',
    androidPrivateKey: 'Приватный ключ Android',
    iosPrivateKey: 'Приватный ключ iOS',
    indefiniteTimePeriod: 'Бессрочный период времени',
    sportMinBetAge: 'Минимальный возраст для ставок на спорт',
    casinoMinBetAge: 'Минимальный возраст для ставок в казино',
    zingBrainDesc: 'ZingBrain — это простая в интеграции платформа для повышения производительности в индустрии iGaming.',
    awsCloudDescription: 'Настройте AWS для включения загрузки данных.',
    zingBrandDescription: 'Интегрируйте ZingBrain для настройки рекомендаций контента для лобби на основе AI.',
    regionName: 'Название региона',
    endpointUrl: 'URL-адрес конечной точки',
    accessKeyId: 'ID ключа доступа',
    secretAccessKey: 'Секретный ключ доступа',
    bucketName: 'Название корзины',
    apiUserName: 'Имя пользователя API',
    apiPassword: 'Пароль API',
    zingBrandId: 'ID ZingBrand ',
    configuredDate: 'Дата настройки',
    configuredBy: 'Настройка (кем)',
    standardTaxModel: 'Стандартная налоговая модель',
    loyaltyProgram: 'Программа лояльности',
    activationMinimumAmount: 'Минимальная сумма активации',
    activationMinimumAmountDesc: 'Для активации бонуса игроки должны иметь в своих кошельках как минимум указанную сумму',
    authentigateDescription:
      'Authentigate — это универсальное решение для аутентификации большинства популярных электронных удостоверений личности в странах Балтии. Подключите Smart-ID, Mobile-ID, мобильное приложение eParaksts и эстонское удостоверение личности через один надежный шлюз.',
    betStatusCorrectionsNotification: 'Определение лимитов и требований к подтверждению для операторов, позволяющее им утверждать или отменять действия по превышению лимита',
    trustlyDescription: 'Trustly Pay and Play обеспечивает игрокам быстрый и удобный процесс регистрации, объединяющий внесение депозитов, верификацию пользователя и создание аккаунта.',
    trustlyNote: 'Перед включением этой опции необходимо сначала настроить Pay and Play на странице Paydom.',
    relumActivation:
      'Активировав продукт Relum, вы получаете доступ к множеству игр от различных премиальных провайдеров игр, что позволяет создать персонализированный игровой опыт для ваших игроков.',
    sportsBookActivation:
      'Активировав продукт Спортсбук, вы получите доступ к комплексному многоязычному, мультивалютному, настраиваемому интерфейсу с событиями в режиме реального времени и до начала матчей по различным видам спорта, с лигами по всему миру и огромным количеством рынков ставок.',
    domain: 'Домен',
    whiteIps: 'Белые IP-адреса',
    betStatusCorrections: 'Коррекция статуса ставок',
    autoDeposit: 'Автопополнение',
  },
  pt: {
    mainCurrency: 'Moeda Principal',
    mainLanguage: 'Idioma Principal',
    market: 'Mercado',
    setMainCountry: 'Definir País Principal',
    setMainCurrency: 'Definir Moeda Principal',
    setMainLanguage: 'Definir Idioma Principal',
    redirectedTo: 'Redirecionado para',
    verifyDomain: 'Verificar domínio',
    onlyVerifiedDomainInfo: 'Somente domínios verificados podem ser conectados',
    disconnectDomain: 'Desconectar Domínio',
    connectDomain: 'Conectar Domínio',
    deleteDomain: 'Excluir Domínio',
    deleteScript: 'Excluir Script',
    deactivateScript: 'Desativar Script',
    activateScript: 'Ativar Script',
    supportedCurrencies: 'Moedas Compatíveis',
    supportedCountries: 'Países Compatíveis',
    supportedLanguages: 'Idiomas Compatíveis',
    providerDisableInfo: 'O fornecedor pode ter sido desativado para todo o sistema',
    activity: 'Atividade',
    verificationAnd: 'Verificação (e)',
    verificationOr: 'Verificação (ou)',
    andDelimiter: 'e',
    currencyFrom: 'Moeda de',
    currencyTo: 'Moeda para',
    reverseRate: 'Taxa Reversa',
    feature: 'Destaque',
    otherTransactions: 'Outras Transações',
    limitType: 'Limitar Tipo',
    playersNotifiedDate: 'Data Notificada',
    depositProcessingType: 'Tipo de Processamento de Depósito',
    withdrawalProcessingType: 'Tipo de Processamento de Saque',
    allowedActivities: 'Atividades Permitidas',
    depositSupportedCurrencies: 'Moedas Compatíveis para Depósito',
    withdrawalSupportedCurrencies: 'Moedas Compatíveis para Saque',
    newFee: 'Nova Taxa, %',
    feeBefore: 'Taxa Anterior, %',
    newLimit: 'Novo Limite',
    statusDisabledInfo: 'O site ficará indisponível em todos os domínios.',
    statusActivitiesDisabledInfo: 'Não serão aceitas novas apostas.',
    statusVersionNamesDisabledInfo: 'As apostas serão desativadas para as versões selecionadas.',
    timezoneInfo: 'Qualquer cálculo em andamento relacionado com o fuso horário será alterado.',
    domainRedirection: 'Redirecionamento de Domínio',
    uVerify: 'VERIFICAR',
    redirect: 'Redirecionar',
    forwardingURL: 'URL de Encaminhamento',
    destinationURL: 'URL de Destino',
    domainRedirectInfo: 'O domínio que é usado como redirecionamento ou URL de destino não pode ser excluído sem a eliminação da regra existente.',
    registerDomainInfo: 'Você precisa registrar todos os seus domínios em sua conta google para habilitar o captcha para todos eles.',
    ageRestriction: 'Restrições de Idade',
    passwordPattern: 'Padrão de Senha',
    failedAttemptsPeriod: 'Período de Tentativas Fracassadas',
    lockPeriod: 'Período de Bloqueio',
    passwordReminder: 'Lembrete de Senha',
    inactivityPeriod: 'Período de Inatividade',
    securityPeriod: 'Período de Verificação de Segurança',
    referralActivationPeriod: 'Período de Ativação da Indicação',
    passwordPatternNote:
      'Recomenda-se que as senhas tenham no mínimo 8 caracteres, incluindo pelo menos 1 número e 1 letra maiúscula. Entretanto, você pode fragilizá-la até ter de 6 a 20 letras latinas, números ou caracteres especiais.',
    referralActivationPeriodNote: 'Período durante o qual você deseja manter as informações de identificação do indicado para um novo registro no site.',
    playerVerification: 'Configurações de Verificação do Jogador',
    verificationConf: 'Configuração de Verificação',
    correspondingTranslations: 'Certifique-se de que todas as traduções estejam correspondentemente atualizadas.',
    verificationCodeLength: 'Tamanho do Código de Verificação',
    dailyMobileVerification: 'Pedidos Diários de Verificação pelo Celular',
    emailRequestsInDaily: 'Pedidos Diários de Verificação por E-mail',
    expirationMinutes: 'Período de Expiração do Token',
    expirationMinutesNote: 'Config define o período após o qual o token (código, link) na notificação se tornará inválido.',
    emailRequestsInDailyNote: 'Config define quantos pedidos de verificação por e-mail podem ser recebidos em um dia. O valor mínimo é de {{value}}.',
    dailyMobileVerificationNote: 'Config define quantos pedidos de verificação por SMS o jogador pode receber em um dia. O valor mínimo é de {{value}}.',
    identityDocument: 'Documento de Identidade',
    addressDocument: 'Documento de Endereço',
    additionalDocument: 'Documento Adicional',
    disableSportBook: 'Desativar {{name}}',
    gameDisableTooltip: 'O jogo pode ter sido desativado para todo o sistema',
    playerLimitInfo: {
      text1: 'Você pode definir um período de redução da severidade do limite para cada tipo de limite.',
    },
    depositDecreaseLimit: 'Limite de Depósito',
    betDecreaseLimit: 'Limite de Aposta',
    withdrawalDecreaseLimit: 'Limite de Saque',
    activateSportsbook: 'Ativar o Sportsbook',
    customScriptInfo: 'Você pode integrar novas ou adicionar diferentes aplicações funcionalidades em seu site, adicionando scripts personalizados.',
    scriptName: 'Nome do Script',
    insideHead: 'Antes e dentro da tag de fechamento </head>',
    insideBody: 'Antes e dentro da tag de fechamento </body>',
    headTag: 'script da tag head',
    bodyTag: 'script da tag body',
    service: 'serviço',
    integrate: 'Integrar',
    showOnLive: 'Mostrar no Site Ao Vivo',
    showOnLiveTitle: 'Quando você desligar este interruptor, o ícone do serviço terceirizado será ocultado da página inicial do seu site.',
    apiSecret: 'API Secret',
    apiSecretOrPass: 'API Secret ou senha',
    apiKeyOrUsername: 'API Key ou nome de usuário',
    sendEmailVia: 'Enviar E-mail Via',
    smtpUser: 'Usuário SMTP',
    smtpPass: 'Senha SMTP',
    useSSL: 'Use SSL',
    smtpHost: 'SMTP Host',
    smtpPort: 'SMTP Port',
    emailsInfo: {
      text1: 'Para alguns provedores SMTP, é necessário que o mesmo e-mail seja registrado do seu lado.',
      text2: 'Por favor, certifique-se de que a exigência seja atendida.',
    },
    emailsInfo1: 'Todas as mensagens programadas com este e-mail serão movidas para o rascunho',
    blockCountries: 'Bloquear Países',
    blockCountriesMainText: 'O site estará indisponível nos países selecionados',
    versionControl: 'Controle de Versão',
    policies: 'Políticas',
    policy: 'Política',
    dateToNotify: 'Data para Notificar',
    featureName: 'Nome do Recurso',
    createBrand: 'Criar Marca',
    builder: 'Construtor',
    platformState: 'Estado da Plataforma',
    minMaxWithdrawalAmount: 'Sistema Min-Max Valor de saque',
    minWithdrawalAmount: 'Valor Mín. de Saque',
    maxWithdrawalAmount: 'Valor Máx. de Saque',
    minMaxDepositAmount: 'Valor Mín-Máx do Depósito do Sistema',
    minDepositAmount: 'Valor Mín. de Depósito',
    maxDepositAmount: 'Valor Máx. de Depósito',
    operationFeePercent: 'Taxa de Operação, %',
    withdrawalFeePercent: 'Taxa de Saque, %',
    withdrawalFee: 'Taxa de Saque',
    withdrawalFeeForUsedBalancePercent: 'Taxa de Saque para o Saldo Utilizado, %',
    withdrawalFeeForUsedBalance: 'Taxa de Saque por Saldo Utilizado',
    allowedConversion: 'Conversão Permitida',
    paymentMethodName: 'Nome da forma de pagamento',
    minAmount: 'Valor Mín. de {{title}}',
    maxAmount: 'Valor Máx. de {{title}}',
    minMaxSystemAmount: 'Sistema de Valor Mín-Máx de {{title}}',
    depositFeePercent: 'Taxa de Depósito, %',
    depositFee: 'Taxa de Depósito',
    allowConversion: 'Permitir Conversão',
    previewLive: 'Visualização Ao Vivo',
    feeFromDeposit: 'Taxa de Depósito',
    allowWithdrawalFromUnusedBalance: 'Permitir Saque do Saldo Não Utilizado',
    allowWithdrawalFeeUsedBalance: 'A taxa de Saque será retida do saldo restante.',
    feeCalculationForWithdrawals: 'Cálculo de Taxas de Saques',
    feeFromWithdrawals: 'Taxa de Saque',
    feeFromWithdrawalsUsedBalance: 'Taxa de Saques (Saldo Utilizado)',
    feeFromWithdrawalsBalance: 'Taxa de Saques de Saldo ({{type}})',
    unusedBalanceInfo: "Quando ativada, a opção de saldo 'Não utilizado' aparecerá na configuração 'Taxa de Saque'.",
    paymentTransactionType: 'Tipo de Transação de Pagamento',
    paymentMethodType: 'Tipo de Forma de Pagamento',
    playerPaymentRelation: 'Relação Jogador-Pagador',
    failedPaymentAttempts: 'Tentativas de Pagamento Fracassadas',
    failedPaymentAttemptsPeriod: 'Período de Tentativas de Pagamento Fracassadas',
    temporaryBlockPeriod: 'Período de Bloqueio Temporário',
    reverseConversion: 'Conversão Reversa {{title}}',
    lCustomScript: 'script personalizado',
    largeTransactions: 'Grandes Transações',
    lBrand: 'marca',
    playerSettings: 'Configurações do jogador',
    verificationConfigurations: 'Configurações de verificação',
    theCurrency: 'A moeda',
    mainCountry: 'País Principal',
    theLanguage: 'O idioma',
    smsSettings: 'Configurações SMS',
    verificationSettings: 'Configurações de verificação',
    smtpSettings: 'Configurações SMTP',
    captchaSettings: 'Configurações do Captcha',
    theEmail: 'O e-mail',
    conversions: 'Conversões',
    theConversion: 'A conversão',
    theCountry: 'O país',
    playerVerificationSettings: 'Configurações de verificação do jogador',
    domainRedirectionRule: 'Regra de redirecionamento de domínio',
    wageringActivities: 'Atividades de apostas',
    theSportsBook: 'O Sportsbook',
    sportsBook: 'Sportsbook',
    theSportsBookView: 'A visão do Sportsbook',
    setMainView: 'Definir Visão Principal',
    feeForWithdrawalsWillBeHeld: 'A taxa de Saque será retida do saldo restante.',
    brandName: 'Nome da Marca',
    defaultCountry: 'País Padrão',
    defaultLanguage: 'Idioma Padrão',
    defaultCurrency: 'Moeda Padrão',
    products: 'Produtos',
    websiteTemplate: 'Modelo de Site',
    failedPaymentInfo: 'As configurações não estão disponíveis devido à inatividade do padrão "Procedimento de Pagamentos Malsucedidos". Por favor, ative-a a partir da seção "Normas".',
    depositWithdrawalPaymentMethodInfo:
      'Os métodos de pagamento que utilizam conversão serão afetados em caso de mudanças e os limites de mín/máx personalizados poderão ser redefinidos pelo sistema se contradizerem novas mudanças. Certifique-se de rever os limites e a disponibilidade de moedas nas configurações dos métodos de pagamento.',
    otherPaymentMethodInfo:
      'As funcionalidades internas que utilizam a conversão utilizarão essas taxas de conversão. Assegure-se de ter todas as conversões em vigor (por exemplo, Bônus de Indicação).',
    conversionSettingsInfo: 'O limite atual contradiz o limite sistema/sistema-convertido.',
    card: 'Carta',
    imageAlt: 'Alt de Imagem',
    recommendedSize: 'Tamanho recomendado',
    stateOrRegion: 'Estado/Região',
    socialLinks: 'Links Sociais',
    socialLinkInfo: 'As páginas do perfil da empresa em diferentes meios, tais como Facebook, Twitter, Google+, Instagram, Youtube, LinkedIn, Wikipedia, etc. Você pode adicionar quantas URLs quiser.',
    image: 'Imagem',
    depositPaymentCategory: 'Categoria de Pagamento do Depósito',
    withdrawalPaymentCategory: 'Categoria de Pagamento de Saque',
    createNewBrand: 'Criar Nova Marca',
    lConversion: 'conversão',
    allowWithdrawalViaTheDepositedMethods: 'Permitir o saque somente através dos métodos depositados',
    allowWithdrawalViaTheDepositedMethodsInfo: 'A ativação das configurações restringe o jogador de retirar dinheiro através dos métodos que ele nunca depositou antes',
    schemaMarkupSettings: 'Configurações de Schema Markup',
    accountId: 'ID da conta',
    accountIdInfo: 'Qualquer nome ou código de identificação associado ao ID da conta de serviço que fornece um nível específico de acesso',
    ranges: 'Intervalo',
    depositAmountRanges: 'Intervalo de valores de depósito (de - até)',
    taxPercentage: 'Porcentagem de imposto %',
    lTaxes: 'impostos',
    withdrawalAmountRanges: 'Faixa de valor de saque (de - até)',
    fixedAmountOrPercent: 'Valor Fixo ou Porcentagem de Imposto',
    spotsBookJackpotDescription: 'Quando ativado, o Widget do Sports Jackpot fica disponível na página inicial',
    spotsBookScrollingTypeDescription: 'A configuração é aplicável apenas para visualização padrão e, quando ativada, a página de esportes pode ser totalmente rolada com uma rolagem',
    spotsBookTournamentBalanceDescription: 'Quando ativado, o saldo do torneio fica disponível na página inicial do site',
    sportJackpot: 'Jackpot esportivo',
    sectionsScrolling: 'Rolagem de seções',
    sportTournamentBalance: 'Saldo do Torneio Desportivo',
    iframe: 'Iframe',
    native: 'Nativo',
    sportsBookIframeIntegrationDescription: 'O sportsbook estará disponível em um inline frame',
    sportsBookNativeIntegrationDescription: 'O sportsbook estará disponível diretamente em um aplicativo integrado',
    sportsBookMobileIntegrationType: 'Tipo de integração no celular',
    setAsDefault: 'Definir como padrão',
    configs: 'Configs',
    availableLayouts: 'Layouts Disponíveis',
    setAmountRangesInfo:
      "Se, para um intervalo, 'Valor fixo' e 'Porcentagem de imposto' forem definidos, o sistema deve calcular o imposto da seguinte maneira: reter um valor de imposto fixo + a porcentagem x do valor que excede o valor definido em 'De' campo do intervalo.",
    depositAmountRangesHint: "O valor no campo 'De' do 'Intervalo de Valor do Depósito' está incluído nesse intervalo, enquanto o valor no campo 'Para' não está incluído no intervalo.",
    withdrawalAmountRangesHint: "O valor no campo 'De' do 'Intervalo de Valor de Saque' está incluído nesse intervalo, enquanto o valor no campo 'Para' não está incluído no intervalo.",
    fixedAmountHint:
      "O valor no campo 'Valor Fixo' deve ser menor ou igual ao valor inserido no campo 'De' do 'Intervalo de Valor do Depósito'. Se o valor 'De' for 0, o valor no campo 'Valor Fixo' também deverá ser 0.",
    fixedAmount: 'Valor Fixo',
    brandSportsBookActivation:
      'Ao ativar o produto Sportsbook, você terá acesso a uma interface personalizável com eventos ao vivo e pré-jogo para mais de 65 esportes. Quando ativado, o produto só pode ser desativado no painel de administração do Sportsbook.',
    amountFrom: 'Valor de',
    allowPlayerCompose: 'Permitir que os jogadores "escrevam" mensagens',
    sportsBookInheritWebsiteColor: 'Herdar cor do site',
    sportsBookInheritWebsiteColorDescription: 'A configuração se aplica a todas as páginas de esportes.',
    theBrand: 'Marca',
    taxSettings: 'Configurações de impostos',
    infoUrlHint: 'Este URL será usado no site para exibir detalhes de tributação.',
    everyMatrixDescription: 'Soluções iGaming modulares e orientadas por API projetadas para desencadear ideias ousadas',
    smarticoAffiliateDescription: 'Não há melhor maneira de se conectar com seus clientes',
    hotjarDescription: 'Entenda como os usuários estão realmente experimentando seu site sem se afogar em números',
    hotjarId: 'ID HotJar',
    googleAnalyticsId: 'ID do Google Analytics',
    googleAnalyticsDescription: 'Analise o uso em seus sites',
    googleSiteVerificationCode: 'Código de verificação do site do Google',
    googleSearchConsoleDescription: 'Obtenha ajuda para monitorar, manter e solucionar problemas de presença do seu site nos resultados de pesquisa do Google.',
    copyPasteFieldName: 'Copie seu {{fieldName}} e cole-o no campo abaixo.',
    learnMore: 'Saber mais…',
    affiliateInfo: '{{count}} integrações não podem estar ativas simultaneamente',
    liveChatDescription: 'Aplicação de comunicação online que permite que você e os visitantes do seu site conversem em tempo real',
    liveAgentDescription: 'Fornecer excelente atendimento ao cliente',
    intercomDescription: 'Comece um ótimo relacionamento com o cliente aqui',
    zendeskDescription: 'Comunique-se com os clientes de forma mais eficiente',
    intercomId: 'Intercom ID',
    zendeskId: 'Zendesk ID',
    liveChatLicenseNumber: 'LiveChat LICENSE_NUMBER',
    liveAgentYourLa: 'LiveAgent YOUR-LA',
    liveAgentButtonID: 'ID do botão LiveAgent',
    digitainAgIdInfo: 'Este é o ID da marca no painel de administração "Digitain Agent"',
    depositCurrencyInfo:
      'Caso os jogadores tenham permissão para fazer depósitos com todas as moedas suportadas pelos métodos de pagamento, "Permitir conversão" com as configurações de moeda suportadas deve estar ativo para o método de pagamento.',
    pageGroups: 'Grupos de Páginas',
    digitainRetailInfo: "Este é o ID da marca no painel de administração 'Digitain Retail'",
    smarticoDescription: 'A solução de gamificação que usa desafios e técnicas de jogo para motivar os jogadores',
    smarticoLabelKey: 'Chave de etiqueta',
    brandKey: 'Chave da Marca',
    smarticoBrandKeyInfo: 'Uma chave pública para a marca',
    smarticoLabelKeyInfo: 'Uma chave pública para a etiqueta',
    smarticoNote: 'O Smartico CRM e o Gamification estão interligados, cada ação nesta seção também tem efeito no Gamification',
    realityCheckPeriod: 'Período de Verificação da Realidade',
    timeOut: 'Pausa',
    prematchTotalTopMatches: 'Principais partidas pré-jogo (mercado total incluído)',
    spotsBookPrematchTotalTopMatchesDescription: 'Quando ativado, fica disponível o widget de Melhores Jogos Prematch com dados do Mercado Total',
    livePrematchTopMatches: 'Jogos principais ao vivo e pré-lançamento',
    spotsBookLivePrematchTopMatchesDescription: 'Quando ativado, o widget Jogos principais em direto e pré-jogo fica disponível',
    liveTopMatches: 'Jogos principais em direto',
    spotsBookLiveTopMatchesDescription: 'Quando ativado, o widget Jogos principais em direto fica disponível',
    periodCalculationSource: 'Fonte de cálculo do período',
    periodCalculationSourceInfo: 'Selecionar a fonte de data na qual o cálculo do período de verificação irá começar',
    verificationPeriod: 'Período de verificação',
    verificationPeriodInfo: 'O número de dias que uma conta de jogador pode estar ativa antes da verificação',
    unverifiedPlayersExclusionsInfo:
      "Nos casos em que um método de pagamento é selecionado no menu 'Pagamentos que ignoram a verificação de depósitos' e os limites são definidos na parte 'Montantes máximos de depósito', os limites não afectarão esse método de pagamento.",
    responsibleGamingPeriodLimitsInfo: 'Nesta secção, pode definir um período de tempo específico que um jogador pode escolher para o tempo limite e a auto-exclusão.',
    preferencesDescription: 'Ativar/desativar as notificações por SMS, e-mail e push para os jogadores.',
    preferencesSMSDescription: 'Envio de SMS para todos os jogadores da marca e no site Via SMS a parte deve ficar invisível',
    preferencesEmailDescription: 'Envio de e-mail para todos os jogadores da marca e no site Via E-mail a parte deve ficar invisível',
    walletsSettings: 'Definições das Carteiras',
    wallets: 'Carteiras',
    features: 'Recursos',
    dda: 'DDA',
    ddaInfo: 'Activando esta opção os impostos sobre o levantamento serão retidos na lógica do DDA',
    whatsAppDescription: 'Permita que os seus clientes o contactem utilizando o mensageiro mais popular do mundo.',
    phoneNumber: 'Número de telefone',
    whatsAppPhoneNumberInfo: 'Introduza o número de telefone com o qual a sua conta WhatsApp está registada',
    multiGameLaunch: 'Lançamento de multi-jogos',
    multiGameLaunchDescription: 'Dependendo da configuração, a opção multi-jogo está disponível no sítio Web e os jogadores podem jogar vários jogos simultaneamente.',
    jackpotWidget: 'Widget do Jackpot',
    jackpotWidgetDescription: 'Refere-se à ativação do Widget do Jackpot do Casino para a página de destino. Disponível para o widget de jackpot do fornecedor Amusnet.',
    gameIframe: 'Iframe do Jogo',
    manuBarFixation: 'Fixação da barra de menus',
    manuBarFixationDescription: 'Apenas para a vista móvel, dependendo da configuração, a barra principal é fixada para os lobbies.',
    paymentVisibilityInfo: 'Nesta secção, pode ocultar e não permitir a utilização do método de pagamento para jogadores que tenham uma das etiquetas seleccionadas',
    centrivoConnectAgDescription: 'Transforme o seu negócio iGaming com a solução Connect Agent da Centrivo',
    retailCentrivoDescription: 'Transforme o seu negócio de iGaming com a solução de retail da Centrivo',
    currencySymbol: 'Símbolo da moeda',
    preferencesPushNotificationsDescription: 'O canal de Notificações Push ficará disponível para o envio de notificações para a Marca',
    currencyFormat: 'Formato da moeda',
    currencyFormatInfo: 'Qual o formato da moeda a apresentar no sítio Web para os jogadores.',
    isoCode: 'Código ISO',
    symbols: 'Símbolos',
    digitainCrmDescription: 'Solução CRM concebida para manter o envolvimento dos jogadores existentes e aumentar a sua satisfação geral',
    accessDecreaseLimit: 'Limite de acesso',
    depositOnNegativeBalance: 'Depósito em Saldo Negativo',
    depositOnNegativeBalanceInfo: 'Após a aprovação do depósito, o ajuste será efectuado na carteira negativa do jogador para fechar a dívida.',
    digitainAffiliateDescription: 'Active o seu programa de afiliados e experimente um aumento significativo no tráfego do seu site.',
    projectId: 'ID do Projeto',
    projectIdInfo: 'Este é o ID do projeto no painel de administração "Digitain Affiliate".',
    brandIdInfo: 'Este é o ID da marca no painel de administração "Digitain Affiliate".',
    maintenanceSetup: 'Configuração da manutenção',
    maintenancePeriod: 'Período de manutenção',
    sportsBookViews: 'Visualizações do Sportsbook',
    mandatoryNotification: 'Notificação obrigatória',
    mandatoryNotificationInfo: 'Um pop-up obrigatório para jogadores com sessão iniciada no site',
    lossDecreaseLimit: 'Limite de perdas',
    inactivityIndicators: 'Indicadores de inatividade',
    inactivityIndicatorsInfo:
      'Esta configuração irá considerar um jogador inativo com base num de vários indicadores, a data do último início de sessão do jogador ou a data das últimas transacções (aposta, depósito, levantamento)',
    recoverByPlayer: 'Recuperar por jogador',
    recoverByPlayerInfo: 'Quando ativado, os jogadores podem recuperar-se a si próprios através do código de verificação',
    singleBetDecreaseLimit: 'Limite de Aposta Única',
    cashierType: 'Tipo de Caixa',
    lIcon: 'ícone',
    gameLaunchType: 'Tipo de lançamento do jogo (vista móvel)',
    gameFullScreenLaunchDescription: 'Jogo aberto com iframe em ecrã inteiro',
    gameHeaderFooterLaunchDescription: 'Jogos abertos com iframe e cabeçalho e rodapé',
    gameQuickActionBarLaunchDescription: 'Jogos abertos com barra de acções rápidas',
    limitEffectConfigs: 'Configurações de efeito limite',
    ignoreFirstDeposit: 'Ignorar Primeiro Depósito',
    ignoreFirstDepositHint: 'Se esta opção for selecionada, o primeiro depósito bem sucedido do jogador não será calculado no limite de depósito de jogo responsável',
    periodLimit: 'Limite do período',
    playerLimitsConfiguration: 'Configuração dos Limites do Jogador',
    alanbaseDescription: 'Uma plataforma trazida até si por especialistas em iGaming e marketing de afiliados, ajudando outros especialistas a otimizar os seus custos e a aumentar os seus lucros.',
    routForEvents: 'Rota para Eventos',
    routForGoals: 'Rotas por Objetivos',
    fastDepositPaymentMethod: 'Método de pagamento por depósito rápido',
    fastDepositPaymentMethodInfo:
      "Fast Deposit é uma funcionalidade do site por meio da qual os jogadores podem fazer um depósito sem sair da página do jogo pelo método de pagamento predefinido pela 'Centrivo'.",
    sportStatusIconsInfo: 'Os ícones carregados serão visíveis no perfil do jogador no sítio Web. Cada ícone carregado será refletido no sítio Web após, no máximo, uma hora.',
    rolloverBetsReturn: 'As apostas de rollover regressam à mesma carteira',
    rolloverBetsReturnInfo: 'Nos casos em que a aposta feita a partir do saldo de rollover é devolvida/cancelada, o montante será transferido para o saldo de rollover',
    maxDepositAmounts: 'Montantes máximos de depósito',
    paymentsIgnoringDepositVerification: 'Pagamentos que ignoram a verificação de depósitos',
    selfExclusion: 'Autoexclusão',
    setMainDomain: 'Definir domínio principal',
    disconnected: 'Desconectado',
    spotsBookPrematchTopMatchesDescription: 'Quando habilitado, o widget Top Matches fica disponível no Iframe da Sportsbook e na Landing Page',
    prematchTopMatches: 'Melhores partidas pré-jogo',
    configureLimits: 'Configurar Limites',
    metaMapDesc: 'Tudo o que você precisa para verificar seus clientes em uma única plataforma',
    clientId: 'ID do cliente',
    clientIdInfo: 'Usado para identificá-lo como comerciante.',
    clientSecret: 'Segredo do cliente',
    clientSecretInfo: 'Use client_secret retirado do Painel como sua senha.',
    pushGameState: 'Enviar Estado do Jogo',
    pushGameStateDescription: 'Esta configuração define o estado dos jogos ("Estado do Jogo") enviados pelo agregador para o Back Office.',
    thunderBiteDescription: 'Gamifique a experiência do cliente e transforme o engajamento em fidelidade.',
    campaignURL: 'URL da campanha',
    captchaCaseInsensitiveInfo: 'Ao habilitar a opção do captcha, o sistema não distingue entre letras maiúsculas e minúsculas, que são consideradas idênticas.',
    caseInsensitive: 'Não diferencia maiúsculas de minúsculas',
    verificationRequestPeriod: 'Período de solicitação de verificação por SMS/e-mail',
    verificationRequestPeriodInfo: 'A configuração define quando a próxima solicitação de verificação por SMS/e-mail será enviada ao jogador',
    sec: 'seg',
    integratedDate: 'Data de integração',
    integratedBy: 'Integrado por',
    isInvisible: 'Não é visível',
    captchaInvisibleInfo: 'Se marcado, o captcha não ficará visível para os jogadores',
    captchaLogonAttemptsInfo: 'Defina o número de tentativas de login com falha, o período para contagem dessas tentativas e a duração em que o CAPTCHA aparecerá.',
    jackpot: 'Jackpot',
    globalState: 'Estado global',
    jackpotGames: 'Jogos de Jackpot',
    myAffiliatesDescription: 'O software de rastreamento de afiliados mais flexível do mercado',
    sportDomainsTabInfo: 'A contagem máxima de domínios esportivos é {{count}}. Somente domínios ativos podem ser definidos como Principais. Somente domínios verificados podem ser conectados.',
    firebaseAuthenticationDescription: 'Configure plataformas de mídia social para inscrição de usuários e autenticação de login com o Firebase.',
    frontend: 'Frontend',
    backend: 'Backend',
    google: 'Google',
    facebook: 'Facebook',
    socialMediaPlatforms: 'Plataformas de mídia social',
    optimoveDescription: 'Solução de CRM projetada para manter o engajamento dos jogadores existentes e aumentar sua satisfação geral.',
    baseUrl: 'URL Base',
    forcePasswordChangeNote:
      'Ao habilitar a opção, os jogadores devem alterar suas senhas se o período definido for ultrapassado. Quando o período do Lembrete de Senha for ultrapassado, os jogadores não poderão acessar o site sem alterar suas senhas se a opção estiver habilitada.',
    forcePasswordChange: 'Forçar alteração de senha',
    playerTags: 'Tags do jogador',
    additional: 'Adicional',
    gameTimeLimit: 'Limite de tempo do jogo',
    verificationOptions: 'Opções de verificação',
    blockActions: 'Bloquear ações',
    userNotification: 'Notificação do usuário',
    winAmounts: 'Quantia de Ganhos',
    largeWinTransactionNotification:
      'A notificação da transação de Grande Vitória será enviada apenas para usuários selecionados. Certifique-se de que o valor do ganho esteja configurado para todas as moedas, caso algum usuário seja selecionado.',
    promptOnLogin: 'Mensagem ao fazer login',
    promptOnLoginInfo: 'Ao selecionar esta opção, os jogadores deverão definir seus limites durante o primeiro login',
    productCategory: 'Categoria do produto',
    betProfitRange: 'Faixa de lucro da aposta (de - para)',
    betProfitRangeHint: 'O valor no campo "De" do "Intervalo de Lucro da Aposta" está incluído nesse intervalo, enquanto o valor no campo "Para" não está incluído no intervalo.',
    betTaxInfo: "Uma única 'Categoria de Produto' pode ser atribuída ao tipo de tributação 'Cumulativa' ou 'Por Transação', com base no método de cálculo de imposto preferido.",
    betTaxStandardDisabledInfo: "Ative 'Tributação' e 'Imposto sobre Lucro de Apostas' para habilitar o mecanismo de impostos para sua marca.",
    depositTaxStandardDisabledInfo: "Ative 'Tributação' e 'Imposto sobre Depósito' para habilitar o mecanismo de impostos para sua marca.",
    withdrawalTaxStandardDisabledInfo: "Ative 'Tributação' e 'Imposto sobre Saque' para habilitar o mecanismo de impostos para sua marca.",
    registrationUniqueness: 'Unicidade de registro',
    registrationUniquenessNote: 'A exclusividade da combinação selecionada deve ser validada durante o registro do jogador.',
    responsibleGamingLimitsInfo:
      'Nesta seção, você pode definir valores predefinidos que serão preenchidos automaticamente como limites padrão durante a configuração, mas podem ser ajustados manualmente. O prompt de login pode ser ativado/desativado, o que exigirá que os jogadores definam o limite.',
    hours: '{{number}} horas',
    days: '{{number}} dias',
    month: '{{number}} mês',
    year: '{{number}} ano',
    viewDefaultAmount: 'Ver valor padrão',
    viewDefaultLimit: 'Ver limite padrão',
    realTimeUniquenessCheck: 'Verificação de exclusividade em tempo real',
    realTimeUniquenessCheckNote: 'Ao habilitar isso, o sistema verificará instantaneamente a exclusividade do número de celular, do ID e do e-mail durante o processo de registro.',
    appToken: 'Token do app',
    accountVerificationOptions: 'Opções de verificação de conta',
    accountVerificationOptionsInfo: 'Selecione as opções com base nas quais a conta do jogador será considerada verificada',
    markAsUnverified: 'Marcar como não verificado',
    markAsUnverifiedInfo: 'Quando ativado, os jogadores serão marcados como não verificados com base nas regras definidas',
    verificationPeriodTabInfo: {
      text1: 'Nesta seção, você pode definir regras para bloquear automaticamente jogadores não verificados após um período específico.',
      text2:
        'Jogadores são considerados não verificados se não concluírem as etapas de verificação necessárias, definidas na seção Configuração de Verificação. Jogadores que passarem na verificação selecionada serão considerados verificados. Caso não verifiquem, os jogadores serão marcados como bloqueados por não verificados.',
    },
    notificationReminder: 'Lembrete de notificação',
    notificationReminderInfo: 'O número de dias após os quais o jogador será lembrado de verificar a conta',
    blockForUnVerify: 'Bloquear por não verificar',
    blockForUnVerifyOptions: 'Opções de bloqueio por falta de verificação',
    betOddsLimit: 'Limite de odds de aposta',
    betOddsLimitInfo:
      'Nos casos em que a aposta for feita com odds menores que a especificada, o valor ganho será distribuído proporcionalmente entre as carteiras (usadas e não utilizadas), onde a aposta foi feita',
    selfExclusionReason: 'Motivo de autoexclusão',
    selfExclusionReasonInfo: 'Se o motivo for selecionado, o jogador não poderá definir uma autoexclusão na conta selecionando os motivos especificados',
    balanceVisibility: 'Visibilidade do saldo',
    balanceVisibilityNote: 'Os saldos selecionados ficarão visíveis para os jogadores da marca.',
    configured: 'Configurado',
    limitEffectPeriodInfo:
      'As alterações entram em vigor após um período definido (imediatamente, 24 horas, 48 ​​horas ou 7 dias) ou no início do próximo período do calendário — meia-noite para limites diários, segunda-feira para limites semanais ou no primeiro dia do mês para limites mensais.',
    documentsConfig: 'Configuração de documentos',
    documentsConfigInfo: 'Os seguintes tipos de documentos exigem que a contagem de páginas seja sempre 1',
    pageCount: 'Contagem de páginas',
    realityCheckSettings: 'Configurações de verificação da realidade',
    calculationType: 'Tipo de cálculo',
    realityCheckInterval: 'Intervalo de verificação da realidade',
    showLogOutButton: 'Mostrar botão de logout',
    realityCheckSettingsInfo: 'As configurações só serão aplicadas se a Verificação da Realidade estiver habilitada na seção Padrões',
    realityCheckStatus: 'Status de verificação da realidade',
    realityCheckPeriodInfo: 'Esses períodos aparecerão na conta do jogador no site',
    realityCheckIntervalInfo: 'Define o intervalo de tempo entre o pop-up Verificação da Realidade mostrado aos jogadores',
    capitalizePlayerData: 'Capitalizar dados do jogador',
    capitalizePlayerDataInfo: 'Ao habilitar isso, o sistema colocará em maiúsculas os campos Nome/Sobrenome, Endereço e Cidade durante o processo de registro e os salvará no backoffice',
    blockedCountriesInfo:
      'A ação (desbloqueio, bloqueio total, bloqueio para login, bloqueio para registro, bloqueio para login e registro) pode ser aplicada individualmente por país ou em massa, atualizando seu estado de uma só vez.',
    bulkAction: 'Ação em massa',
    multiPeriodLimitType: 'Tipo de limite de vários períodos',
    singlePeriodLimitType: 'Tipo de limite de período único',
    changeEffectPeriods: 'Períodos de Efeito de Mudança',
    lastMonthPeriod: 'Período do último mês',
    eddVerificationNotification: 'As configurações de EDD acionarão a verificação da fonte de fundos para jogadores qualificados',
    totalDepositAmount: 'Valor total do depósito',
    brandBonusesInfo:
      'Esta seção permite que os usuários configurem a lógica de ativação de bônus da marca com base em condições específicas. Se alguma condição não for atendida, o bônus não será ativado.',
    firstSuccessfulDeposit: 'Primeiro depósito bem-sucedido',
    firstSuccessfulDepositDesc: 'Os jogadores devem ter pelo menos um depósito bem-sucedido para serem elegíveis a ativar os bônus.',
    sportStatusDesc: 'Jogadores com o status selecionado não são elegíveis para ativar os bônus recebidos.',
    standardTaxModelInfo: 'Calcula o imposto sobre o depósito realizado, aplicando a porcentagem de imposto mencionada ao valor total.',
    vatTaxModelInfo: 'Calcula o imposto sobre o depósito realizado, aplicando a porcentagem de IVA mencionada pela fórmula do IVA. O valor total do depósito inclui IVA.',
    setVatAmountRangesInfo: 'O sistema separa automaticamente a parte do IVA do total para calcular o valor real do depósito.',
    multiBetOfTheDay: 'Aposta Múltipla do Dia',
    sportSuperPromotion: 'Super Promoções',
    schemaMarkupImage: 'Imagem de Schema Markup',
    dataSendPeriod: 'Período de envio de dados',
    demoLaunchDesktop: 'Lançamento da Demo (Desktop)',
    demoLaunchMobile: 'Lançamento da Demo (Mobile)',
    demoLaunchDesktopDescription:
      'Dependendo da configuração, o botão de demonstração está disponível nos jogos e os jogadores podem abrir a versão de demonstração do jogo na visualização para desktop.',
    demoLaunchMobileDescription:
      'Dependendo da configuração, o botão de demonstração está disponível nos jogos e os jogadores podem abrir a versão de demonstração do jogo na visualização para dispositivos móveis.',
    androidSettings: 'Configurações de Android',
    iosSettings: 'Configurações de iOs',
    googleCloudProjectId: 'ID do projeto do Google Cloud',
    mobileReCaptcha: 'reCAPTCHA mobile',
    androidReCaptchaKey: 'Chave reCAPTCHA para Android',
    androidKeyId: 'ID da chave do Android',
    iosReCaptchaKey: 'Chave reCAPTCHA para iOS',
    iosKeyId: 'ID da chave do iOS',
    playerApproval: 'Aprovação do jogador',
    playerApprovalInfo: 'Requer confirmação do jogador antes da aplicação do novo limite, mais fraco, após o período de vigência da alteração.',
    transactionTypeNote: 'Os tipos selecionados ficarão visíveis para os jogadores da marca em seu Caixa no site.',
    domainDeletion: 'Exclusão de domínio',
    incomeAccessDescription: 'Junte-se à rede de marketing de afiliados de iGaming mais antiga do mercado',
    suggestedAmounts: 'Valores sugeridos',
    defaultAmount: 'Valor padrão',
    viewLimits: 'Ver limites',
    configureAmounts: 'Configurar valores',
    suggested: 'Sugestões',
    otherTypeDocumentConfigInfo:
      'Para todos os tipos, exceto <0>Other</0>, o número de arquivos selecionado é obrigatório. Para <0>Other</0>, o número selecionado é o máximo permitido; menos arquivos são permitidos.',
    uploadReCaptchaInfo: 'Você pode enviar um arquivo JSON válido para a configuração do ReCaptcha.',
    androidPrivateKey: 'Chave privada do Android',
    iosPrivateKey: 'Chave privada do iOS',
    indefiniteTimePeriod: 'Período indefinido',
    sportMinBetAge: 'Idade mínima para apostas esportivas',
    casinoMinBetAge: 'Idade mínima para apostas em cassinos',
    zingBrainDesc: 'O ZingBrain é uma plataforma de melhoria de desempenho fácil de integrar para o setor de iGaming.',
    awsCloudDescription: 'Configure a AWS para habilitar o upload de dados.',
    zingBrandDescription: 'Integre o ZingBrain para habilitar a configuração de recomendações de conteúdo do lobby com IA.',
    regionName: 'Nome da região',
    endpointUrl: 'URL do endpoint',
    accessKeyId: 'ID da chave de acesso',
    secretAccessKey: 'Chave de acesso secreta',
    bucketName: 'Nome do bucket',
    apiUserName: 'Nome de usuário da API',
    apiPassword: 'Senha da API',
    zingBrandId: 'ID de ZingBrand',
    configuredDate: 'Data de configuração',
    configuredBy: 'Configurado por',
    standardTaxModel: 'Modelo de imposto padrão',
    loyaltyProgram: 'Programa de fidelidade',
    activationMinimumAmount: 'Valor mínimo de ativação',
    activationMinimumAmountDesc: 'Os jogadores devem ter pelo menos o valor mencionado em suas carteiras para poder ativar o bônus.',
    authentigateDescription:
      'Authentigate é a sua solução completa para a autenticação de identidade eletrônica mais popular nos países bálticos. Conecte Smart-ID, Mobile-ID, eParaksts mobile e o cartão de identidade estoniano por meio de um gateway seguro.',
    betStatusCorrectionsNotification: 'Defina limites e requisitos de confirmação para os operadores, permitindo que eles aprovem ou cancelem ações que excedam o limite.',
    trustlyDescription: 'O Trustly Pay and Play oferece aos jogadores um fluxo de integração rápido e perfeito que combina depósitos, verificação de usuário e criação de conta.',
    trustlyNote: 'O Pay and Play deve ser configurado primeiro na página Paydrom antes de habilitar esta opção.',
    relumActivation:
      'Ao ativar o produto Relum, você obtém acesso a vários jogos de diversos provedores de jogos premium, permitindo que você crie uma experiência de jogo personalizada para seus jogadores.',
    sportsBookActivation:
      'Ao ativar o produto Sportsbook, você terá acesso a uma interface completa, multilíngue, com suporte a múltiplas moedas e personalizável, com eventos ao vivo e pré-jogo para diferentes modalidades esportivas, ligas do mundo todo e uma enorme variedade de mercados de apostas.',
    domain: 'Domínio',
    whiteIps: 'IPs permitidos',
    betStatusCorrections: 'Correções de status de apostas',
    autoDeposit: 'Depósito automático',
  },
  zh: {
    mainCurrency: '主要货币',
    mainLanguage: '主要语言',
    market: '市场',
    setMainCountry: '设置主要国家',
    setMainCurrency: '设置主要货币',
    setMainLanguage: '设置主要语言',
    redirectedTo: '重新定向至',
    verifyDomain: '验证域名',
    onlyVerifiedDomainInfo: '只可连接经验证的域名',
    disconnectDomain: '断开域',
    connectDomain: '连接域',
    deleteDomain: '删除域',
    deleteScript: '删除脚本',
    deactivateScript: '停用脚本',
    activateScript: '激活脚本',
    supportedCurrencies: '支持的货币',
    supportedCountries: '支持的国家',
    supportedLanguages: '支持的语言',
    providerDisableInfo: '供应商可能已被整个系统禁用',
    activity: '活动',
    verificationAnd: '验证（和）',
    verificationOr: '验证（或）',
    andDelimiter: '和',
    currencyFrom: '货币从',
    currencyTo: '货币至',
    reverseRate: '逆向速率',
    feature: '特点',
    otherTransactions: '其他交易',
    playersNotifiedDate: '通知日',
    depositProcessingType: '存款处理类型',
    withdrawalProcessingType: '取款处理类型',
    allowedActivities: '允许活动',
    depositSupportedCurrencies: '支持的存款货币',
    withdrawalSupportedCurrencies: '支持的取款货币',
    newFee: '新的费用，％',
    feeBefore: '收费前，%',
    newLimit: '新限制',
    statusDisabledInfo: '网站将无法从所有域中获得。',
    statusActivitiesDisabledInfo: '不接受新的投注。',
    statusVersionNamesDisabledInfo: '选定的版本将禁用投注。',
    timezoneInfo: '任何正在进行的与时区有关的计算将被改变。',
    domainRedirection: '域名重定向',
    uVerify: '验证',
    redirect: '重新定向',
    forwardingURL: '转发URL',
    destinationURL: '目标URL',
    domainRedirectInfo: '在不删除现有规则的情况下，不能删除用作转发或目标URL的域名。',
    registerDomainInfo: '您需要在您的谷歌账户中注册所有的域名，以便为所有的域名启用验证码。',
    ageRestriction: '年龄限制',
    passwordPattern: '密码模式',
    failedAttemptsPeriod: '尝试失败时期',
    lockPeriod: '封锁期',
    passwordReminder: '密码提醒',
    inactivityPeriod: '不活动期',
    securityPeriod: '安全检查期',
    referralActivationPeriod: '推荐人激活期',
    passwordPatternNote: '我们建议密码至少有8个字符，包括至少一个数字和一个大写字母。然而，您可以将其弱化为拥有6-20个拉丁字母、数字或特殊字符。',
    referralActivationPeriodNote: '您希望保留推荐人的ID信息以便在网站上进行新的注册周期。',
    playerVerification: '玩家验证设置',
    verificationConf: '验证配置',
    correspondingTranslations: '确保所有的翻译内容都得到相应的更新。',
    verificationCodeLength: '验证码长度',
    dailyMobileVerification: '每日手机验证请求',
    emailRequestsInDaily: '每日电子邮箱验证请求',
    expirationMinutes: '代币失效期',
    expirationMinutesNote: '配置定义了通知中的标记（代码、链接）在一段时间后将变得无效。',
    emailRequestsInDailyNote: '配置定义了玩家一天内可以收到多少封要求验证的电子邮件。最小值为 {{value}}。',
    dailyMobileVerificationNote: '配置定义了玩家一天内可以收到多少条要求验证的短信。最小值为 {{value}}。',
    identityDocument: '身份证明文件',
    addressDocument: '地址文件',
    additionalDocument: '附加文件',
    disableSportBook: '禁用 {{name}}',
    gameDisableTooltip: '游戏可能已在整个系统中被禁用',
    playerLimitInfo: {
      text1: '您可以为每一种限制类型设置限制严重程度下降期。',
    },
    depositDecreaseLimit: '存款限制',
    betDecreaseLimit: '投注限制',
    withdrawalDecreaseLimit: '取款限制',
    activateSportsbook: '激活体育博彩',
    customScriptInfo: '您可以通过添加自定义脚本整合新的应用程序，通过添加自定义脚本为您的网站提供功能。',
    scriptName: '脚本名称',
    insideHead: '在关闭的</head>标签内',
    insideBody: '在关闭的</body>标签内',
    headTag: '标题标签脚本',
    bodyTag: '身体标签脚本',
    service: '服务',
    integrate: '对接',
    showOnLive: '在线网站上展示',
    showOnLiveTitle: '当您关闭这个切换器时，第三方服务的图标将从您的网站主页上隐藏。',
    apiSecret: 'API保密问题',
    apiSecretOrPass: 'API秘密问题或密码',
    apiKeyOrUsername: 'API密钥或用户名',
    sendEmailVia: '发送电子邮件通过',
    smtpUser: 'SMTP用户',
    smtpPass: 'SMTP密码',
    useSSL: '使用SSL',
    smtpHost: 'SMTP主机',
    smtpPort: 'SMTP端口',
    emailsInfo: {
      text1: '有SMTP供应商被要求提供相同的电子邮件，以便在他们那边注册。',
      text2: '请确保符合要求。',
    },
    emailsInfo1: '所有带有此电子邮件的定时信息将被移至草稿中',
    blockCountries: '屏蔽的国家',
    blockCountriesMainText: '一些国家的网站将无法访问。',
    versionControl: '版本控制',
    policies: '政策',
    policy: '政策',
    dateToNotify: '通知的日期',
    featureName: '功能名称',
    createBrand: '创建品牌',
    builder: '建造者',
    platformState: '平台状态',
    minMaxWithdrawalAmount: '最低-最高系统取款金额',
    minWithdrawalAmount: '最低取款金额',
    maxWithdrawalAmount: '最高取款金额',
    minMaxDepositAmount: '最低—最高系统存款金额',
    minDepositAmount: '最低存款金额',
    maxDepositAmount: '最高存款金额',
    operationFeePercent: '运营费用，%',
    withdrawalFeePercent: '取款手续费，%',
    withdrawalFee: '取款手续费',
    withdrawalFeeForUsedBalancePercent: '已用余额的取款手续费，%',
    withdrawalFeeForUsedBalance: '已用余额的取款手续费',
    allowedConversion: '允许的转换',
    paymentMethodName: '付款方式名称',
    minAmount: '最低 {{title}} 金额',
    maxAmount: '最高 {{title}} 金额',
    minMaxSystemAmount: '最低—最高系统 {{title}} 金额',
    depositFeePercent: '存款手续费，%',
    depositFee: '存款手续费',
    allowConversion: '允许的转换',
    previewLive: '实时预览',
    feeFromDeposit: '存款手续费',
    allowWithdrawalFromUnusedBalance: '允许从未使用的余额中取款',
    allowWithdrawalFeeUsedBalance: '取款费将从剩余余额中扣除。',
    feeCalculationForWithdrawals: '取款手续费计算',
    feeFromWithdrawals: '取款手续费',
    feeFromWithdrawalsUsedBalance: '取款手续费（已使用余额）',
    feeFromWithdrawalsBalance: '取款手续费（{{type}} 余额）',
    unusedBalanceInfo: '激活后，“未使用”余额选项将出现在“取款手续费”设置中',
    paymentTransactionType: '付款交易类型',
    paymentMethodType: '付款方式类型',
    playerPaymentRelation: '玩家与付款之间的关系',
    failedPaymentAttempts: '尝试付款失败',
    failedPaymentAttemptsPeriod: '尝试付款失败时期',
    temporaryBlockPeriod: '临时屏蔽期',
    reverseConversion: '{{title}} 反向转换',
    lCustomScript: '自定义脚本',
    largeTransactions: '大额交易',
    lBrand: '付款方式',
    playerSettings: '玩家设置',
    verificationConfigurations: '验证配置',
    theCurrency: '货币',
    mainCountry: '主要国家',
    theLanguage: '语言',
    smsSettings: 'SMS设置',
    verificationSettings: '验证设置',
    smtpSettings: 'SMTP设置',
    captchaSettings: '验证码设置',
    theEmail: '电子邮件',
    conversions: '转换',
    theConversion: '转换',
    theCountry: '国家',
    playerVerificationSettings: '玩家验证设置',
    domainRedirectionRule: '域重定向规则',
    wageringActivities: '投注活动',
    theSportsBook: '体育博彩',
    sportsBook: '体育博彩',
    theSportsBookView: '体育博彩视图',
    setMainView: '设置主视图',
    feeForWithdrawalsWillBeHeld: '取款手续费将从余额中扣留。',
    brandName: '付款方式名称',
    defaultCountry: '默认国家',
    defaultLanguage: '默认语言',
    defaultCurrency: '默认货币',
    products: '产品',
    websiteTemplate: '网站模板',
    failedPaymentInfo: '由于“付款程序失败”标准未激活，导致配置不可用。请从“标准”版块将其激活。',
    depositWithdrawalPaymentMethodInfo: '如果发生变化，使用转换功能的付款方式将受到影响，如果与新的变化冲突，系统可能会重置自定义的最低/最高限额。请确保在付款方式的设置中查看限额及可用货币。',
    otherPaymentMethodInfo: '使用转换的内部功能将使用这些汇率。确保所有转换均到位（如推荐奖金）。',
    conversionSettingsInfo: '当前限制与系统/系统转换的限制冲突。',
    card: '卡',
    imageAlt: '图像Alt',
    recommendedSize: '推荐尺寸',
    stateOrRegion: '国家/地区',
    socialLinks: '社会联系',
    socialLinkInfo: '公司在不同资源上的简介页面，如Facebook、Twitter、Google+、Instagram、Youtube、LinkedIn、Wikipedia等等。您可以添加不限数量的URL。',
    content: '内容',
    image: '图像',
    depositPaymentCategory: '存款支付类别',
    withdrawalPaymentCategory: '取款支付类别',
    createNewBrand: '创建新付款方式',
    lConversion: '转换',
    allowWithdrawalViaTheDepositedMethods: '只允许使用与存款相同的方法取款。',
    allowWithdrawalViaTheDepositedMethodsInfo: '只允许使用与存款相同的方法取款。',
    schemaMarkupSettings: '模式标记设置',
    accountId: '账户ID',
    accountIdInfo: '任何与服务账户ID相关的识别名称或代码，提供特定级别的访问。',
    ranges: '范围',
    depositAmountRanges: '存款金额范围(从-到)',
    taxPercentage: '税率百分比',
    lTaxes: '税',
    withdrawalAmountRanges: '取款金额范围（从-到）',
    fixedAmountOrPercent: '固定金额或税收百分比',
    spotsBookJackpotDescription: '启用后在登陆页面上可以看到体育大奖小工具。',
    spotsBookPrematchTopMatchesDescription: '启用后在体育博彩的Iframe和登陆页面上都可以看到热门比赛的小工具。',
    spotsBookScrollingTypeDescription: '该设置仅适用于标准视图，当启用时，体育页面可完全通过一次滚动进行滚动。',
    spotsBookTournamentBalanceDescription: '启用后锦标赛余额可在网站主页上看到。',
    sportJackpot: '运动大奖',
    sectionsScrolling: '栏目滚动',
    sportTournamentBalance: '体育比赛的余额',
    iframe: 'Iframe',
    native: '本地',
    sportsBookIframeIntegrationDescription: '该体育博彩将以在线框架的形式提供',
    sportsBookNativeIntegrationDescription: '体育博彩将直接在应用内构建的',
    sportsBookMobileIntegrationType: '移动端整合类型',
    setAsDefault: '设为默认',
    configs: '配置',
    availableLayouts: '可用布局',
    setAmountRangesInfo: '如果一个范围同时设置了 "固定金额 "和 "税收百分比"，系统应按以下方式计算税收：预扣固定税额+超过该范围 "来自 "字段中设置的金额的x百分比。',
    depositAmountRangesHint: '存款金额范围 "的 "自 "字段中的金额包括在该范围内，而 "至 "字段中的金额则不包括在该范围内。',
    withdrawalAmountRangesHint: '提款金额范围 "的 "自 "字段中的金额包括在该范围内，而 "至 "字段中的金额则不包括在该范围内。',
    fixedAmountHint: '“固定金额”字段中的金额应低于或等于“存款金额范围”的“自”字段中输入的金额。如果金额“自”为0，则“固定金额”字段中的金额也必须为0。',
    fixedAmount: '固定金额',
    brandSportsBookActivation: '通过激活体育博彩产品，您将可以访问65项以上体育赛事的现场和赛前活动的自定义界面。激活后，只能从体育博彩管理面板停用产品。',
    amountFrom: '金额自',
    allowPlayerCompose: '允许玩家“编写”消息',
    sportsBookInheritWebsiteColor: '继承网站颜色',
    sportsBookInheritWebsiteColorDescription: '该设置适用于所有体育页面。',
    theBrand: '付款方式',
    taxSettings: '税收设置',
    infoUrlHint: '这个URL将在网站上用于显示税收的详细信息。',
    everyMatrixDescription: '模块化和API驱动的iGaming解决方案旨在释放大胆的想法',
    smarticoAffiliateDescription: '与客户建立联系的最佳方式',
    hotjarDescription: '了解用户如何在不被数字淹没的情况下真正体验您的网站',
    hotjarId: 'HotJar ID',
    googleAnalyticsId: 'Google Analytics ID',
    googleAnalyticsDescription: '分析网站的使用情况',
    googleSiteVerificationCode: 'Google的网站验证码',
    googleSearchConsoleDescription: '获得帮助来监控、维护和排除您的网站在Google搜索结果中的存在。',
    copyPasteFieldName: '复制你的{{fieldName}}并粘贴到下面的字段。',
    learnMore: '了解更多...',
    affiliateInfo: '{{count}}集成不能同时激活',
    liveChatDescription: '线上交流应用程序，使您和您的网站访客能够实时聊天',
    liveAgentDescription: '提供卓越的客户服务',
    intercomDescription: '在这里建立良好的客户关系',
    zendeskDescription: '更有效地与客户沟通',
    intercomId: 'Intercom ID',
    zendeskId: 'Zendesk ID',
    liveChatLicenseNumber: 'LiveChat LICENSE_NUMBER',
    liveAgentYourLa: 'LiveAgent YOUR-LA',
    liveAgentButtonID: 'LiveAgent按钮的ID',
    digitainAgIdInfo: '这是 "Digitain代理 "管理面板中的付款方式ID。',
    depositCurrencyInfo: '如果玩家被允许用支付方式支持的所有货币进行存款，那么支付方式的 "允许转换 "与支持的货币配置应该是激活的。',
    pageGroups: '页面组',
    digitainRetailInfo: '这是 "Digitain Retail "管理面板中付款方式的ID。',
    smarticoDescription: '利用挑战和游戏技术来激励玩家的游戏化解决方案',
    smarticoLabelKey: '标签键',
    brandKey: '付款方式键',
    smarticoBrandKeyInfo: '一个付款方式的公键',
    smarticoLabelKeyInfo: '一个标签的公键',
    smarticoNote: 'Smartico CRM和游戏化是相互关联的，本节中的每个动作对游戏化也有影响。',
    realityCheckPeriod: '真实性检验期',
    timeOut: '暂停时间',
    prematchTopMatches: '赛前热身赛',
    prematchTotalTopMatches: '赛前热门赛（包括全市场）',
    spotsBookPrematchTotalTopMatchesDescription: '启用后，可使用包含全市场数据的赛前热门比赛小工具',
    livePrematchTopMatches: '现场和赛前顶级比赛',
    spotsBookLivePrematchTopMatchesDescription: '启用“实时和赛前顶级比赛”小工具后即可使用',
    liveTopMatches: '实时顶级比赛',
    spotsBookLiveTopMatchesDescription: '启用“实时顶级比赛”小工具后即可使用',
    periodCalculationSource: '期间计算来源',
    periodCalculationSourceInfo: '选择开始计算验证期的日期来源',
    verificationPeriod: '验证期',
    verificationPeriodInfo: '玩家账户在验证前可以活跃的天数',
    unverifiedPlayersExclusionsInfo: '如果在“忽略存款验证的支付”菜单中选择了付款方式，且在“最大存款额”部分设置了限额，则该限额不会影响该付款方式。',
    responsibleGamingPeriodLimitsInfo: '在本部分中，您可以设置玩家可以选择暂停和自我排除的特定时间段。',
    preferencesDescription: '为玩家激活/停用短信、电子邮件和推送通知。',
    preferencesSMSDescription: '为品牌的所有参与者发送短信，并在网站上 “通过短信”部分应该是不可见的',
    preferencesEmailDescription: '为品牌和网站上的所有参与者发送电子邮件 并且在网站上“通过电子邮件"部分应变得不可见',
    walletsSettings: '钱包设置',
    wallets: '钱包',
    features: '特征',
    ddaInfo: '激活该选项后，提款的税款将在DDA逻辑中预扣。',
    whatsAppDescription: '让您的客户使用世界上最流行的通讯工具联系您。',
    phoneNumber: '手机号',
    whatsAppPhoneNumberInfo: '输入您注册WhatsApp帐户的手机号',
    multiGameLaunch: '多游戏启动',
    multiGameLaunchDescription: '根据配置，网站上提供了多游戏选项，玩家可以同时玩多个游戏。',
    jackpotWidget: '大奖小工具',
    jackpotWidgetDescription: '请参阅 赌场大奖小工具登陆页面激活。适用于Amusnet供应商大奖小工具。',
    gameIframe: '游戏Iframe',
    manuBarFixation: '菜单栏定制',
    manuBarFixationDescription: '仅适用于移动视图，具体取决于大厅的主栏固定配置。',
    paymentVisibilityInfo: '在本部分中，您可以隐藏或不允许拥有以下标签之一的玩家使用付款方式',
    centrivoConnectAgDescription: '使用Centrivo的连接代理解决方案改变您的iGaming业务',
    retailCentrivoDescription: '使用Centrivo的零售解决方案改变您的iGaming业务',
    currencySymbol: '货币符号',
    preferencesPushNotificationsDescription: '推送通知渠道将可用于为品牌发送通知',
    currencyFormat: '货币格式',
    currencyFormatInfo: '在网站上为玩家显示哪种货币格式。',
    isoCode: 'ISO代码',
    symbols: '符号',
    digitainCrmDescription: 'CRM解决方案旨在保持现有玩家的参与度，提高他们的整体满意度',
    accessDecreaseLimit: '访问限制',
    depositOnNegativeBalance: '负余额存款',
    depositOnNegativeBalanceInfo: '存款批准后，将对玩家的负钱包进行调整，以结清债务。',
    digitainAffiliateDescription: '激活您的附属联盟计划并体验网站流量的显著提升。',
    projectId: '项目ID',
    projectIdInfo: '这是“Digitain附属”管理面板中的项目ID',
    brandIdInfo: '这是“Digitain附属”管理面板中的品牌ID',
    maintenanceSetup: '维护设置',
    maintenancePeriod: '维护期',
    sportsBookViews: '体育博彩视图',
    mandatoryNotification: '强制通知',
    mandatoryNotificationInfo: '在网站上为已登录玩家强制弹出窗口',
    lossDecreaseLimit: '损失限制',
    inactivityIndicators: '不活跃指标',
    inactivityIndicatorsInfo: '该配置将根据玩家的最后登录日期或最后交易（投注、存款、取款）日期等指标之一，将玩家视为非活跃玩家。',
    recoverByPlayer: '按玩家恢复',
    recoverByPlayerInfo: '启用后，玩家可通过验证码找回自己',
    singleBetDecreaseLimit: '单次投注限额',
    cashierType: '出纳类型',
    lIcon: '图标',
    gameLaunchType: '游戏启动类型（移动视图）',
    gameFullScreenLaunchDescription: '用iframe全屏打开游戏',
    gameHeaderFooterLaunchDescription: '用iframe和页眉页脚打开游戏',
    gameQuickActionBarLaunchDescription: '通过快速操作栏打开游戏',
    limitEffectConfigs: '限制效果配置',
    ignoreFirstDeposit: '忽略首次存款',
    ignoreFirstDepositHint: '如果选择此选项，玩家的首次终身成功存款将不计算在负责任博彩存款限额内。',
    periodLimit: '期间限制',
    playerLimitsConfiguration: '玩家限制配置',
    alanbaseDescription: '由iGaming和附属营销专家为您提供的平台，帮助其他专家优化成本，提高利润。',
    routForEvents: '赛事路线',
    routForGoals: '进球途径',
    fastDepositPaymentMethod: '快速存款支付方式',
    fastDepositPaymentMethodInfo: '快速存款是网站上的一项功能，通过该功能，玩家可以使用“Centrivo”预定义的付款方式存款，而无需离开游戏页面。',
    sportStatusIconsInfo: '上传的图标将在网站的玩家资料中显示。每个上传的图标将在不超过一小时后反映在网站上。',
    rolloverBetsReturn: '展期投注返回同一钱包',
    rolloverBetsReturnInfo: '如果从展期余额中投注的金额被退回/取消，该金额将转入展期余额中',
    maxDepositAmounts: '最大存款额',
    paymentsIgnoringDepositVerification: '忽略存款验证的支付',
    selfExclusion: '自我排除',
    setMainDomain: '设置主域',
    disconnected: '断线',
    configureLimits: '配置限制',
    metaMapDesc: '在单一平台上验证客户的一切需求',
    clientId: '客户ID',
    clientIdInfo: '用于识别您作为商家。',
    clientSecret: '客户秘密',
    clientSecretInfo: '使用控制面板中的client_secret作为密码。',
    pushGameState: '推送游戏状态',
    pushGameStateDescription: '此设置定义了聚合器发送到后台的游戏状态（“游戏状态”）。',
    thunderBiteDescription: '将客户体验游戏化，将参与度转化为忠诚度。',
    campaignURL: '活动URL',
    captchaCaseInsensitiveInfo: '启用验证码选项后，系统不会区分大写字母和小写字母，因为它们被认为是相同的。',
    caseInsensitive: '不区分大小写',
    verificationRequestPeriod: '短信/电子邮件验证申请期限',
    verificationRequestPeriodInfo: '配置定义下一次向玩家发送短信/邮件验证请求的时间',
    sec: 'sec',
    integratedDate: '整合日期',
    integratedBy: '集成方',
    isInvisible: '是不可见',
    captchaInvisibleInfo: '如果选中，玩家将看不到验证码',
    captchaLogonAttemptsInfo: '定义尝试登录失败的次数、计算这些尝试的时间段以及验证码出现的持续时间。',
    jackpot: '大奖',
    globalState: '全球状态',
    jackpotGames: '大奖游戏',
    myAffiliatesDescription: '市场上最灵活的联属会员跟踪软件',
    sportDomainsTabInfo: '最大运动域名数为{{count}}。只有激活的域才能设置为主域。只能连接已验证的域。',
    firebaseAuthenticationDescription: '使用Firebase配置社交媒体平台的用户注册和登录验证。',
    frontend: '前端',
    backend: '后台',
    google: '谷歌',
    facebook: 'Facebook',
    socialMediaPlatforms: '社交媒体平台',
    optimoveDescription: 'CRM解决方案旨在维持现有玩家的参与度并提高他们的整体满意度。',
    baseUrl: '基本URL',
    forcePasswordChangeNote: '启用该选项后，如果超过了设定的期限，玩家就必须更改密码。\n密码提醒期过后，如果启用了该选项，玩家在未修改密码的情况下就无法登录网站。',
    forcePasswordChange: '强制更改密码',
    playerTags: '玩家标签',
    additional: '附加',
    gameTimeLimit: '游戏时间限制',
    verificationOptions: '验证选项',
    blockActions: '屏蔽操作',
    userNotification: '用户通知',
    winAmounts: '赢钱金额',
    largeWinTransactionNotification: '大额赢钱交易通知只会发送给选定的用户。如果有任何用户被选中，请确保为所有货币配置了赢钱金额。',
    promptOnLogin: '登录时提示',
    promptOnLoginInfo: '选择此选项后，玩家需要在首次登录时设置限额',
    productCategory: '产品类别',
    betProfitRange: '投注利润范围（从 - 到）',
    betProfitRangeHint: '“投注利润范围”中“从”字段的金额包含在此范围内，而“到”字段中的金额不包含在内。',
    betTaxInfo: '根据首选的税收计算方法，可以将单个“产品类别”分配给“累计”或“每次交易”税收类型。',
    betTaxStandardDisabledInfo: '激活“税收”和“投注利润税”以为您的品牌启用税收引擎。',
    depositTaxStandardDisabledInfo: '激活“税收”和“存款税”以为您的品牌启用税收引擎。',
    withdrawalTaxStandardDisabledInfo: '激活“税收”和“取款税”以为您的品牌启用税收引擎。',
    registrationUniqueness: '注册唯一性',
    registrationUniquenessNote: '在玩家注册期间应验证所选组合的唯一性。',
    responsibleGamingLimitsInfo: '在本节中，您可以设置预定义值，这些值将在设置期间自动填充为默认限制，但可以手动调整。可以启用/禁用登录提示，这将要求玩家设置限制。',
    hours: '{{number}} 小时',
    days: '{{number}} 天',
    month: '{{number}} 月',
    year: '{{number}} 年',
    viewDefaultAmount: '查看默认额',
    viewDefaultLimit: '查看默认限制',
    realTimeUniquenessCheck: '实时唯一性检验',
    realTimeUniquenessCheckNote: '启用此功能后，系统将在注册过程中立即检查手机号码、ID和电子邮件的唯一性。',
    appToken: '应用令牌',
    accountVerificationOptions: '帐户验证选项',
    accountVerificationOptionsInfo: '选择玩家账户将被视为已验证的选项',
    markAsUnverified: '标记为未验证',
    markAsUnverifiedInfo: '启用后，玩家将根据设定的规则被标记为未经验证',
    verificationPeriodTabInfo: {
      text1: '在本节中，您可以设置规则以在特定时间段后自动阻止未经验证的玩家。',
      text2: '如果玩家未完成“验证配置”部分中定义的必要验证步骤，则会被视为未验证。通过所选验证的玩家将被视为已验证。未验证的玩家将被标记为“未验证”而被屏蔽。',
    },
    notificationReminder: '通知提醒',
    notificationReminderInfo: '提醒玩家验证账户的天数',
    blockForUnVerify: '因未验证而屏蔽',
    blockForUnVerifyOptions: '屏蔽未验证选项',
    betOddsLimit: '投注赔率限制',
    betOddsLimitInfo: '如果投注的赔率低于指定赔率，则赢得的金额将按比例分配给投注的钱包（已使用和未使用）',
    selfExclusionReason: '自我排除原因',
    selfExclusionReasonInfo: '如果选择了该原因，玩家就不能通过选择指定的原因对账户设置自我排除',
    balanceVisibility: '余额可见度',
    balanceVisibilityNote: '品牌玩家可以看到所选余额。',
    configured: '已配置',
    limitEffectPeriodInfo: '更改将在设定的时间（立即、24小时、48小时或7天）后生效，或在下一个日历周期开始时生效 - 每日限制在午夜生效，每周限制在星期一生效，每月限制在每月1日生效。',
    documentsConfig: '文件配置',
    documentsConfigInfo: '以下类型的文件所需页数始终为1',
    pageCount: '页数',
    realityCheckSettings: '真实性检验设置',
    calculationType: '计算类型',
    realityCheckInterval: '真实性检验间隔',
    showLogOutButton: '显示登出按钮',
    realityCheckSettingsInfo: '仅当在“标准”部分启用“真实性检验”时，这些配置才会适用',
    realityCheckStatus: '真实性检验状态',
    realityCheckPeriodInfo: '这些时间段将显示在玩家在网站上的账户中',
    realityCheckIntervalInfo: '定义向玩家显示真实性检验弹出窗口的时间间隔',
    capitalizePlayerData: '玩家数据资本化',
    capitalizePlayerDataInfo: '启用此功能后，系统将在注册过程中将名/姓、地址和城市字段大写，并保存在后台办公室中',
    blockedCountriesInfo: '操作（解除屏蔽、完全屏蔽、屏蔽登录、屏蔽注册、屏蔽登录和注册）可单独应用于每个国家，也可批量应用，一次性更新其状态。',
    bulkAction: '批量操作',
    multiPeriodLimitType: '多期限额类型',
    singlePeriodLimitType: '单期限额类型',
    changeEffectPeriods: '变化影响期',
    lastMonthPeriod: '上月期间',
    eddVerificationNotification: 'EDD配置将触发合格玩家的资金来源验证',
    totalDepositAmount: '存款总额',
    dda: 'DDA',
    brandBonusesInfo: '此部分允许用户根据特定条件为品牌设置奖金激活逻辑。 如果任何条件不满足，奖金将不会被激活。',
    firstSuccessfulDeposit: '首次成功存款',
    firstSuccessfulDepositDesc: '玩家必须至少有一次成功存款，才有资格激活奖金。',
    sportStatusDesc: '具有所选状态的玩家无资格激活已收到的奖金。',
    standardTaxModelInfo: '通过将所述税率应用于存款总额来计算存款的税费。',
    vatTaxModelInfo: '根据增值税公式，将所述增值税百分比应用于总金额，以计算存款的税费。存款总额包含增值税。',
    setVatAmountRangesInfo: '系统会自动从总金额中分离出增值税部分，以计算实际的存款金额。',
    multiBetOfTheDay: '每日多重投注',
    sportSuperPromotion: '超级促销',
    schemaMarkupImage: 'Schema 标记图片',
    dataSendPeriod: '数据发送周期',
    demoLaunchDesktop: '演示启动（桌面）',
    demoLaunchMobile: '演示启动（移动端）',
    demoLaunchDesktopDescription: '根据配置，桌面端游戏将显示演示按钮，玩家可启动试玩',
    demoLaunchMobileDescription: '根据配置，移动端游戏将显示演示按钮，玩家可启动试玩',
    androidSettings: 'Android 设置',
    iosSettings: 'iOS 设置',
    googleCloudProjectId: 'Google Cloud 项目 ID',
    mobileReCaptcha: '移动端 reCAPTCHA',
    androidReCaptchaKey: 'Android reCAPTCHA 密钥',
    androidKeyId: 'Android Key ID',
    iosReCaptchaKey: 'iOS reCAPTCHA 密钥',
    iosKeyId: 'iOS Key ID',
    playerApproval: '玩家确认',
    playerApprovalInfo: '在变更生效期后，应用更弱限制前需玩家确认',
    transactionTypeNote: '所选类型将在网站收银对品牌玩家可见',
    domainDeletion: '域名删除',
    incomeAccessDescription: '加入服务时间最长的 iGaming 联盟营销网络',
    suggestedAmounts: '建议金额',
    defaultAmount: '默认金额',
    viewLimits: '查看限额',
    configureAmounts: '配置金额',
    suggested: '推荐',
    otherTypeDocumentConfigInfo: '除 <0>Other</0> 外，所选文件数量为必填；对于 <0>Other</0>，所选数量为最大允许值，可上传更少文件',
    uploadReCaptchaInfo: '可上传有效的 JSON 文件用于 ReCaptcha 配置',
    androidPrivateKey: 'Android 私钥',
    iosPrivateKey: 'iOS 私钥',
    indefiniteTimePeriod: '无限期',
    sportMinBetAge: '体育最低投注年龄',
    casinoMinBetAge: '娱乐场最低投注年龄',
    zingBrainDesc: 'ZingBrain 是一款易于集成的 iGaming 行业性能优化平台',
    awsCloudDescription: '配置 AWS 以启用数据上传',
    zingBrandDescription: '集成 ZingBrain 以启用基于 AI 的大厅内容推荐配置',
    regionName: '区域名称',
    endpointUrl: '接口地址',
    accessKeyId: '访问密钥 ID',
    secretAccessKey: '访问密钥',
    bucketName: '存储桶名称',
    apiUserName: 'API 用户名',
    apiPassword: 'API 密码',
    zingBrandId: 'ZingBrand ID',
    configuredDate: '配置日期',
    configuredBy: '配置人',
    standardTaxModel: '标准税务模型',
    loyaltyProgram: '忠诚度计划',
    activationMinimumAmount: '激活最低金额',
    activationMinimumAmountDesc: '玩家钱包余额需达到该金额方可激活奖金',
    authentigateDescription: 'Authentigate 是一体化波罗的海 eID 认证解决方案，可通过单一安全网关连接 Smart-ID、Mobile-ID、eParaksts mobile 及爱沙尼亚身份证',
    betStatusCorrectionsNotification: '为运营商定义限额与确认要求，允许批准或取消超额操作',
    trustlyDescription: 'Trustly Pay and Play 为玩家提供快速无缝的注册流程，整合存款、身份验证与账户创建',
    trustlyNote: '启用前需先在 Paydrom 页面配置 Pay and Play',
    relumActivation: '启用 Relum 产品后，可接入多家高端游戏供应商的多款游戏，打造个性化娱乐体验',
    sportsBookActivation: '启用体育博彩产品后，可获得多语言、多币种、可定制的体育博彩界面，涵盖全球联赛及大量投注市场',
    domain: '域名',
    whiteIps: '白名单 IP',
    betStatusCorrections: '投注状态修正',
    autoDeposit: '自动存款',
  },
  ro: {
    mainCurrency: 'Valuta principală',
    mainLanguage: 'Limba principală',
    market: 'Piață',
    setMainCountry: 'Setează țara principală',
    setMainCurrency: 'Setează moneda principală',
    setMainLanguage: 'Setează limba principală',
    redirectedTo: 'Redirecționat către',
    onlyVerifiedDomainInfo: 'Doar domeniile verificate pot fi conectate',
    disconnectDomain: 'Deconectează domeniul',
    connectDomain: 'Conectare Domeniu',
    deleteDomain: 'Ștergere Domeniul',
    deleteScript: 'Ștergere Script',
    deactivateScript: 'Deactivare Script',
    activateScript: 'Activare Script',
    supportedCurrencies: 'Valute acceptate',
    supportedCountries: 'Țări acceptate',
    supportedLanguages: 'Limbi acceptate',
    providerDisableInfo: 'Este posibil ca furnizorul să fi fost dezactivat pentru întregul sistem',
    activity: 'Activitate',
    verificationAnd: 'Verificare (și)',
    verificationOr: 'Verificare (sau)',
    andDelimiter: 'și',
    currencyFrom: 'Valută din',
    currencyTo: 'Valuta către',
    reverseRate: 'Taxare inversă',
    feature: 'Caracteristică',
    otherTransactions: 'Alte tranzacții',
    playersNotifiedDate: 'Data de notificare',
    depositProcessingType: 'Tip de procesare a depozitului',
    withdrawalProcessingType: 'Tip de procesare a retragerii',
    allowedActivities: 'Activități permise',
    depositSupportedCurrencies: 'Valute acceptate pentru depunere',
    withdrawalSupportedCurrencies: 'Valute acceptate pentru retragere',
    newFee: 'Taxa nouă, %',
    feeBefore: 'Taxa înainte, %',
    newLimit: 'Limita nouă',
    statusDisabledInfo: 'Site-ul web va deveni indisponibil din toate domeniile.',
    statusActivitiesDisabledInfo: 'Nu vor fi acceptate pariuri noi.',
    statusVersionNamesDisabledInfo: 'Pariurile vor fi dezactivate pentru versiunile selectate.',
    timezoneInfo: 'Orice calcule în curs, legate de fusul orar, vor fi schimbate.',
    domainRedirection: 'Redirecționarea de domeniu',
    uVerify: 'VERIFICARE',
    redirect: 'Redirecționa',
    forwardingURL: 'URL de redirecționare',
    destinationURL: 'Adresa URL de destinație',
    domainRedirectInfo: 'Domeniul care este folosit ca adresă URL de redirecționare, sau de destinație, nu poate fi șters fără ștergerea regulei existente.',
    registerDomainInfo: 'Trebuie să-ți înregistrezi toate domeniile în contul tău Google pentru a activa captcha pentru toate.',
    ageRestriction: 'Restricție de vârstă',
    passwordPattern: 'Șablon de parolă',
    failedAttemptsPeriod: 'Perioadă de încercări eșuate',
    lockPeriod: 'Perioada de blocare',
    passwordReminder: 'Aducere aminte al parolei',
    inactivityPeriod: 'Perioada de inactivitate',
    securityPeriod: 'Perioada verificării de securitate',
    referralActivationPeriod: 'Perioada activării a recomandărilor',
    passwordPatternNote:
      'Se recomandă ca parolele să aibă minim 8 caractere, inclusiv cel puțin 1 număr și 1 literă mare. Totuși, le poți slăbi până la 6-20 de litere latine, numere sau caractere speciale.',
    referralActivationPeriodNote: 'Perioada pentru care dorești să păstrezi informațiile de identificare a refererului pentru o nouă înregistrare pe site.',
    correspondingTranslations: 'Asigură-ți că toate traducerile sunt actualizate în mod corespunzător.',
    verificationCodeLength: 'Lungimea codului de verificare',
    dailyMobileVerification: 'Solicitări zilnice de verificare pe telefon mobil',
    emailRequestsInDaily: 'Solicitări zilnice de verificare de e-mail',
    expirationMinutes: 'Perioada de expirare a token-ului',
    expirationMinutesNote: 'Configurația definește perioada după care token-ul (codul, linkul) din notificare va deveni nevalid.',
    emailRequestsInDailyNote: 'Configurația definește câte solicitări de e-mail pentru verificare jucătorul poate primi într-o zi. Valoarea minimă este de {{value}}.',
    dailyMobileVerificationNote: 'Configurația definește câte solicitări de SMS pentru verificare jucătorul poate primi într-o zi. Valoarea minimă este de {{value}}.',
    identityDocument: 'Document de identitate',
    addressDocument: 'Document de adresă',
    additionalDocument: 'Document adițional',
    disableSportBook: 'Dezactiva {{name}}',
    gameDisableTooltip: 'Este posibil ca jocul să fi fost dezactivat pentru întregul sistem',
    depositDecreaseLimit: 'Limită de depunere',
    betDecreaseLimit: 'Limită de pariu',
    withdrawalDecreaseLimit: 'Limită de retragere',
    activateSportsbook: 'Activează pariurile sportive',
    scriptName: 'Numele de script',
    insideHead: 'Tag-ul de închidere </head> în interior',
    insideBody: 'Tag-ul de închidere </body> în interior',
    headTag: 'scriptul etichetei de cap',
    bodyTag: 'scriptul etichetei de corp',
    service: 'serviciu',
    integrate: 'Integrează',
    showOnLive: 'Afișează pe site-ul live',
    showOnLiveTitle: 'Când dezactivezi acest comutator, pictograma serviciilor terță parte va fi ascunsă din pagina de pornire a site-ului tău web.',
    apiSecret: 'Secret de API',
    apiSecretOrPass: 'Secret API și parolă',
    apiKeyOrUsername: 'Cheia API și numele de utilizator',
    sendEmailVia: 'Trimite e-mail prin',
    smtpUser: 'Utilizator SMTP',
    smtpPass: 'Parolă SMTP',
    useSSL: 'Folosește SSL',
    smtpHost: 'Gazdă SMTP',
    smtpPort: 'Port-ul SMTP',
    emailsInfo1: 'Toate mesajele programate cu acest e-mail vor fi mutate în versiune nefinalizată',
    blockCountries: 'Țări blocate',
    blockCountriesMainText: 'Site-ul web va deveni indisponibil din țările selectate',
    versionControl: 'Controlul de versiuni',
    policies: 'Politici',
    policy: 'Politică',
    dateToNotify: 'Data de notificare',
    featureName: 'Nume caracteristică',
    createBrand: 'Crează Marcă',
    builder: 'Constructor',
    platformState: 'Starea platformei',
    minMaxWithdrawalAmount: 'Suma de retragere a sistemului min.-max.',
    minWithdrawalAmount: 'Suma de retragere minimă',
    maxWithdrawalAmount: 'Suma de retragere maximă',
    minMaxDepositAmount: 'Suma de depunere a sistemului min.-max.',
    minDepositAmount: 'Suma de depunere minimă',
    maxDepositAmount: 'Suma de depunere maximă',
    operationFeePercent: 'Taxa de operare, %',
    withdrawalFeePercent: 'Taxa de retragere, %',
    withdrawalFee: 'Taxa de retragere',
    withdrawalFeeForUsedBalancePercent: 'Taxa de retragere pentru soldul utilizat, %',
    withdrawalFeeForUsedBalance: 'Taxa de retragere pentru soldul utilizat',
    allowedConversion: 'Conversie permisă',
    paymentMethodName: 'Numele metodei de plată',
    minAmount: 'Sumă minimă de {{title}}',
    maxAmount: 'Sumă maximă de {{title}}',
    minMaxSystemAmount: 'Suma min.-max. de sistem {{title}}',
    depositFeePercent: 'Taxă de depunere %',
    depositFee: 'Taxă de depunere',
    allowConversion: 'Permite conversia',
    previewLive: 'Previzualizare live',
    feeFromDeposit: 'Comision din depunere',
    allowWithdrawalFromUnusedBalance: 'Permite retragerea din soldul neutilizat',
    allowWithdrawalFeeUsedBalance: 'Taxă de retragere va fi reținută din soldul rămas.',
    feeCalculationForWithdrawals: 'Calcul de taxă pentru retrageri',
    feeFromWithdrawals: 'Taxa de la retrageri',
    feeFromWithdrawalsUsedBalance: 'Taxa de la retrageri',
    feeFromWithdrawalsBalance: 'Taxa de la retrageri ({{type}} sold)',
    unusedBalanceInfo: 'Când este activată, opțiunea de sold „Nefolosit” va apărea în setarea de „Taxă de la retrageri”',
    paymentTransactionType: 'Tip de tranzacție de plată',
    paymentMethodType: 'Tip de metodă de plată',
    playerPaymentRelation: 'Relația jucător-plată',
    failedPaymentAttempts: 'Încercări de plată eșuate',
    failedPaymentAttemptsPeriod: 'Perioadă de încercări de plată eșuate',
    temporaryBlockPeriod: 'Perioadă de blocare temporară',
    reverseConversion: 'Conversie inversă {{title}}',
    lCustomScript: 'script personalizat',
    largeTransactions: 'Tranzacții mari',
    lBrand: 'marcă',
    playerSettings: 'Setări de jucător',
    verificationConfigurations: 'Configurații de verificare',
    theCurrency: 'Valută',
    mainCountry: 'Țara principală',
    theLanguage: 'Limba',
    smsSettings: 'setările SMS',
    verificationSettings: 'Setări de verificare',
    smtpSettings: 'Setări SMTP',
    captchaSettings: 'Setări Captcha',
    theEmail: 'e-mailul',
    conversions: 'Conversii',
    theConversion: 'Conversia',
    theCountry: 'Țara',
    playerVerificationSettings: 'Setări de verificare a jucătorului',
    domainRedirectionRule: 'Regula de redirecționare a domeniului',
    wageringActivities: 'Activități de pariuri',
    theSportsBook: 'Pariurile sportive',
    sportsBook: 'Pariuri sportive',
    theSportsBookView: 'Vizualizarea pariurilor sportive',
    setMainView: 'Seta vizualizarea principală',
    feeForWithdrawalsWillBeHeld: 'Taxa de retragere va fi reținută din soldul rămas.',
    brandName: 'Numele de marcă',
    defaultCountry: 'Țara implicită',
    defaultLanguage: 'Limba implicită',
    defaultCurrency: 'Valuta implicită',
    products: 'Produse',
    websiteTemplate: 'Șablon de web',
    failedPaymentInfo: 'Configurațiile nu sunt disponibile din cauza inactivității standardului „Procedură de plată eșuată”. Rugăm să îl activezi din secțiunea „Standarde”.',
    depositWithdrawalPaymentMethodInfo:
      'Metodele de plată care utilizează conversia vor fi afectate în cazul schimbărilor, iar limitele min/max personalizate pot fi resetate de sistem, dacă sunt în contradicție cu noile modificări. Asigură-ți că revizuiești limitele și disponibilitatea valutelor în setările metodelor de plată.',
    otherPaymentMethodInfo:
      'Funcționalitățile interne care utilizează conversia, vor folosi aceste rate de conversie. Asigură-ți că ai toate conversiile la locul lor (de exemplu, bonus de recomandare).',
    conversionSettingsInfo: 'Limita curentă contrazice sistemul / limita convertite de sistem.',
    card: 'Card',
    imageAlt: 'Image Alt',
    recommendedSize: 'Dimensiune recomandată',
    stateOrRegion: 'Stat/Regiune',
    socialLinks: 'Link-uri de socializare',
    socialLinkInfo: 'Paginile de profil ale companiei pe diferite resurse, cum ar fi Facebook, Twitter, Google+, Instagram, Youtube, LinkedIn, Wikipedia etc. Poți adăuga oricâte adrese URL dorești.',
    image: 'Imagine',
    depositPaymentCategory: 'Categoria de plată a depozitului',
    withdrawalPaymentCategory: 'Categoria de plată de retragere',
    createNewBrand: 'Crează o marcă nouă',
    lConversion: 'conversie',
    schemaMarkupSettings: 'Setări de schema Marchup',
    accountId: 'ID de cont',
    accountIdInfo: 'Orice nume sau cod de identificare asociat cu ID-ul contului de serviciu, care oferă un anumit nivel de acces',
    ranges: 'Intervale',
    depositAmountRanges: 'Intervalul sumei depunerii (de la - până la)',
    taxPercentage: 'Procentul de impozitare %',
    lTaxes: 'Impozite',
    withdrawalAmountRanges: 'Intervalul sumei de retragere (de la - până la)',
    fixedAmountOrPercent: 'Suma fixă sau procentajul de impozit',
    allowWithdrawalViaTheDepositedMethods: 'Permite retragerea doar prin intermediul metodelor depuse',
    allowWithdrawalViaTheDepositedMethodsInfo:
      'Activarea acestei setări restricționează jucătorul de a retrage bani prin metodele de plată/marcă pe care nu le-a folosit niciodată înainte pentru depunere ',
    spotsBookJackpotDescription: 'Odataă activat Widgetul Jackpot Sportiv, devine disponibil pe pagina de aterizare',
    spotsBookScrollingTypeDescription: 'Setarea se aplică doar pentru vizualizarea standard și, odată activată, pagina de Sport este complet derulabilă cu o singură defilare.',
    spotsBookTournamentBalanceDescription: 'Atunci când este activat, soldul turneului este disponibil pe pagina de pornire a site-ului web',
    sportJackpot: 'Jackpot Sportiv',
    sectionsScrolling: 'Derularea secțiunilor',
    sportTournamentBalance: 'Sold de turneu sportiv',
    iframe: 'Iframe',
    native: 'Nativ',
    sportsBookIframeIntegrationDescription: 'Casa de pariuri sportive va fi disponibilă într-un cadru inline',
    sportsBookNativeIntegrationDescription: 'Sportsbookul va fi disponibil direct în aplicația încorporată ',
    sportsBookMobileIntegrationType: 'Tipul de integrare pe telefonul mobil',
    setAsDefault: 'Setare ca implicit',
    configs: 'Configurații',
    availableLayouts: 'Pagina de layout-uri disponibile',
    setAmountRangesInfo:
      'Dacă sunt setate "Suma fixă" și "Procentul de impozit" pentru un interval, sistemul calculează impozitul în felul următor: a reține o sumă fixă de impozit + procentul x din suma, care depășește suma stabilită în câmpul "Din" al intervalului.',
    depositAmountRangesHint:
      'Suma din câmpul "De la" din secțiunea "Intervalul sumei depunerii" este inclusă în intervalul respectiv, în timp ce suma din câmpul "Până la" nu este inclusă în interval.',
    withdrawalAmountRangesHint: 'Suma din câmpul "De la" din "Intervalul sumei de retragere" este inclusă în acel interval, în timp ce suma din câmpul "Până la" nu este inclusă în interval.',
    fixedAmountHint:
      'Suma din câmpul "Sumă fixă" trebuie să fie mai mică sau egală cu suma introdusă în câmpul "De la" din "Intervalul sumei depunerii". În cazul în care suma "De la" este egală cu 0, suma din câmpul "Sumă fixă" trebuie să fie de asemenea 0.',
    fixedAmount: 'Sumă fixă',
    brandSportsBookActivation:
      'Prin activarea produsului Sportsbook vei avea acces la o interfață personalizabilă cu evenimente live și pre-meci pentru mai mult de 65 de sporturi. Odată activat, produsul poate fi dezactivat numai din panoul de administrare Sportsbook.',
    amountFrom: 'Suma din',
    allowPlayerCompose: 'Permite jucătorii să compună mesaje',
    sportsBookInheritWebsiteColor: 'Utilizează (a moșteni) culoarea site-ului web',
    sportsBookInheritWebsiteColorDescription: 'Setarea se aplică tuturor paginilor de sport.',
    theBrand: 'Marcă (metodă de plată)',
    taxSettings: 'Setări de impozite',
    infoUrlHint: 'Acest URL va fi folosit pe site-ul web pentru afișarea detaliilor fiscale.',
    everyMatrixDescription: 'Soluții iGaming modulare și bazate pe API, concepute pentru implementarea celor mai îndrăznețe idei',
    smarticoAffiliateDescription: 'Nu există o modalitate mai bună de a te conecta cu clienții ',
    hotjarDescription: 'Înțelege modul în care utilizatorii experimentează cu adevărat site-ul tău fără să te îneci în cifre',
    hotjarId: 'ID HotJar',
    googleAnalyticsId: 'ID de Google Analytics',
    googleAnalyticsDescription: 'Analizează utilizarea pe site-urile tale web',
    googleSiteVerificationCode: 'Codul de verificare a site-ului Google',
    googleSearchConsoleDescription: 'Obține ajutor pentru monitorizarea, menținerea și soluționarea problemelor legate de prezența site-ului tău în rezultatele căutării pe Google.',
    copyPasteFieldName: 'Copiază {{fieldName}} și inserează-l în câmpul de mai jos.',
    learnMore: 'Află mai mult',
    affiliateInfo: 'Integrările {{count}} nu pot fi active simultan',
    liveChatDescription: 'Aplicație de comunicare bazată pe internet, care permite să discuti în timp real cu vizitatorii site-ului tău web.',
    liveAgentDescription: 'Furbizează servicii excelente pentru clienți',
    intercomDescription: 'Începe să cultivi relații excelente cu clienții aici',
    zendeskDescription: 'Comunică mai eficient cu clienții',
    intercomId: 'ID de Intercom',
    zendeskId: 'ID Zendesk',
    liveChatLicenseNumber: 'LiveChat LICENSE_NUMBER',
    liveAgentYourLa: 'LiveAgent YOUR-LA',
    liveAgentButtonID: 'ID-ul butonului LiveAgent',
    digitainAgIdInfo: 'Acesta este ID-ul Mărcii în panoul de administrare "Digitain Agent".',
    depositCurrencyInfo:
      'În cazul în care jucătorilor li se permite să facă depuneri cu toate monedele acceptate de metodele de plată, "Permite conversia" cu configurările valutei acceptate trebuie să fie activă pentru metoda de plată.',
    pageGroups: 'Grupuri de pagină',
    digitainRetailInfo: "Acesta este ID-ul metodei de plată în panoul de administrare 'Digitain Retail'.",
    smarticoDescription: 'Soluția de gamificare cu diverse provocări și tehnici de joc pentru a motiva jucătorii ',
    smarticoLabelKey: 'Cheie de Etichetă ',
    brandKey: 'Cheie de Marcă',
    smarticoBrandKeyInfo: 'O cheie publică pentru marcă/metoda de plată',
    smarticoLabelKeyInfo: 'O cheie publică pentru etichetă',
    smarticoNote: 'Smartico CRM și Gamificarea sunt interconectate, iar fiecare acțiune din această secțiune are efect și asupra gamificării',
    realityCheckPeriod: 'Perioada de verificare a realității',
    timeOut: 'Timp de expirare',
    inactivityIndicators: 'Indicatori de inactivitate',
    inactivityIndicatorsInfo:
      'Această configurație va considera că jucătorul este inactiv pe baza unui indicator dintr-o listă de indicatori, data ultimei conectări a jucătorului sau data ultimei tranzacții (pariu, depunere, retragere)',
    recoverByPlayer: 'Recuperare după jucător',
    recoverByPlayerInfo: 'La activare, jucătorii pot efectua singuri recuperarea prin codul de verificare',
    setMainDomain: 'Setare domeniu principal',
    disconnected: 'Deconectat',
    spotsBookPrematchTopMatchesDescription: 'La activare, widgetul „Meciuri de top” devine disponibil în Iframe-ul Sportsbook și pe pagina de destinație',
    prematchTopMatches: 'Meciuri de top înainte de meci',
    prematchTotalTopMatches: 'Meciuri de top înainte de meci (piață totală inclusă)',
    spotsBookPrematchTotalTopMatchesDescription: 'La activare, widgetul „Meciuri de top înainte de meci” cu „Date totale piață” devine disponibil',
    livePrematchTopMatches: 'Meciuri de top live și înainte de meci',
    spotsBookLivePrematchTopMatchesDescription: 'La activare, widgetul „Meciuri de top live și înainte de meci” devine disponibil',
    liveTopMatches: 'Meciuri de top live',
    spotsBookLiveTopMatchesDescription: 'La activare, widgetul „Meciuri de top live” devine disponibil',
    periodCalculationSource: 'Sursă calcul perioadă',
    periodCalculationSourceInfo: 'Selectează sursa datei de la care va începe calculul perioadei de verificare',
    verificationPeriod: 'Perioadă de verificare',
    verificationPeriodInfo: ' Numărul de zile în care contul jucătorului este activ înainte de verificare',
    unverifiedPlayersExclusionsInfo:
      'În situațiile în care o metodă de plată este selectată în meniul „Plăți cu ignorare verificare depunere”, iar limitele sunt setate în „Valori max. depunere”, limitele nu vor afecta metoda de plată.',
    responsibleGamingPeriodLimitsInfo: 'În această secțiune poți seta o perioadă exactă în care un jucător poate să opteze pentru o întrerupere sau pentru o autoexcludere.',
    preferencesDescription: 'Activare/dezactivare SMS, e-mail și notificări Push pentru jucători.',
    preferencesSMSDescription: 'Trimiterea de SMS-uri către toți jucătorii mărcii și pe website prin partea de SMS ar trebui să fie ascunsă',
    preferencesEmailDescription: 'Trimiterea de e-mailuri către toți jucătorii mărcii și pe website prin partea de e-mail ar trebui să fie ascunsă',
    walletsSettings: 'Setări portofele',
    wallets: 'Portofele',
    features: 'Funcții',
    dda: 'DDA',
    ddaInfo: 'Prin activarea acestei opțiuni, taxele de pe retragere vor fi reținute în logica DDA',
    whatsAppDescription: 'Permite clienților să te contacteze utilizând cel mai utilizată aplicație de mesagerie din lume.',
    phoneNumber: 'Număr de telefon',
    whatsAppPhoneNumberInfo: 'Introdu-ți numărul de telefon cu care ți-ai înregistrat contul de WhatsApp',
    multiGameLaunch: 'Lansare jocuri multiple',
    multiGameLaunchDescription: 'În funcție de configurații, opțiunea de jocuri multiple este disponibilă pe website și jucătorii pot juca mai multe jocuri în același timp.',
    jackpotWidget: 'Widgetul Jackpot',
    jackpotWidgetDescription: 'Se referă la activarea widgetului „Jackpot Cazinou” pentru pagina de destinație. Disponibil pentru widgetul „Jackpot” de la furnizorul Amusnet.',
    gameIframe: 'Iframe joc',
    manuBarFixation: 'Fixare bară de meniu',
    manuBarFixationDescription: 'Doar pentru vizualizarea de pe dispozitive mobile. În funcție de configurație, bara de meniu este fixă pentru lobby-uri.',
    paymentVisibilityInfo: 'În această secțiune, poți ascunde și interzice utilizarea metodei de plată pentru jucătorii care au una dintre următoarele etichete',
    centrivoConnectAgDescription: 'Transformă-ți afacerea de iGaming cu soluția de conectare a agenților oferită de Centrivo',
    retailCentrivoDescription: 'Transformă-ți afacerea de iGaming cu soluția de retail oferită de Centrivo',
    currencySymbol: 'Simbol unitate monetară',
    preferencesPushNotificationsDescription: 'Canalul cu notificările Push va deveni disponibil pentru trimiterea notificărilor pentru marca',
    currencyFormat: 'Format unitate monetară',
    currencyFormatInfo: 'Formatul de monedă care va fi afișat pe site-ul web pentru jucători.',
    isoCode: 'Cod ISO',
    symbols: 'Simboluri',
    digitainCrmDescription: 'Soluții CRM concepute pentru a menține angajamentul jucătorilor existenți și pentru a îmbunătăți nivelul de satisfacție al acestora',
    accessDecreaseLimit: 'Limită acces',
    depositOnNegativeBalance: 'Depunere în sold negativ',
    depositOnNegativeBalanceInfo: 'După aprobarea depunerii, ajustarea va fi efectuată în portofelul negativ al jucătorului pentru închiderea datoriei.',
    digitainAffiliateDescription: 'Activează-ți programul de afiliere și vezi ce înseamnă o creștere semnificativă a traficului pe website-ul tău.',
    projectId: 'ID proiect',
    projectIdInfo: 'Acesta este ID-ul proiectului din panoul de administrare „Afiliat Digitain”',
    brandIdInfo: 'Acesta este ID-ul mărcii din panoul de administrare „Afiliat Digitain”',
    maintenanceSetup: 'Configurare întreținere',
    maintenancePeriod: 'Perioadă întreținere',
    sportsBookViews: 'Vizualizări Pariuri sportive',
    mandatoryNotification: 'Notificare obligatorie',
    mandatoryNotificationInfo: 'O fereastră de tip pop-up obligatorie pentru jucătorii care s-au conectat pe website',
    lossDecreaseLimit: 'Limită de pierdere',
    singleBetDecreaseLimit: 'Limită pariu simplu',
    cashierType: 'Tip casier',
    lIcon: 'pictogramă',
    gameLaunchType: 'Tip lansator de joc (vizualizare pe dispozitive mobile)',
    gameFullScreenLaunchDescription: 'Jocul se deschide cu iframe în modul ecran complet',
    gameHeaderFooterLaunchDescription: 'Jocul se deschide cu iframe cu antet și subsol',
    gameQuickActionBarLaunchDescription: 'Jocul se deschide cu bara de acțiuni rapide',
    limitEffectConfigs: 'Limitează configurațiile de efecte speciale',
    ignoreFirstDeposit: 'Ignoră prima depunere',
    ignoreFirstDepositHint: 'Dacă se selectează această opțiune, prima depunere reușită a jucătorului nu va fi calculată în limita depunerii din jocul responsabil',
    periodLimit: 'Limita de perioadă',
    playerLimitsConfiguration: 'Configurare limite jucător',
    alanbaseDescription: 'O platformă realizată de specialiști în iGaming și în marketing afiliat care să ajute ceilalți specialiști să-și optimizeze costurile și să-și crească profiturile.',
    routForEvents: 'Rută pentru evenimente',
    routForGoals: 'Rută pentru obiective',
    fastDepositPaymentMethod: 'Metodă de plată depunere rapidă',
    fastDepositPaymentMethodInfo:
      '„Depunerea rapidă” este o funcție de pe website prin care jucătorii au posibilitatea să facă o depunere fără să părăsească pagina jocului, utilizând metoda de plată predefinită de la „Centrivo”.',
    sportStatusIconsInfo: 'Pictogramele încărcate vor fi vizibile în profilul jucătorului de pe website. Fiecare pictogramă încărcată va apărea pe website după cel mult o oră.',
    rolloverBetsReturn: 'Pariurile Rollover se întorc în același portofel',
    rolloverBetsReturnInfo: 'În cazul în care pariul făcut din soldul Rollover este returnat/anulat, suma va fi transferată în soldul Rollover',
    maxDepositAmounts: 'Valori max. depunere',
    paymentsIgnoringDepositVerification: 'Plăți cu ignorare verificare depunere',
    selfExclusion: 'Atuoexcludere',
    configureLimits: 'Configurare limite',
    metaMapDesc: 'Tot ce trebuie să știți pentru verificarea clienților pe o singură platformă',
    clientId: 'ID client',
    clientIdInfo: 'Utilizat pentru a vă identifica drept comerciant.',
    clientSecret: 'Secret client',
    clientSecretInfo: 'Utilizați secret_client din Tabloul de bord ca parolă.',
    pushGameState: 'Stare jocuri Push',
    pushGameStateDescription: 'Această setare definește starea jocurilor („Stare jocuri”) trimise de agregator la Back Office.',
    thunderBiteDescription: 'Gamificați experiența clientului și transformați angajamentul în loialitate.',
    campaignURL: 'URL campanie',
    captchaCaseInsensitiveInfo: 'Prin activarea acestei opțiuni pentru Captcha, sistemul nu distinge între literele mari și cele mici, pe care le consideră identice.',
    caseInsensitive: 'Nu distinge între litere mari și mici',
    verificationRequestPeriod: 'Perioadă de solicitare a verificării prin SMS/e-mail',
    verificationRequestPeriodInfo: 'Configurația definește când va fi trimisă jucătorului solicitarea de verificare prin SMS/e-mail',
    sec: 'sec',
    integratedDate: 'Dată integrată',
    integratedBy: 'Integrată de',
    isInvisible: 'Nu este vizibilă',
    captchaInvisibleInfo: 'Dacă opțiunea este bifată, verificarea captcha nu va fi vizibilă pentru jucători',
    captchaLogonAttemptsInfo: 'Definiți numărul de încercări eșuate de conectare, perioada de contorizare a acestor încercări și durata de timp în care va apărea CAPTCHA.',
    jackpot: 'Jackpot',
    globalState: 'Stare globală',
    jackpotGames: 'Jocuri cu jackpot',
    myAffiliatesDescription: 'Cel mai flexibil software de urmărire a afiliaților pe piață',
    sportDomainsTabInfo: 'Numărul maxim de domenii sportive {{număr}}. Numai domeniile active pot fi setate ca Principal. Numai domeniile verificate pot fi conectate.',
    firebaseAuthenticationDescription: 'Configurați platformele de socializare pentru autentificarea pe bază de înregistrare și conectare a utilizatorilor cu Firebase.',
    frontend: 'Frontend',
    backend: 'Backend',
    google: 'Google',
    facebook: 'Facebook',
    socialMediaPlatforms: 'Platforme de socializare',
    optimoveDescription: 'Soluții CRM concepute pentru a menține angajamentul jucătorilor existenți și pentru a îmbunătăți nivelul de satisfacție al acestora.',
    baseUrl: 'URL de bază',
    forcePasswordChangeNote:
      'Prin activarea acestei opțiuni, jucătorii trebuie să-și modifice parolele dacă perioada stabilită a expirat.\nDacă perioada pentru Reamintirea parolei a expirat, jucătorii nu se pot conecta la site-ul web fără să-și modifice parola, dacă opțiunea este activată.',
    forcePasswordChange: 'Forțare schimbare parolă',
    playerTags: 'Etichetele jucătorului',
    additional: 'Suplimentar',
    gameTimeLimit: 'Limită de timp pentru joc',
    verificationOptions: 'Opțiuni de verificare',
    blockActions: 'Blocare acțiuni',
    userNotification: 'Notificare utilizator',
    winAmounts: 'Sume câștig',
    largeWinTransactionNotification:
      'Notificarea tranzacției Câștig mare va fi trimisă numai utilizatorilor selectați. Asigurați-vă că Suma câștigului este configurată pentru toate valutele în cazul în care toți utilizatorii sunt selectați.',
    promptOnLogin: 'Solicitare la conectare',
    promptOnLoginInfo: 'Prin selectarea acestei opțiuni, jucătorilor li se va solicita să-și seteze limitele la prima lor conectare',
    productCategory: 'Categoria de produse',
    betProfitRange: 'Intervalul profitului din pariuri (De la - Până la)',
    betProfitRangeHint: 'Suma din câmpul „De la” din „Intervalul profitului din pariuri” este inclusă în intervalul respectiv, în timp ce suma din câmpul „Până la” nu este inclusă în interval.',
    betTaxInfo: 'Se poate aloca o singură „Categorie de produse” tipului de impozitare „Cumulativ” sau „Per tranzacție”, în funcție de metoda preferată de calculare a impozitului.',
    betTaxStandardDisabledInfo: 'Activați „Impozitare” și „Impozitare profit din pariuri” pentru a activa calculatorul de impozite pentru marca dvs.',
    depositTaxStandardDisabledInfo: 'Activați „Impozitare” și „Impozitare la depunere” pentru a activa calculatorul de impozite pentru marca dvs.',
    withdrawalTaxStandardDisabledInfo: 'Activați „Impozitare” și „Impozitare la retragere” pentru a activa calculatorul de impozite pentru marca dvs.',
    registrationUniqueness: 'Unicitate înregistrare',
    registrationUniquenessNote: 'Unicitatea combinației selectate trebuie validată în timpul înregistrării jucătorului.',
    responsibleGamingLimitsInfo:
      'În această secțiune puteți seta valori predefinite care se vor completa automat ca limite implicite în timpul configurării, dar pot fi ajustate manual. Opțiunea „Solicitare la conectare” poate fi activată/dezactivată, ceea ce va necesita ca jucătorii să seteze limita.',
    hours: '{{număr}} ore',
    days: '{{număr}} zile',
    month: '{{număr}} lună',
    year: '{{număr}} an',
    viewDefaultAmount: 'Vizualizare sumă implicită',
    viewDefaultLimit: 'Vizualizare limită implicită',
    realTimeUniquenessCheck: 'Verificarea unicității în timp real',
    realTimeUniquenessCheckNote:
      'Prin activarea acestei opțiuni, sistemul va verifica instantaneu numărul de telefon mobil, ID-ul și adresa de e-mail pentru unicitate în timpul procesului de înregistrare.',
    appToken: 'Token aplicație',
    accountVerificationOptions: 'Opțiuni de verificare a contului',
    accountVerificationOptionsInfo: 'Selectați opțiunile pe baza cărora contul jucătorului va fi considerat verificat',
    markAsUnverified: 'Marcare ca neverificat',
    markAsUnverifiedInfo: 'Când această opțiune este activată, jucătorii vor fi marcați ca neverificați pe baza regulilor setate',
    notificationReminder: 'Memento notificare',
    notificationReminderInfo: 'Numărul de zile după care jucătorului i se va reaminti să verifice contul',
    blockForUnVerify: 'Blocare pe motiv de neverificare',
    blockForUnVerifyOptions: 'Opțiuni de blocare pe motiv de neverificare',
    betOddsLimit: 'Limită cote pariu',
    betOddsLimitInfo:
      'În cazurile în care pariul este plasat cu o cotă mai mică decât cea specificată, suma câștigată va fi distribuită proporțional între portofelele (utilizate și neutilizate) în care a fost plasat pariul',
    selfExclusionReason: 'Motivul autoexcluderii',
    selfExclusionReasonInfo: 'Dacă motivul este selectat, jucătorii nu pot seta o autoexcludere pentru cont selectând motivele specificate',
    balanceVisibility: 'Vizibilitate sold',
    balanceVisibilityNote: 'Soldurile selectate vor fi vizibile pentru jucătorii mărcii.',
    configured: 'Configurat',
    limitEffectPeriodInfo:
      'Modificările intră în vigoare fie după o anumită perioadă de timp (imediat, 24 de ore, 48 de ore sau 7 zile), fie la începutul următoarei perioade calendaristice - miezul nopții pentru limitele zilnice, luni pentru limitele săptămânale sau prima zi a lunii pentru limitele lunare.',
    documentsConfig: 'Configurație documente',
    documentsConfigInfo: 'Numărul de pagini necesare pentru următoarele tipuri de documente este întotdeauna 1',
    pageCount: 'Număr de pagini',
    realityCheckSettings: 'Setări de verificare a realității',
    calculationType: 'Tip de calcul',
    realityCheckInterval: 'Interval de verificare a realității',
    showLogOutButton: 'Afișare buton de deconectare',
    realityCheckSettingsInfo: 'Configurațiile se vor aplica numai dacă este activată opțiunea Verificarea realității în secțiunea Standarde',
    realityCheckStatus: 'Stare de verificare a realității',
    realityCheckPeriodInfo: 'Aceste perioade vor apărea în contul jucătorului de pe site-ul web',
    realityCheckIntervalInfo: 'Definește intervalul de timp dintre afișarea ferestrei Verificare realitate jucătorilor',
    capitalizePlayerData: 'Scriere cu majuscule a datelor jucătorului',
    capitalizePlayerDataInfo: 'Prin activarea acestei opțiuni, sistemul va scrie cu majuscule câmpurile Prenume/Nume, Adresă și Oraș în timpul procesului de înregistrare și le va salva în backoffice',
    blockedCountriesInfo:
      'Acțiunea (deblocare, blocare completă, blocare pentru autentificare, blocare pentru înregistrare, blocare pentru autentificare și înregistrare) poate fi aplicată individual pentru fiecare țară sau în masă, actualizând starea acestora simultan.',
    bulkAction: 'Acțiune în masă',
    multiPeriodLimitType: 'Tip limită perioadă multiplă',
    singlePeriodLimitType: 'Tip limită perioadă unică',
    changeEffectPeriods: 'Perioade de efectuare modificări',
    lastMonthPeriod: 'Perioadă din luna trecută',
    eddVerificationNotification: 'Configurațiile EDD vor declanșa verificarea Sursei de fonduri pentru Jucătorii calificați',
    totalDepositAmount: 'Sumă totală depuneri',
    brandBonusesInfo:
      'Această secțiune le permite utilizatorilor să configureze logica de activare a bonusurilor pentru brand pe baza unor condiții specifice. Dacă oricare dintre condiții nu este îndeplinită, bonusul nu va fi activat.',
    firstSuccessfulDeposit: 'Primul depozit reușit',
    firstSuccessfulDepositDesc: 'Jucătorii trebuie să aibă cel puțin un depozit reușit pentru a fi eligibili să activeze bonusurile.',
    sportStatusDesc: 'Jucătorii cu statutul selectat nu sunt eligibili să activeze bonusurile primite.',
    standardTaxModelInfo: 'Calculează taxa pentru depozitul efectuat, aplicând procentul de taxă menționat asupra sumei totale.',
    vatTaxModelInfo: 'Calculează taxa pentru depozitul efectuat, aplicând procentul de TVA menționat conform formulei de TVA. Suma totală a depozitului include TVA.',
    setVatAmountRangesInfo: 'Sistemul separă automat partea de TVA din total pentru a calcula valoarea reală a depozitului.',
    emailsInfo: {
      text1: 'Pentru unii furnizori SMTP este necesar ca aceeași adresă de e-mail să fie înregistrată la ei.',
      text2: 'Vă rugăm să vă asigurați că cerința este îndeplinită.',
    },
    multiBetOfTheDay: 'Pariul multiplu al zilei',
    sportSuperPromotion: 'Super promoții',
    schemaMarkupImage: 'Imagine cu marcaj schemă',
    dataSendPeriod: 'Perioadă de trimitere a datelor',
    demoLaunchDesktop: 'Lansare demo (desktop)',
    demoLaunchMobile: 'Lansare demo (dispozitive mobile)',
    demoLaunchDesktopDescription:
      'În funcție de configurație, butonul „Demo” este disponibil în cadrul jocurilor, iar jucătorii pot lansa versiunea demo a jocului în modul de vizualizare pentru desktop.',
    demoLaunchMobileDescription:
      'În funcție de configurație, butonul „Demo” este disponibil în cadrul jocurilor, iar jucătorii pot lansa versiunea demo a jocului în modul de vizualizare pentru dispozitive mobile.',
    androidSettings: 'Setări Android',
    iosSettings: 'Setări iOS',
    googleCloudProjectId: 'ID-ul proiectului Google Cloud',
    mobileReCaptcha: 'reCAPTCHA pentru dispozitive mobile',
    androidReCaptchaKey: 'Cheia reCAPTCHA pentru Android',
    androidKeyId: 'ID cheie Android',
    iosReCaptchaKey: 'Cheie reCAPTCHA pentru iOS',
    iosKeyId: 'ID cheie iOS',
    playerApproval: 'Aprobarea jucătorului',
    playerApprovalInfo: 'Este necesară confirmarea jucătorului înainte de aplicarea noii limite, mai scăzute, după perioada de valabilitate a modificării',
    transactionTypeNote: 'Tipurile selectate vor fi vizibile pentru jucătorii mărcii în secțiunea „Casier” de pe site-ul web.',
    domainDeletion: 'Ștergerea domeniului',
    incomeAccessDescription: 'Deveniți parte din cea mai veche rețea de marketing afiliat din domeniul iGaming',
    suggestedAmounts: 'Sume recomandate',
    defaultAmount: 'Sumă implicită',
    viewLimits: 'Vizualizare limite',
    configureAmounts: 'Configurare sume',
    suggested: 'Sugerat',
    otherTypeDocumentConfigInfo:
      'Pentru toate tipurile, cu excepția <0>Altele</0>, este obligatoriu să se selecteze un număr de fișiere. Pentru <0>Altele</0>, numărul selectat reprezintă limita maximă permisă; se acceptă un număr mai mic de fișiere.',
    uploadReCaptchaInfo: 'Puteți încărca un fișier JSON valid pentru configurarea ReCaptcha',
    androidPrivateKey: 'Cheie privată Android',
    iosPrivateKey: 'Cheie privată iOS',
    indefiniteTimePeriod: 'Perioadă nedeterminată',
    sportMinBetAge: 'Min. sport Vârstă minimă pentru pariuri',
    casinoMinBetAge: 'Min. cazinou Vârstă minimă pentru pariuri',
    zingBrainDesc: 'ZingBrain este o platformă de optimizare a performanței ușor de integrat, destinată industriei iGaming.',
    awsCloudDescription: 'Configurați AWS pentru a permite încărcarea datelor.',
    zingBrandDescription: 'Integrați ZingBrain pentru a activa configurarea recomandărilor de conținut pentru lobby bazate pe inteligența artificială.',
    regionName: 'Nume regiune',
    endpointUrl: 'Adresa URL a punctului final',
    accessKeyId: 'ID cheie de acces',
    secretAccessKey: 'Cheie de acces secretă',
    bucketName: 'Nume coș',
    apiUserName: 'Nume de utilizator API',
    apiPassword: 'Parolă API',
    zingBrandId: 'ID ZingBrand',
    configuredDate: 'Data configurării',
    configuredBy: 'Configurat de',
    standardTaxModel: 'Model fiscal standard',
    loyaltyProgram: 'Program de fidelitate',
    activationMinimumAmount: 'Suma minimă de activare',
    activationMinimumAmountDesc: 'Jucătorii trebuie să aibă în portofel cel puțin suma menționată pentru a putea activa bonusul',
    authentigateDescription:
      'Authentigate este soluția completă pentru cele mai populare metode de autentificare cu eID din țările baltice. Conectați Smart-ID, Mobile-ID, eParaksts mobile și cartea de identitate estoniană printr-o singură poartă de acces securizată.',
    betStatusCorrectionsNotification: 'Stabilirea limitelor și a cerințelor de confirmare pentru operatori, permițându-le să aprobe sau să anuleze acțiunile care depășesc limitele',
    trustlyDescription:
      'Funcția de încredere Pay and Play le oferă jucătorilor un proces de înregistrare rapid și fără probleme, care combină depunerile, verificarea utilizatorului și crearea contului.',
    trustlyNote: 'Funcția Pay and Play trebuie configurată mai întâi în pagina Paydrom înainte de a activa această opțiune.',
    relumActivation:
      'Prin activarea produsului Relum veți avea acces la numeroase jocuri de la diverși furnizori de jocuri premium, ceea ce vă permite să creați o experiență de joc personalizată pentru jucătorii dvs.',
    sportsBookActivation:
      'Prin activarea produsului Sportsbook, veți avea acces la o interfață completă, multilingvă, compatibilă cu mai multe monede și personalizabilă, care include evenimente în timp reale și anterioare meciurilor pentru diverse sporturi, cu ligi din întreaga lume și un număr imens de piețe de pariuri.',
    domain: 'Domeniu',
    whiteIps: 'Adrese IP albe',
    betStatusCorrections: 'Corectarea stării pariului',
    autoDeposit: 'Depunere automată',
  },
  bg: {},
  el: {
    mainCurrency: 'Κύριο νόμισμα',
    mainLanguage: 'Κύρια γλώσσα',
    market: 'Αγορά',
    setMainCountry: 'Ορισμός κύριας χώρας',
    setMainCurrency: 'Ορισμός κύριου νομίσματος',
    setMainLanguage: 'Ορισμός κύριας γλώσσας',
    redirectedTo: 'Ανακατεύθυνση σε',
    onlyVerifiedDomainInfo: 'Μόνο επαληθευμένοι τομείς μπορούν να συνδεθούν',
    disconnectDomain: 'Αποσύνδεση τομέα',
    connectDomain: 'Σύνδεση τομέα',
    deleteDomain: 'Διαγραφή τομέα',
    deleteScript: 'Διαγραφή σεναρίου',
    deactivateScript: 'Απενεργοποίηση σεναρίου',
    activateScript: 'Ενεργοποίηση σεναρίου',
    supportedCurrencies: 'Υποστηριζόμενα νομίσματα',
    supportedCountries: 'Υποστηριζόμενες χώρες',
    supportedLanguages: 'Υποστηριζόμενες γλώσσες',
    providerDisableInfo: 'Ενδέχεται να έχει απενεργοποιηθεί ο πάροχος για ολόκληρο το σύστημα',
    activity: 'Δραστηριότητα',
    verificationAnd: 'Επαλήθευση (και)',
    verificationOr: 'Επαλήθευση (ή)',
    andDelimiter: 'και',
    currencyFrom: 'Νόμισμα από',
    currencyTo: 'Νόμισμα προς',
    reverseRate: 'Ισοτιμία αντίστροφης μετατροπής',
    feature: 'Λειτουργία',
    otherTransactions: 'Άλλες συναλλαγές',
    playersNotifiedDate: 'Ημερομηνία ειδοποίησης',
    depositProcessingType: 'Τύπος επεξεργασίας κατάθεσης',
    withdrawalProcessingType: 'Τύπος επεξεργασίας ανάληψης',
    allowedActivities: 'Επιτρεπόμενες δραστηριότητες',
    depositSupportedCurrencies: 'Υποστηριζόμενα νομίσματα κατάθεσης',
    withdrawalSupportedCurrencies: 'Υποστηριζόμενα νομίσματα ανάληψης',
    newFee: 'Νέα χρέωση, %',
    feeBefore: 'Χρέωση πριν, %',
    newLimit: 'Νέο όριο',
    statusDisabledInfo: 'Ο ιστότοπος θα καταστεί μη διαθέσιμος από όλους τους τομείς.',
    statusActivitiesDisabledInfo: 'Δεν θα γίνονται αποδεκτά νέα στοιχήματα.',
    statusVersionNamesDisabledInfo: 'Τα στοιχήματα θα είναι απενεργοποιημένα για τις επιλεγμένες εκδόσεις.',
    timezoneInfo: 'Τυχόν υπολογισμοί σε εξέλιξη που σχετίζονται με τη ζώνη ώρας θα αλλάξουν.',
    domainRedirection: 'Ανακατεύθυνση τομέα',
    uVerify: 'ΕΠΑΛΗΘΕΥΣΗ',
    redirect: 'Ανακατεύθυνση',
    forwardingURL: 'URL ανακατεύθυνσης',
    destinationURL: 'URL προορισμού',
    domainRedirectInfo: 'Ο τομέας που χρησιμοποιείται είτε ως URL ανακατεύθυνσης είτε ως URL προορισμού δεν μπορεί να διαγραφεί χωρίς να γίνει διαγραφή του υφιστάμενου κανόνα.',
    registerDomainInfo: 'Πρέπει να εγγράψετε όλους τους τομείς σας στον λογαριασμό σας Google για να ενεργοποιηθεί το captcha για όλους τους τομείς.',
    ageRestriction: 'Περιορισμός ηλικίας',
    passwordPattern: 'Μοτίβο κωδικού πρόσβασης',
    failedAttemptsPeriod: 'Περίοδος αποτυχημένων προσπαθειών',
    lockPeriod: 'Περίοδος κλειδώματος',
    passwordReminder: 'Υπενθύμιση κωδικού πρόσβασης',
    inactivityPeriod: 'Περίοδος αδράνειας',
    securityPeriod: 'Περίοδος ελέγχου ασφαλείας',
    referralActivationPeriod: 'Περίοδος ενεργοποίησης παραπομπής',
    passwordPatternNote:
      'Συνιστάται οι κωδικοί πρόσβασης να έχουν τουλάχιστον 8 χαρακτήρες, συμπεριλαμβάνοντας τουλάχιστον 1 αριθμό και 1 κεφαλαίο γράμμα. Ωστόσο, μπορείτε να έχετε πιο αδύναμο κωδικό πρόσβασης, χρησιμοποιώντας 6-20 λατινικούς χαρακτήρες, αριθμούς ή ειδικούς χαρακτήρες.',
    referralActivationPeriodNote: 'Περίοδος για την οποία θέλετε να κρατήσετε τα στοιχεία της ταυτότητας του ατόμου που έκανε την παραπομπή για νέα εγγραφή στον ιστότοπο.',
    correspondingTranslations: 'Βεβαιωθείτε ότι όλες οι μεταφράσεις είναι ενημερωμένες αντίστοιχα.',
    verificationCodeLength: 'Μήκος κωδικού επαλήθευσης',
    dailyMobileVerification: 'Ημερήσια αιτήματα επαλήθευσης κινητού τηλεφώνου',
    emailRequestsInDaily: 'Ημερήσια αιτήματα επαλήθευσης email',
    expirationMinutes: 'Περίοδος λήξης token',
    expirationMinutesNote: 'Η διαμόρφωση καθορίζει την περίοδο μετά την οποία το token (κωδικός, σύνδεσμος) της ειδοποίησης δεν θα ισχύει πλέον.',
    emailRequestsInDailyNote: 'Η διαμόρφωση καθορίζει πόσα αιτήματα επαλήθευσης email μπορεί να λάβει ένας παίκτης σε μία ημέρα. Η ελάχιστη τιμή είναι {{value}}.',
    dailyMobileVerificationNote: 'Η διαμόρφωση καθορίζει πόσα αιτήματα επαλήθευσης μέσω SMS μπορεί να λάβει ένας παίκτης σε μία ημέρα. Η ελάχιστη τιμή είναι {{value}}.',
    identityDocument: 'Έγγραφο ταυτότητας',
    addressDocument: 'Έγγραφο διεύθυνσης',
    additionalDocument: 'Επιπρόσθετο έγγραφο',
    disableSportBook: 'Απενεργοποίηση {{name}}',
    gameDisableTooltip: 'Ενδέχεται να έχει απενεργοποιηθεί το παιχνίδι για ολόκληρο το σύστημα',
    playerLimitInfo: {
      text1: 'Μπορείτε να ορίσετε όριο για την περίοδο μείωσης της βαρύτητας για κάθε τύπο ορίου.',
      text2: 'Αλλαγές στα όρια που έχουν επιβληθεί από παίκτες, οι οποίες κάνουν πιο αδύναμα τα όρια, θα εφαρμόζονται σύμφωνα με αυτή τη διαμόρφωση.',
    },
    depositDecreaseLimit: 'Όριο κατάθεσης',
    betDecreaseLimit: 'Όριο στοιχήματος',
    withdrawalDecreaseLimit: 'Όριο ανάληψης',
    activateSportsbook: 'Ενεργοποίηση Sportsbook',
    customScriptInfo: 'Μπορείτε να ενσωματώνετε νέες εφαρμογές ή να προσθέτετε διαφορετικές λειτουργίες στον ιστότοπό σας με την προσθήκη προσαρμοσμένων σεναρίων.',
    scriptName: 'Όνομα σεναρίου',
    insideHead: 'Ετικέτα </head> εσωτερικού κλεισίματος',
    insideBody: 'Ετικέτα </body> εσωτερικού κλεισίματος',
    headTag: 'σενάριο ετικέτας επικεφαλίδας',
    bodyTag: 'σενάριο ετικέτας σώματος κειμένου',
    service: 'υπηρεσία',
    integrate: 'Ενσωμάτωση',
    showOnLive: 'Εμφάνιση στον Live ιστότοπο',
    showOnLiveTitle: 'Όταν απενεργοποιείτε αυτόν τον διακόπτη, το εικονίδιο υπηρεσιών τρίτων δεν θα εμφανίζεται στην αρχική σελίδα του ιστότοπού σας.',
    apiSecret: 'Μυστικό API',
    apiSecretOrPass: 'Μυστικό API ή κωδικός πρόσβασης',
    apiKeyOrUsername: 'Κλειδί API ή όνομα χρήστη',
    sendEmailVia: 'Αποστολή email μέσω',
    smtpUser: 'Χρήστης SMTP',
    smtpPass: 'Κωδικός πρόσβασης SMTP',
    useSSL: 'Χρήση SSL',
    smtpHost: 'Εξυπηρετητής SMTP',
    smtpPort: 'Πύλη SMTP',
    emailsInfo: {
      text1: 'Για ορισμένους παρόχους SMTP απαιτείται να έχει γίνει εγγραφή του ίδιου email από την πλευρά τους.',
      text2: 'Βεβαιωθείτε ότι καλύπτεται αυτή η απαίτηση.',
    },
    emailsInfo1: 'Όλα τα προγραμματισμένα μηνύματα με αυτό το email θα μεταφερθούν στο πρόχειρο',
    blockCountries: 'Αποκλεισμός χωρών',
    blockCountriesMainText: 'Ο ιστότοπος θα γίνει μη διαθέσιμος από επιλεγμένες χώρες',
    versionControl: 'Έλεγχος έκδοσης',
    policies: 'Πολιτικές',
    policy: 'Πολιτική',
    dateToNotify: 'Ημερομηνία ειδοποίησης',
    featureName: 'Όνομα λειτουργίας',
    createBrand: 'Δημιουργία επωνυμίας',
    builder: 'Κατασκευαστής',
    platformState: 'Κατάσταση πλατφόρμας',
    minMaxWithdrawalAmount: 'Ελάχιστο-μέγιστο ποσό ανάληψης συστήματος',
    minWithdrawalAmount: 'Ελάχ. Ποσό ανάληψης',
    maxWithdrawalAmount: 'Μέγ. Ποσό ανάληψης',
    minMaxDepositAmount: 'Ελάχιστο-μέγιστο ποσό κατάθεσης συστήματος',
    minDepositAmount: 'Ελάχ. Ποσό κατάθεσης',
    maxDepositAmount: 'Μέγ. Ποσό κατάθεσης',
    operationFeePercent: 'Χρέωση λειτουργίας, %',
    withdrawalFeePercent: 'Χρέωση ανάληψης, %',
    withdrawalFee: 'Χρέωση ανάληψης',
    withdrawalFeeForUsedBalancePercent: 'Χρέωση ανάληψης για χρησιμοποιημένο υπόλοιπο, %',
    withdrawalFeeForUsedBalance: 'Χρέωση ανάληψης για χρησιμοποιημένο υπόλοιπο',
    allowedConversion: 'Επιτρεπόμενη μετατροπή',
    paymentMethodName: 'Όνομα μεθόδου πληρωμής',
    minAmount: 'Ελαχ. ποσό {{title}}',
    maxAmount: 'Μεγ. ποσό {{title}}',
    minMaxSystemAmount: 'Ελάχιστο-μέγιστο ποσό {{title}} συστήματος',
    depositFeePercent: 'Χρέωση κατάθεσης, %',
    depositFee: 'Χρέωση κατάθεσης',
    allowConversion: 'Να επιτρέπεται η μετατροπή',
    previewLive: 'Προεπισκόπηση Live',
    feeFromDeposit: 'Χρέωση από την κατάθεση',
    allowWithdrawalFromUnusedBalance: 'Να επιτρέπεται η ανάληψη από αχρησιμοποίητο υπόλοιπο',
    allowWithdrawalFeeUsedBalance: 'Το ποσό χρέωσης για την ανάληψη θα κρατηθεί από το εναπομένον υπόλοιπο.',
    feeCalculationForWithdrawals: 'Υπολογισμός χρέωσης για αναλήψεις',
    feeFromWithdrawals: 'Χρέωση από αναλήψεις',
    feeFromWithdrawalsUsedBalance: 'Χρέωση από αναλήψεις (χρησιμοποιημένο υπόλοιπο)',
    feeFromWithdrawalsBalance: 'Χρέωση από αναλήψεις ({{type}} υπόλοιπο)',
    unusedBalanceInfo: 'Όταν είναι ενεργοποιημένη, η επιλογή αχρησιμοποίητου υπολοίπου θα εμφανίζεται στη ρύθμιση Χρέωση από αναλήψεις',
    paymentTransactionType: 'Τύπος συναλλαγής πληρωμής',
    paymentMethodType: 'Τύπος μεθόδου πληρωμής',
    playerPaymentRelation: 'Σχέση παίκτη-πληρωμής',
    failedPaymentAttempts: 'Αποτυχημένες προσπάθειες πληρωμής',
    failedPaymentAttemptsPeriod: 'Περίοδος αποτυχημένων προσπαθειών πληρωμής',
    temporaryBlockPeriod: 'Περίοδος προσωρινού αποκλεισμού',
    reverseConversion: 'Αντίστροφη μετατροπή {{title}}',
    lCustomScript: 'προσαρμοσμένο σενάριο',
    largeTransactions: 'Μεγάλες συναλλαγές',
    lBrand: 'επωνυμία',
    playerSettings: 'Ρυθμίσεις παίκτη',
    verificationConfigurations: 'Διαμορφώσεις επαλήθευσης',
    theCurrency: 'Το νόμισμα',
    mainCountry: 'Κύρια χώρα',
    theLanguage: 'Η γλώσσα',
    smsSettings: 'Ρυθμίσεις SMS',
    verificationSettings: 'Ρυθμίσεις επαλήθευσης',
    smtpSettings: 'Ρυθμίσεις SMTP',
    captchaSettings: 'Ρυθμίσεις Captcha',
    theEmail: 'Το email',
    conversions: 'Μετατροπές',
    theConversion: 'Η μετατροπή',
    theCountry: 'Η χώρα',
    playerVerificationSettings: 'Ρυθμίσεις επαλήθευσης παίκτη',
    domainRedirectionRule: 'Κανόνας ανακατεύθυνσης τομέα',
    wageringActivities: 'Δραστηριότητες στοιχηματισμού',
    theSportsBook: 'Το Sportsbook',
    sportsBook: 'Sportsbook',
    theSportsBookView: 'Η προβολή Sportsbook',
    setMainView: 'Ορισμός κύριας προβολής',
    feeForWithdrawalsWillBeHeld: 'Το ποσό χρέωσης για την ανάληψη θα κρατηθεί από το εναπομένον υπόλοιπο.',
    brandName: 'Όνομα επωνυμίας',
    defaultCountry: 'Προεπιλεγμένη χώρα',
    defaultLanguage: 'Προεπιλεγμένη γλώσσα',
    defaultCurrency: 'Προεπιλεγμένο νόμισμα',
    products: 'Προϊόντα',
    websiteTemplate: 'Πρότυπο ιστότοπου',
    failedPaymentInfo: 'Οι διαμορφώσεις δεν είναι διαθέσιμες λόγω αδράνειας του προτύπου «Διαδικασία αποτυχημένων πληρωμών». Ενεργοποιήστε το από την ενότητα «Πρότυπα».',
    depositWithdrawalPaymentMethodInfo:
      'Οι μέθοδοι πληρωμής που χρησιμοποιούν μετατροπή θα επηρεαστούν σε περίπτωση αλλαγών,'
      + ' και μπορεί να γίνει επαναρύθμιση των προσαρμοσμένων ορίων ελάχιστου/μέγιστου από το σύστημα, αν δεν είναι συνεπή με τις νέες αλλαγές. Βεβαιωθείτε ότι έχετε ελέγξει τα όρια και τη διαθεσιμότητα των νομισμάτων στις ρυθμίσεις των μεθόδων πληρωμής.',
    otherPaymentMethodInfo:
      'Οι εσωτερικές λειτουργίες που χρησιμοποιούν μετατροπή θα χρησιμοποιήσουν αυτές τις συναλλαγματικές ισοτιμίες. Βεβαιωθείτε ότι έχετε εφαρμόσει όλες τις μετατροπές (π.χ. Μπόνους παραπομπής).',
    conversionSettingsInfo: 'Το τρέχον όριο δεν είναι συνεπές με το σύστημα/όριο μετατροπής συστήματος.',
    card: 'Κάρτα',
    imageAlt: 'Εναλλακτικό κείμενο εικόνας',
    recommendedSize: 'Προτεινόμενο μέγεθος',
    stateOrRegion: 'Πολιτεία/Περιφέρεια',
    socialLinks: 'Σύνδεσμοι μέσων κοινωνικής δικτύωσης',
    socialLinkInfo: 'Σελίδες προφίλ της εταιρείας σε διάφορους πόρους όπως Facebook, Twitter, Google+, Instagram, YouTube, LinkedIn, Wikipedia, κ.λπ. Μπορείτε να προσθέσετε όσα URL θέλετε.',
    image: 'Εικόνα',
    depositPaymentCategory: 'Κατηγορία πληρωμής κατάθεσης',
    withdrawalPaymentCategory: 'Κατηγορία πληρωμής ανάληψης',
    createNewBrand: 'Δημιουργία νέας επωνυμίας',
    lConversion: 'μετατροπή',
    schemaMarkupSettings: 'Ρυθμίσεις σήμανσης δομημένων δεδομένων',
    accountId: 'Αναγνωριστικό λογαριασμού',
    accountIdInfo: 'Οποιοδήποτε όνομα ή κωδικός αναγνώρισης που σχετίζεται με το αναγνωριστικό Λογαριασμού υπηρεσίας που παρέχει συγκεκριμένο επίπεδο πρόσβασης',
    ranges: 'Εύρη',
    depositAmountRanges: 'Εύρος ποσού κατάθεσης (Από - Έως)',
    taxPercentage: 'Ποσοστό φόρου %',
    lTaxes: 'φόροι',
    withdrawalAmountRanges: 'Εύρος ποσού ανάληψης (Από - Έως)',
    fixedAmountOrPercent: 'Σταθερό ποσό ή ποσοστό φόρου',
    allowWithdrawalViaTheDepositedMethods: 'Να επιτρέπεται ανάληψη μόνο μέσω των μεθόδων κατάθεσης',
    allowWithdrawalViaTheDepositedMethodsInfo: 'Αν ενεργοποιηθεί η ρύθμιση, ο παίκτης δεν θα μπορεί να κάνει ανάληψη χρημάτων μέσω μεθόδων επωνυμίας από τις οποίες δεν έχει κάνει ποτέ κατάθεση',
    spotsBookJackpotDescription: 'Όταν είναι ενεργοποιημένο το γραφικό στοιχείο Τζάκποτ αθλητικού στοιχήματος γίνεται διαθέσιμο στη Σελίδα προορισμού',
    spotsBookPrematchTopMatchesDescription: 'Όταν είναι ενεργοποιημένο το γραφικό στοιχείο Κορυφαίων αγώνων γίνεται διαθέσιμο στο Iframe του Sportsbook και στη Σελίδα προορισμού',
    spotsBookScrollingTypeDescription:
      'Η ρύθμιση ισχύει μόνο για τη Βασική προβολή και όταν είναι ενεργοποιημένη ο παίκτης μπορεί να δει ολόκληρη τη σελίδα Αθλητικού στοιχήματος με μία κύλιση του δρομέα',
    spotsBookTournamentBalanceDescription: 'Όταν είναι ενεργοποιημένο το υπόλοιπο τουρνουά γίνεται διαθέσιμο στην Αρχική σελίδα του Ιστότοπου',
    sportJackpot: 'Τζάκποτ αθλητικού στοιχήματος',
    sectionsScrolling: 'Κύλιση δρομέα στις ενότητες',
    sportTournamentBalance: 'Υπόλοιπο Αθλητικών τουρνουά',
    iframe: 'Iframe',
    native: 'Εγγενής',
    sportsBookIframeIntegrationDescription: 'Το Sportsbook θα είναι διαθέσιμο σε μορφή inline frame',
    sportsBookNativeIntegrationDescription: 'Το Sportsbook θα είναι διαθέσιμο άμεσα σε εσωτερική εφαρμογή',
    sportsBookMobileIntegrationType: 'Τύπος ενσωμάτωσης στο κινητό',
    setAsDefault: 'Ρύθμιση ως προεπιλογή',
    configs: 'Διαμορφώσεις',
    availableLayouts: 'Διαθέσιμες διατάξεις',
    setAmountRangesInfo:
      'Αν σε ένα εύρος έχουν οριστεί τόσο το «Σταθερό ποσό» όσο και το «Ποσοστό φόρου», το σύστημα θα πρέπει να υπολογίσει τον φόρο ως εξής: να παρακρατάει ένα σταθερό ποσό φόρου + ποσοστό x του ποσού που υπερβαίνει το ποσό που έχει καθοριστεί στο πεδίο «Από» του εύρους.',
    depositAmountRangesHint: 'Το ποσό στο πεδίο «Από» στο «Εύρος ποσού κατάθεσης» περιλαμβάνεται σε αυτό το εύρος, ενώ το ποσό στο πεδίο «Έως» δεν περιλαμβάνεται στο εύρος.',
    withdrawalAmountRangesHint: 'Το ποσό στο πεδίο «Από» στο «Εύρος ποσού ανάληψης» περιλαμβάνεται σε αυτό το εύρος, ενώ το ποσό στο πεδίο «Έως» δεν περιλαμβάνεται στο εύρος.',
    fixedAmountHint:
      'Το ποσό στο πεδίο «Σταθερό ποσό» θα πρέπει να είναι χαμηλότερο ή ίσο με το ποσό που πληκτρολογήθηκε στο πεδίο «Από» στο «Εύρος ποσού ανάληψης». Αν το ποσό «Από» είναι 0, το ποσό του πεδίου «Σταθερό ποσό» θα πρέπει επίσης να είναι 0.',
    fixedAmount: 'Σταθερό ποσό',
    brandSportsBookActivation:
      'Αν ενεργοποιήσετε το προϊόν Sportsbook, θα αποκτήσετε πρόσβαση σε ένα ευρύ περιβάλλον χρήστη με δυνατότητα προσαρμογής με γεγονότα live και pre-match σε πάνω από 65 αθλήματα. Μετά την ενεργοποίησή του, το προϊόν μπορεί να απενεργοποιηθεί μόνο από τον πίνακα διαχειριστή του Sportsbook.',
    amountFrom: 'Ποσό Από',
    allowPlayerCompose: 'Να επιτρέπεται στους παίκτες να «συνθέτουν» μηνύματα',
    sportsBookInheritWebsiteColor: 'Διαδοχή χρώματος ιστότοπου',
    sportsBookInheritWebsiteColorDescription: 'Η ρύθμιση ισχύει σε όλες τις σελίδες αθλητικού στοιχήματος.',
    theBrand: 'Η επωνυμία',
    taxSettings: 'Ρυθμίσεις φόρων',
    infoUrlHint: 'Αυτό το URL θα χρησιμοποιηθεί στον ιστότοπο για την προβολή στοιχείων φορολόγησης.',
    everyMatrixDescription: 'Λύσεις τυχερών παιχνιδιών σπονδυλωτές και με γνώμονα τα API, σχεδιασμένες για να προτείνουν τολμηρές ιδέες',
    smarticoAffiliateDescription: 'Δεν υπάρχει καλύτερος τρόπος για να συνδεθείτε με τους πελάτες σας',
    hotjarDescription: 'Κατανοήστε πώς βιώνουν πραγματικά οι χρήστες τον ιστότοπό σας χωρίς να «πνίγεστε» σε αριθμούς',
    hotjarId: 'Αναγνωριστικό HotJar',
    googleAnalyticsId: 'Αναγνωριστικό Google Analytics',
    googleAnalyticsDescription: 'Αναλύει την χρήση στους ιστότοπούς σας',
    googleSiteVerificationCode: 'Κωδικός επαλήθευσης ιστότοπου Google',
    googleSearchConsoleDescription: 'Λάβετε βοήθεια για την παρακολούθηση, συντήρηση και επίλυση προβλημάτων σχετικά με την παρουσία του ιστότοπού σας σε αποτελέσματα αναζήτησης στο Google.',
    copyPasteFieldName: 'Αντιγράψτε το {{fieldName}} και επικολλήστε το στο παρακάτω πεδίο.',
    learnMore: 'Μάθετε περισσότερα',
    affiliateInfo: 'Δεν μπορούν να είναι ενεργές {{count}} ενσωματώσεις ταυτόχρονα',
    liveChatDescription: 'Διαδικτυακή εφαρμογή επικοινωνίας που επιτρέπει σε σας και στους επισκέπτες του ιστότοπού σας να συνομιλείτε σε πραγματικό χρόνο',
    liveAgentDescription: 'Παρέχετε άριστη εξυπηρέτηση πελατών',
    intercomDescription: 'Ξεκινήστε εδώ μια εξαιρετική σχέση με τον πελάτη',
    zendeskDescription: 'Επικοινωνήστε με τους πελάτες πιο αποτελεσματικά',
    intercomId: 'Αναγνωριστικό Intercom',
    zendeskId: 'Αναγνωριστικό Zendesk',
    liveChatLicenseNumber: 'ΑΡΙΘΜΟΣ ΑΔΕΙΑΣ Live συνομιλίας',
    liveAgentYourLa: 'Live πράκτορας YOUR-LA',
    liveAgentButtonID: 'Αναγνωριστικό κουμπιού Live πράκτορας',
    digitainAgIdInfo: 'Αυτό είναι το αναγνωριστικό της επωνυμίας στον πίνακα διαχειριστή «Πράκτορα Digitain»',
    depositCurrencyInfo:
      'Σε περίπτωση που επιτρέπεται στους παίκτες να κάνουν καταθέσεις με όλα τα νομίσματα που υποστηρίζονται από τις μεθόδους πληρωμής, η επιλογή «Να επιτρέπεται η μετατροπή» με τις υποστηριζόμενες διαμορφώσεις νομίσματος θα πρέπει να είναι ενεργή για τη μέθοδο πληρωμής.',
    pageGroups: 'Ομάδες σελίδας',
    digitainRetailInfo: 'Αυτό είναι το αναγνωριστικό της επωνυμίας στον πίνακα διαχειριστή «Digitain Retail»',
    smarticoDescription: 'Η λύση gamification που χρησιμοποιεί προκλήσεις και τεχνικές παιχνιδιών για να δίνει κίνητρο στους παίκτες',
    smarticoLabelKey: 'Κλειδί μάρκας',
    brandKey: 'Κλειδί επωνυμίας',
    smarticoBrandKeyInfo: 'Ένα δημόσιο κλειδί για την επωνυμία',
    smarticoLabelKeyInfo: 'Ένα δημόσιο κλειδί για τη μάρκα',
    smarticoNote: 'Το Smartico CRM και το Gamification είναι διασυνδεδεμένα, κάθε ενέργεια σε αυτή την ενότητα επηρεάζει επίσης και το Gamification',
    realityCheckPeriod: 'Περίοδος Reality Check',
    prematchTopMatches: 'Prematch κορυφαίοι αγώνες',
    prematchTotalTopMatches: 'Prematch κορυφαίοι αγώνες (περιλαμβάνει τη συνολική αγορά)',
    spotsBookPrematchTotalTopMatchesDescription: 'Όταν είναι ενεργοποιημένο το γραφικό στοιχείο Prematch κορυφαίοι αγώνες, τα Δεδομένα συνολικής αγοράς γίνονται διαθέσιμα',
    livePrematchTopMatches: 'Live & Prematch κορυφαίοι αγώνες',
    spotsBookLivePrematchTopMatchesDescription: 'Όταν είναι ενεργοποιημένο, γίνεται διαθέσιμο το γραφικό στοιχείο Live & Prematch κορυφαίοι αγώνες',
    liveTopMatches: 'Live κορυφαίοι αγώνες',
    spotsBookLiveTopMatchesDescription: 'Όταν είναι ενεργοποιημένο, γίνεται διαθέσιμο το γραφικό στοιχείο Live κορυφαίοι αγώνες',
    periodCalculationSource: 'Πηγή υπολογισμού περιόδου',
    periodCalculationSourceInfo: 'Επιλέξτε την πηγή της ημερομηνίας στην οποία θα ξεκινήσει ο υπολογισμός της περιόδου επαλήθευσης',
    verificationPeriod: 'Περίοδος επαλήθευσης',
    verificationPeriodInfo: 'Ο αριθμός των ημερών που μπορεί να είναι ενεργός ένας λογαριασμός παίκτη πριν να γίνει επαλήθευση',
    responsibleGamingPeriodLimitsInfo: 'Σε αυτή την ενότητα μπορείτε να ρυθμίσετε συγκεκριμένη χρονική περίοδο κατά την οποία ο παίκτης μπορεί να επιλέξει προσωρινή διακοπή ή αυτοαποκλεισμό.',
    preferencesDescription: 'Ενεργοποίηση/απενεργοποίηση ειδοποιήσεων SMS και email για παίκτες.',
    preferencesSMSDescription: 'Το κομμάτι αποστολής SMS για όλους τους παίκτες της επωνυμίας και στον ιστότοπο μέσω SMS θα πρέπει να γίνει αόρατο',
    preferencesEmailDescription: 'Το κομμάτι αποστολής email για όλους τους παίκτες της επωνυμίας και στον ιστότοπο μέσω email θα πρέπει να γίνει αόρατο',
    walletsSettings: 'Ρυθμίσεις πορτοφολιών',
    wallets: 'Πορτοφόλια',
    features: 'Λειτουργίες',
    dda: 'DDA',
    ddaInfo: 'Αν ενεργοποιήσετε αυτή την επιλογή, οι φόροι επί της ανάληψης θα παρακρατηθούν στο DDA logic',
    whatsAppDescription: 'Επιτρέψτε στους πελάτες σας να επικοινωνούν μαζί σας με το πιο δημοφιλές σύστημα ανταλλαγής μηνυμάτων στον κόσμο.',
    phoneNumber: 'Αριθμός τηλεφώνου',
    whatsAppPhoneNumberInfo: 'Πληκτρολογήστε τον αριθμό τηλεφώνου με τον οποίον είναι εγγεγραμμένος ο λογαριασμός σας στο WhatsApp',
    multiGameLaunch: 'Έναρξη πολλαπλών παιχνιδιών',
    multiGameLaunchDescription: 'Ανάλογα με τη διαμόρφωση, η επιλογή πολλαπλών παιχνιδιών είναι διαθέσιμη στον ιστότοπο και οι παίκτες μπορούν να παίζουν πολλά παιχνίδια ταυτόχρονα.',
    jackpotWidget: 'Γραφικό στοιχείο τζάκποτ',
    jackpotWidgetDescription: 'Αναφέρεται στην ενεργοποίηση του γραφικού στοιχείου Τζάκποτ καζίνο για τη Σελίδα προορισμού. Διαθέσιμο στο γραφικό στοιχείο Τζάκποτ του παρόχου Amusnet.',
    gameIframe: 'Iframe παιχνιδιού',
    manuBarFixation: 'Σταθεροποίηση Κύριας μπάρας',
    manuBarFixationDescription: 'Μόνο για την προβολή για κινητά, ανάλογα με τη διαμόρφωση της Κύριας μπάρας για τα λόμπι.',
    paymentVisibilityInfo: 'Σε αυτή την ενότητα μπορείτε να κάνετε απόκρυψη και να μην επιτρέπετε τη χρήση μεθόδου πληρωμής για παίκτες που έχουν μία από τις επιλεγμένες ετικέτες',
    centrivoConnectAgDescription: 'Μεταμορφώστε την επιχείριση τυχερών παιχνιδιών σας με την Connect Agent Solution της Centrivo',
    retailCentrivoDescription: 'Μεταμορφώστε την επιχείριση τυχερών παιχνιδιών σας με τη Retail Solution της Centrivo',
    currencySymbol: 'Σύμβολο νομίσματος',
    timeOut: 'Προσωρινή διακοπή',
    inactivityIndicators: 'Δείκτες αδράνειας',
    inactivityIndicatorsInfo:
      'Με αυτή τη διαμόρφωση, ένας παίκτης θεωρείται ανενεργός με βάση έναν από τους διάφορους δείκτες, την ημερομηνία τελευταίας σύνδεσης του παίκτη ή την ημερομηνία των τελευταίων συναλλαγών (στοίχημα, κατάθεση, ανάληψη)',
    recoverByPlayer: 'Επαναφορά από παίκτη',
    recoverByPlayerInfo: 'Όταν ενεργοποιηθεί, οι παίκτες μπορούν να κάνουν επαναφορά της κατάστασής τους μέσω του κωδικού επαλήθευσης',
    setMainDomain: 'Ορισμός βασικού τομέα',
    disconnected: 'Αποσυνδέθηκε',
    unverifiedPlayersExclusionsInfo:
      'Στις περιπτώσεις που μια μέθοδος πληρωμής έχει επιλεγεί στο μενού «Πληρωμές που αγνοούν την επαλήθευση κατάθεσης» και έχουν οριστεί όρια στο τμήμα «Μέγιστα ποσά κατάθεσης», τα όρια δεν θα επηρεάσουν τη συγκεκριμένη μέθοδο πληρωμής.',
    preferencesPushNotificationsDescription: 'Το κανάλι των ειδοποιήσεων push θα γίνει διαθέσιμο για την αποστολή ειδοποιήσεων για την επωνυμία',
    currencyFormat: 'Μορφή νομίσματος',
    currencyFormatInfo: 'Ποια μορφή νομίσματος να εμφανίζεται στον ιστότοπο για τους παίκτες.',
    isoCode: 'Κωδικός ISO',
    symbols: 'Σύμβολα',
    digitainCrmDescription: 'Λύση CRM σχεδιασμένη για τη διατήρηση της δέσμευσης των υφιστάμενων παικτών και τη βελτίωση της συνολικής ικανοποίησής τους',
    accessDecreaseLimit: 'Όριο πρόσβασης',
    depositOnNegativeBalance: 'Κατάθεση σε αρνητικό υπόλοιπο',
    depositOnNegativeBalanceInfo: 'Μετά την έγκριση της κατάθεσης, θα γίνει προσαρμογή στο αρνητικό υπόλοιπο του πορτοφολιού του παίκτη για το κλείσιμο της οφειλής.',
    digitainAffiliateDescription: 'Ενεργοποιήστε το πρόγραμμα συνεργατών και δείτε σημαντική αύξηση της επισκεψιμότητας στον ιστότοπό σας.',
    projectId: 'Αναγνωριστικό έργου',
    projectIdInfo: 'Αυτό είναι το αναγνωριστικό του έργου στον πίνακα διαχειριστή «Συνεργάτες Digitain»',
    brandIdInfo: 'Αυτό είναι το αναγνωριστικό της επωνυμίας στον πίνακα διαχειριστή «Συνεργάτες Digitain»',
    maintenanceSetup: 'Ρύθμιση συντήρησης',
    maintenancePeriod: 'Περίοδος συντήρησης',
    sportsBookViews: 'Προβολές Sportsbook',
    mandatoryNotification: 'Υποχρεωτική ειδοποίηση',
    mandatoryNotificationInfo: 'Ένα υποχρεωτικό αναδυόμενο παράθυρο για τους συνδεδεμένους παίκτες στον ιστότοπο',
    lossDecreaseLimit: 'Όριο απωλειών',
    singleBetDecreaseLimit: 'Όριο μονών στοιχημάτων',
    cashierType: 'Τύπος ταμείου',
    lIcon: 'εικονίδιο',
    gameLaunchType: 'Τύπος εκκίνησης παιχνιδιού (προβολή για κινητά)',
    gameFullScreenLaunchDescription: 'Τα παιχνίδια ανοίγουν με iframe σε πλήρη οθόνη',
    gameHeaderFooterLaunchDescription: 'Τα παιχνίδια ανοίγουν με iframe και κεφαλίδα και υποσέλιδο',
    gameQuickActionBarLaunchDescription: 'Τα παιχνίδια ανοίγουν με γραμμή γρήγορων ενεργειών',
    limitEffectConfigs: 'Περιορισμός διαμορφώσεων εφέ',
    ignoreFirstDeposit: 'Μη υπολογισμός πρώτης κατάθεσης',
    ignoreFirstDepositHint: 'Εάν γίνει αυτή η επιλογή, η πρώτη επιτυχημένη κατάθεση του παίκτη δεν θα υπολογιστεί στο όριο καταθέσεων υπεύθυνου παιχνιδιού',
    periodLimit: 'Όριο περιόδου',
    playerLimitsConfiguration: 'Διαμόρφωση ορίων παίκτη',
    alanbaseDescription:
      'Μια πλατφόρμα που σας προσφέρεται από ειδικούς στο iGaming και στο μάρκετινγκ συνεργατών που βοηθά άλλους ειδικούς να βελτιστοποιήσουν το κόστος τους και να αυξήσουν τα κέρδη τους.',
    routForEvents: 'Διαδρομή για γεγονότα',
    routForGoals: 'Διαδρομή για γκολ',
    fastDepositPaymentMethod: 'Μέθοδος πληρωμής γρήγορης κατάθεσης',
    fastDepositPaymentMethodInfo:
      'Η Γρήγορη κατάθεση είναι μια λειτουργία στον ιστότοπο μέσω της οποίας οι παίκτες μπορούν να κάνουν κατάθεση, χωρίς να εγκαταλείψουν τη σελίδα του παιχνιδιού, με τη μέθοδο πληρωμής που έχει προκαθοριστεί από την πλατφόρμα «Centrivo».',
    sportStatusIconsInfo: 'Τα μεταφορτωμένα εικονίδια θα είναι ορατά στο προφίλ του παίκτη στον ιστότοπο. Κάθε μεταφορτωμένο εικονίδιο θα εμφανίζεται στον ιστότοπο το αργότερο μετά από μία ώρα.',
    rolloverBetsReturn: 'Τα στοιχήματα από το υπόλοιπο για κάλυψη απαιτήσεων στοιχηματισμού επιστρέφουν στο ίδιο πορτοφόλι',
    rolloverBetsReturnInfo:
      'Σε περιπτώσεις επιστροφής/ακύρωσης του στοιχήματος που τοποθετήθηκε από το υπόλοιπο για κάλυψη απαιτήσεων στοιχηματισμού, το ποσό θα μεταφέρεται στο υπόλοιπο για κάλυψη απαιτήσεων στοιχηματισμού',
    maxDepositAmounts: 'Μέγ. ποσά κατάθεσης',
    paymentsIgnoringDepositVerification: 'Πληρωμές που αγνοούν την επαλήθευση κατάθεσης',
    selfExclusion: 'Αυτοαποκλεισμός',
    configureLimits: 'Ρύθμιση ορίων',
    metaMapDesc: 'Όλα όσα χρειάζεστε για να επαληθεύετε τους πελάτες σας σε μία μόνο πλατφόρμα',
    clientId: 'Αναγνωριστικό πελάτη',
    clientIdInfo: 'Χρησιμοποιείται για να σας αναγνωρίσουν ως έμπορο.',
    clientSecret: 'Μυστικό πελάτη',
    clientSecretInfo: 'Χρησιμοποιήστε το μυστικό του πελάτη που πήρατε από τον Πίνακα ελέγχου ως τον κωδικό πρόσβασής σας.',
    pushGameState: 'Προώθηση κατάστασης παιχνιδιού',
    pushGameStateDescription: 'Αυτή η ρύθμιση ορίζει την κατάσταση των παιχνιδιών («Κατάσταση Παιχνιδιού») που στέλνει ο σωρευτής στο Back Office.',
    thunderBiteDescription: 'Κάντε παιχνίδι την εμπειρία των πελατών και μετατρέψτε τη συμμετοχή σε αφοσίωση.',
    campaignURL: 'URL καμπάνιας',
    captchaCaseInsensitiveInfo: 'Αν ενεργοποιήσετε την επιλογή για captca, το σύστημα δεν κάνει τον διαχωρισμό μεταξύ κεφαλαίων και πεζών γραμμάτων, τα οποία θεωρούνται ίδια.',
    caseInsensitive: 'Χωρίς διάκριση πεζών-κεφαλαίων',
    verificationRequestPeriod: 'Περίοδος αιτηματος επαλήθευσης SMS/email',
    verificationRequestPeriodInfo: 'Η διαμόρφωση ορίζει ότι θα αποσταλεί στον παίκτη το επόμενο αίτημα επαλήθευσης μέσω SMS/email.',
    sec: 'δευτερόλεπτο',
    integratedDate: 'Ημερομηνία ενσωμάτωσης',
    integratedBy: 'Η ενσωμάτωση έγινε από',
    isInvisible: 'Είναι αόρατο',
    captchaInvisibleInfo: 'Αν γίνει έλεγχος, το captcha δεν θα είναι ορατό στους παίκτες',
    captchaLogonAttemptsInfo: 'Ορίζει τον αριθμό των αποτυχημένων προσπαθειών σύνδεσης, την περίοδο που θα προσμετρώνται οι προσπάθειες αυτές και τη διάρκεια για την οποία θα εμφανίζεται το CAPTCHA.',
    jackpot: 'Τζάκποτ',
    globalState: 'Γενική κατάσταση',
    jackpotGames: 'Παιχνίδια τζάκποτ',
    myAffiliatesDescription: 'Το πιο ευέλικτο λογισμικό παρακολούθησης συνεργατών στην αγορά',
    sportDomainsTabInfo: 'Ο μέγιστος αριθμός αθλητικών τομέων είναι {{count}}. Μόνο ενεργεί τομείς μπορούν να οριστούν ως Κεντρικοί. Μόνο επαληθευμένοι τομείς μπορούν να συνδεθούν.',
    firebaseAuthenticationDescription: 'Ρύθμιση για πλατφόρμες μέσων κοινωνικής δικτύωσης για δημιουργία λογαριασμού και για επαλήθευση σύνδεσης με το Firebase.',
    frontend: 'Frontend',
    backend: 'Backend',
    google: 'Google',
    facebook: 'Facebook',
    socialMediaPlatforms: 'Πλατφόρμες μέσων κοινωνικής δικτύωσης',
    optimoveDescription: 'Λύση CRM σχεδιασμένη για να διατηρεί τη δέσμευση των υφιστάμενων παικτών και να βελτιώνει τη συνολική ικανοποίησή τους.',
    baseUrl: 'Βασικό URL',
    forcePasswordChangeNote:
      'Αν ενεργοποιήσουν αυτήν την επιλογή, οι παίκτες πρέπει να αλλάζουν κωδικό πρόσβασης αν παρέλθει η καθορισμένη περίοδος.\nΌταν η περίοδος Υπενθύμισης Κωδικού Πρόσβασης παρέλθει, οι παίκτες δεν μπορούν να συνδεθούν στον ιστότοπο χωρίς να αλλάξουν τον κωδικό πρόσβασής τους αν η επιλογή είναι ενεργοποιημένη.',
    forcePasswordChange: 'Αναγκαστική αλλαγή κωδικού πρόσβασης',
    playerTags: 'Ετικέτες παικτών',
    additional: 'Πρόσθετα',
    gameTimeLimit: 'Όριο χρόνου παιχνιδιού',
    verificationOptions: 'Επιλογές επαλήθευσης',
    blockActions: 'Ενέργειες αποκλεισμού',
    userNotification: 'Ειδοποίηση χρήστη',
    winAmounts: 'Ποσά κέρδους',
    largeWinTransactionNotification:
      'Η ειδοποίηση συναλλαγής Μεγάλου Κέρδους θα αποστέλλεται μόνο σε επιλεγμένους χρήστες. Βεβαιωθείτε ότι το Ποσό κέρδους έχει ρυθμιστεί για όλα τα νομίσματα σε περίπτωση που επιλεγούν χρήστες.',
    promptOnLogin: 'Επιλογή όταν γίνεται σύνδεση',
    promptOnLoginInfo: 'Με αυτήν την επιλογή, οι παίκτες θα πρέπει να ορίζου τα όριά τους κατά τη διάρκεια της πρώτης τους σύνδεσης',
    productCategory: 'Κατηγορία προϊόντος',
    betProfitRange: 'Εύρος κέρδους από στοιχήματα (Από - Έως)',
    betProfitRangeHint: 'Το ποσό στο πεδίο «Από» στο «Εύρος κέρδους από στοιχήματα» περιλαμβάνεται σε αυτό το εύρος, ενώ το ποσό στο πεδίο «Έως» δεν περιλαμβάνεται στο εύρος.',
    betTaxInfo: 'Μία «Κατηγορία Προϊόντος» μπορεί να ανατεθεί είτε στον τύπο φορολόγησης «Σωρευτικό» ή «Ανά συναλλαγή», με βάση της προτιμώμενη μέθοδο υπολογισμού του φόρου.',
    betTaxStandardDisabledInfo: 'Ενεργοποιήστε τη «Φορολόγηση» και τον «Φόρο επί του κέρδους από στοιχήματα» για να ενεργοποιήσετε τη μηχανή φορολόγησης για την επωνυμία σας.',
    depositTaxStandardDisabledInfo: 'Ενεργοποιήστε τη «Φορολόγηση» και τον «Φόρο επί κατάθεσης» για να ενεργοποιήσετε τη μηχανή φορολόγησης για την επωνυμία σας.',
    withdrawalTaxStandardDisabledInfo: 'Ενεργοποιήστε τη «Φορολόγηση» και τον «Φόρο επί ανάληψης» για να ενεργοποιήσετε τη μηχανή φορολόγησης για την επωνυμία σας.',
    registrationUniqueness: 'Μοναδικότητα εγγραφής',
    registrationUniquenessNote: 'Η μοναδικότητα του επιλεγμένου συνδυασμού θα πρέπει να επαληθεύεται κατά την εγγραφή του παίκτη.',
    responsibleGamingLimitsInfo:
      'Σε αυτήν την ενότητα μπορείτε να ορίσετε προκαθορισμένες τιμές που θα συμπληρώνονται αυτόματα ως προεπιλεγμένα όρια κατά τη ρύθμιση, αλλά μπορούν να προσαρμόζονται χειροκίνητα. Η επιλογή κατά τη σύνδεση μπορεί να ενεργοποιηθεί/απενεργοποιηθεί, κάτι που θα κάνει υποχρεωτικό τον ορισμό ορίων από τους παίκτες.',
    hours: '{{number}} ώρες',
    days: '{{number}} ημέρες',
    month: '{{number}} μήνας',
    year: '{{number}} έτος',
    viewDefaultAmount: 'Προβολή προκαθορισμένου ποσού',
    viewDefaultLimit: 'Προβολή προκαθορισμένου ορίου',
    realTimeUniquenessCheck: 'Έλεγχος μοναδικότητας σε πραγματικό χρόνο',
    realTimeUniquenessCheckNote: 'Αν το ενεργοποιήσετε, το σύστημα θα ελέγχει αμέσως αν ο αριθμός κινητού τηλεφώνου, η ταυτότητα και το email είναι μοναδικά, κατά τη διαδικασία εγγραφής.',
    appToken: 'Token εφαρμογής',
    accountVerificationOptions: 'Επιλογές επαλήθευσης λογαριασμού',
    accountVerificationOptionsInfo: 'Επιλέξτε με βάση το ποιος λογαριασμός παίκτη θα θεωρείται επαληθευμένος',
    markAsUnverified: 'Μαρκάρισμα ως μη επαληθευμένος',
    markAsUnverifiedInfo: 'Όταν είναι ενεργοποιημένο, οι παίκτες θα μαρκάρονται ως μη επαληθευμένοι με βάση τους καθορισμένους κανόνες',
    notificationReminder: 'Ειδοποίηση υπενθύμισης',
    notificationReminderInfo: 'Ο αριθμός των ημερών μετά από τις οποίες θα αποσταλεί υπενθύμιση στον παίκτη να επαληθεύσει τον λογαριασμό του',
    blockForUnVerify: 'Αποκλεισμός λόγω έλλειψης επαλήθευσης',
    blockForUnVerifyOptions: 'Επιλογές για αποκλεισμό λόγω έλλειψης επαλήθευσης',
    betOddsLimit: 'Όρια αποδόσεων στοιχήματος',
    betOddsLimitInfo:
      'Σε περιπτώσεις που τοποθετείται στοίχημα με αποδόσεις χαμηλότερες από τις καθορισμένες, το ποσό κέρδους θα διανέμεται αναλογικά στα πορτοφόλια (χρησιμοποιημένα και μη χρησιμοποιημένα) όπου τοποθετήθηκε το στοίχημα',
    selfExclusionReason: 'Λόγος αυτοαποκλεισμού',
    selfExclusionReasonInfo: 'Αν επιλεγεί ο λόγος, οι παίκτες δεν μπορούν να ορίσουν αυτοαποκλεισμό στον λογαριασμό τους επιλέγοντας τους συγκεκριμένους λόγους',
    balanceVisibility: 'Ορατότητα υπολοίπου',
    balanceVisibilityNote: 'Τα επιλεγμένα υπόλοιπα θα είναι ορατά στους παίκτες της επωνυμίας',
    configured: 'Διαμορφώθηκαν',
    limitEffectPeriodInfo:
      'Οι αλλαγές τίθενται σε ισχύ είτε μετά από καθορισμένο χρονικό διάστημα (αμέσως, 24 ώρες, 48 ώρες ή 7 ημέρες) είτε στην αρχή της επόμενης ημερολογιακής περιόδου — μεσάνυχτα για ημερήσια όρια, Δευτέρα για εβδομαδιαία όρια ή την 1η του μήνα για μηνιαία όρια.',
    documentsConfig: 'Διαμόρφωση εγγράφων',
    documentsConfigInfo: 'Οι παρακάτω τύπου εγγράφων είναι υποχρεωτικοί, ο αριθμός σελίδας είναι πάντα 1',
    pageCount: 'Αριθμός σελίδας',
    realityCheckSettings: 'Ρυθμίσεις Reality Check',
    calculationType: 'Τύπος υπολογισμού',
    realityCheckInterval: 'Διάλειμμα Reality Check',
    showLogOutButton: 'Εμφάνιση κουμπιού αποσύνδεσης',
    realityCheckSettingsInfo: 'Οι ρυθμίσεις θα ισχύουν μόνο αν το Reality Check είναι ενεργοποιημένο στην ενότητα Πρότυπα',
    realityCheckStatus: 'Κατάσταση Reality Check',
    realityCheckPeriodInfo: 'Οι περίοδοι αυτοί θα εμφανίζονται στον λογαριασμό παίκτη στον ιστότοπο',
    realityCheckIntervalInfo: 'Ορίζει τον χρόνο του διαλείμματος ανάμεσα στα αναδυόμενα παράθυρα Reality Check που θα εμφανίζονται στους παίκτες',
    capitalizePlayerData: 'Κεφαλαία γράμματα δεδομένων παίκτη',
    capitalizePlayerDataInfo: 'Αν ενεργοποιηθεί, το σύστημα θα αλλάζει σε κεφαλαία γράμματα τα πεδία Όνομα, Επώνυμο και Πόλη στη διαδικασία εγγραφής και θα τα αποθηκεύει στο backoffice',
    blockedCountriesInfo:
      'Η ενέργεια (κατάργηση αποκλεισμού, πλήρης αποκλεισμός, αποκλεισμός σύνδεσης, αποκλεισμός εγγραφής, αποκλεισμός σύνδεσης και εγγραφής) μπορούν να εφαρμόζονται ξεχωριστά ανά χώρα ή μαζικά, ενημερώνοντας την κατάστασή τους αμέσως.',
    bulkAction: 'Μαζική ενέργεια',
    calendarPeriod: 'Περίοδος ημερολογίου',
    multiPeriodLimitType: 'Τύπος ορίου πολλαπλών περιόδων',
    singlePeriodLimitType: 'Τύπος ορίου μίας περιόδου',
    changeEffectPeriods: 'Αλλαγή περιόδου ισχύος',
    lastMonthPeriod: 'Προηγούμενος μήνας',
    eddVerificationNotification: 'Οι διαμορφώσεις EDD θα ενεργοποιήσουν την επαλήθευση πηγής χρημάτων για τους Πιστοποιημένους Παίκτες',
    totalDepositAmount: 'Συνολικό ποσό κατάθεσης',
    brandBonusesInfo:
      'Αυτή η ενότητα επιτρέπει στους χρήστες να ρυθμίζουν τη λογική ενεργοποίησης των μπόνους για το brand με βάση συγκεκριμένες προϋποθέσεις. Αν κάποια προϋπόθεση δεν πληρούται, το μπόνους δεν θα ενεργοποιηθεί.',
    firstSuccessfulDeposit: 'Πρώτη επιτυχής κατάθεση',
    firstSuccessfulDepositDesc: 'Οι παίκτες πρέπει να έχουν τουλάχιστον μία επιτυχημένη κατάθεση για να είναι επιλέξιμοι να ενεργοποιήσουν τα μπόνους.',
    sportStatusDesc: 'Οι απαιτήσεις ενεργοποίησης δεν πληρούνται. Παρακαλώ επικοινωνήστε με τον χειριστή.',
    standardTaxModelInfo: 'Υπολογίζει τον φόρο στην κατάθεση που πραγματοποιήθηκε, εφαρμόζοντας το ποσοστό φόρου που αναφέρεται στο συνολικό ποσό.',
    vatTaxModelInfo: 'Υπολογίζει τον φόρο στην κατάθεση που πραγματοποιήθηκε, εφαρμόζοντας το ποσοστό ΦΠΑ σύμφωνα με τον τύπο ΦΠΑ. Το συνολικό ποσό της κατάθεσης περιλαμβάνει ΦΠΑ.',
    setVatAmountRangesInfo: 'Το σύστημα διαχωρίζει αυτόματα το ποσό του ΦΠΑ από το σύνολο για να υπολογίσει την πραγματική αξία της κατάθεσης.',
    multiBetOfTheDay: 'Πολλαπλό ποντάρισμα της ημέρας',
    sportSuperPromotion: 'Σούπερ προσφορές',
    schemaMarkupImage: 'Εικόνα σήμανσης με σχήμα',
    dataSendPeriod: 'Περίοδος αποστολής δεδομένων',
    demoLaunchDesktop: 'Έναρξη δοκιμαστικής έκδοσης (για υπολογιστές)',
    demoLaunchMobile: 'Έναρξη δοκιμαστικής έκδοσης (για κινητά)',
    demoLaunchDesktopDescription:
      'Ανάλογα με τη ρύθμιση, το κουμπί δοκιμαστικής έκδοσης είναι διαθέσιμο στα παιχνίδια και οι παίκτες μπορούν να ξεκινήσουν τη δοκιμαστική έκδοση του παιχνιδιού στην προβολή για υπολογιστές.',
    demoLaunchMobileDescription:
      'Ανάλογα με τη ρύθμιση, το κουμπί δοκιμαστικής έκδοσης είναι διαθέσιμο στα παιχνίδια και οι παίκτες μπορούν να ξεκινήσουν τη δοκιμαστική έκδοση του παιχνιδιού στην προβολή για κινητά.',
    androidSettings: 'Ρυθμίσεις για Android',
    iosSettings: 'Ρυθμίσεις για iOS',
    googleCloudProjectId: 'Αναγνωριστικό έργου Google Cloud',
    mobileReCaptcha: 'reCAPTCHA για κινητά',
    androidReCaptchaKey: 'Κλειδί reCAPTCHA για Android',
    androidKeyId: 'Αναγνωριστικό κλειδιού Android',
    iosReCaptchaKey: 'Κλειδί reCAPTCHA για iOS',
    iosKeyId: 'Αναγνωριστικό κλειδιού iOS',
    playerApproval: 'Έγκριση παίκτη',
    playerApprovalInfo: 'Απαιτείται επιβεβαίωση από τον παίκτη πριν από την εφαρμογή του νέου, χαμηλότερου ορίου μετά τη λήξη της περιόδου ισχύος της αλλαγής',
    transactionTypeNote: 'Οι επιλεγμένοι τύποι θα εμφανίζονται στους παίκτες της μάρκας στο Ταμείο του ιστότοπου.',
    domainDeletion: 'Διαγραφή τομέα',
    incomeAccessDescription: 'Γίνετε μέλος του παλαιότερου δικτύου μάρκετινγκ θυγατρικών στον τομέα του iGaming',
    suggestedAmounts: 'Προτεινόμενα ποσά',
    defaultAmount: 'Προεπιλεγμένο ποσό',
    viewLimits: 'Προβολή ορίων',
    configureAmounts: 'Ρύθμιση ποσών',
    suggested: 'Προτεινόμενα',
    otherTypeDocumentConfigInfo:
      'Για όλους τους τύπους εκτός από <0>Άλλο</0>, απαιτείται ο επιλεγμένος αριθμός αρχείων. Για την επιλογή <0>Άλλο</0>, ο αριθμός που επιλέξατε είναι ο μέγιστος επιτρεπόμενος. Επιτρέπονται λιγότερα αρχεία.',
    uploadReCaptchaInfo: 'Μπορείτε να ανεβάσετε ένα έγκυρο αρχείο JSON για τη διαμόρφωση του ReCaptcha',
    androidPrivateKey: 'Ιδιωτικό κλειδί για Android',
    iosPrivateKey: 'Ιδιωτικό κλειδί για iOS',
    indefiniteTimePeriod: 'Αόριστη χρονική περίοδος',
    sportMinBetAge: 'Όριο ηλικίας για πονταρίσματα σε αθλήματα',
    casinoMinBetAge: 'Όριο ηλικίας για πονταρίσματα σε καζίνο',
    zingBrainDesc: 'Το ZingBrain είναι μια πλατφόρμα βελτίωσης της απόδοσης που ενσωματώνεται εύκολα στον κλάδο του iGaming.',
    awsCloudDescription: 'Ρυθμίστε το AWS ώστε να επιτρέπει την αποστολή δεδομένων.',
    zingBrandDescription: 'Ενσωματώστε το ZingBrain για να ενεργοποιήσετε τη διαμόρφωση προτάσεων περιεχομένου στο λόμπι με τη βοήθεια τεχνητής νοημοσύνης.',
    regionName: 'Όνομα περιοχής',
    endpointUrl: 'Διεύθυνση URL τελικού σημείου',
    accessKeyId: 'Αναγνωριστικό κλειδιού πρόσβασης',
    secretAccessKey: 'Μυστικό κλειδί πρόσβασης',
    bucketName: 'Όνομα κάδου',
    apiUserName: 'Όνομα χρήστη API',
    apiPassword: 'Κωδικός πρόσβασης API',
    zingBrandId: 'Αναγνωριστικό ZingBrand',
    configuredDate: 'Ημερομηνία ρύθμισης',
    configuredBy: 'Διαμόρφωση από',
    standardTaxModel: 'Τυποποιημένο φορολογικό μοντέλο',
    loyaltyProgram: 'Πρόγραμμα αφοσίωσης',
    activationMinimumAmount: 'Ελάχιστο ποσό ενεργοποίησης',
    activationMinimumAmountDesc: 'Οι παίκτες πρέπει να έχουν τουλάχιστον το αναφερόμενο ποσό στο πορτοφόλι τους για να μπορούν να ενεργοποιήσουν το μπόνους',
    authentigateDescription:
      'Το Authentigate είναι η ολοκληρωμένη λύση για την πιο διαδεδομένη μέθοδο πιστοποίησης μέσω ηλεκτρονικής ταυτοποίησης (eID) στις χώρες της Βαλτικής. Συνδέστε τις υπηρεσίες Smart-ID, Mobile-ID, eParaksts mobile και την εσθονική ταυτότητα μέσω μιας ασφαλούς πύλης.',
    betStatusCorrectionsNotification: 'Καθορισμός ορίων και απαιτήσεων επιβεβαίωσης για τους χειριστές, που τους επιτρέπουν να εγκρίνουν ή να ακυρώσουν την ενέργεια που υπερβαίνει το όριο',
    trustlyDescription:
      'Το Trustly Pay and Play προσφέρει στους παίκτες μια γρήγορη και απρόσκοπτη διαδικασία εγγραφής που συνδυάζει την κατάθεση χρημάτων, την επαλήθευση ταυτότητας χρήστη και τη δημιουργία λογαριασμού.',
    trustlyNote: 'Πρέπει πρώτα να ρυθμίσετε τη λειτουργία Pay and Play στη σελίδα Paydrom πριν ενεργοποιήσετε αυτήν την επιλογή.',
    relumActivation:
      'Ενεργοποιώντας το προϊόν Relum, αποκτάτε πρόσβαση σε πολλά παιχνίδια από διάφορους κορυφαίους παρόχους παιχνιδιών, κάτι που σας επιτρέπει να δημιουργήσετε μια εξατομικευμένη εμπειρία παιχνιδιού για τους παίκτες σας.',
    sportsBookActivation:
      'Με την ενεργοποίηση του προϊόντος Sportsbook,'
      + ' θα αποκτήσετε πρόσβαση σε ένα ολοκληρωμένο, πολυγλωσσικό και πολυνομισματικό περιβάλλον εργασίας που μπορεί να προσαρμοστεί στις ανάγκες σας, με παιχνίδια ζωντανά και πριν από τον αγώνα για διάφορα αθλήματα, καθώς και πρωταθλήματα από όλο τον κόσμο και τεράστιο αριθμό αγορών στοιχημάτων.',
    domain: 'Τομέας',
    whiteIps: 'Λευκές διευθύνσεις IP',
    betStatusCorrections: 'Διορθώσεις κατάστασης πονταρίσματος',
    autoDeposit: 'Αυτόματη κατάθεση',
  },
};
